import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SglContext from '../SglContext'
import ReactModal from "react-modal";

import $ from 'jquery';
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";

import "./entries.css";

import ManageCards from "../common/ManageCards";
import AddBankModal from "../common/AddBankModal";

// IMPORT IMAGES
import warning_red from "../images/warning_red.gif";
import indicator_icon from "../images/Indicator.gif";
import red_dot from "../images/red-dot.png";
import green_dot from "../images/green-dot.png";
import search_icon from "../images/loupe.png";
import delete_image from "../images/trash.png";
import visa_image from "../images/paymentlogos/visa.png";
import mastercard_image from "../images/paymentlogos/mastercard.png";
import discover_image from "../images/paymentlogos/discover.png";
import americanexpress_image from "../images/paymentlogos/americanexpress.png";

//API END POINTS
// const sgl_webservice_iphone = process.env.REACT_APP_SGL_API+'/iphonev2/addentryv2/';
// const user_info_url = process.env.REACT_APP_NEST_API +'/users/getLoggedInUser';
// const sgl_webservice_checkout = process.env.REACT_APP_SGL_API+'/iphonev2/checkoutv2/';
var AddModal = ReactModal;

//Set Genders Array
const horse_genders_array = ["Gelding", "Mare", "Stallion"];

//Set Genders Array
const horse_greens_array = ["First Year", "Second Year"];

//Set Types Array
const horse_types_array = ["Small", "Small Junior", "Medium", "Large", "Large Junior"];

const membership_organizations = ['EC', 'FEI', 'USEF', 'USHJA'];
const associated_membership_organizations = ['USHJA'];


const countries_array = [
  'United States',
  'Canada',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Saint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'C?te d\'Ivoire',
  'Croatia',
  'Cuba',
  'Cura?ao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'R?union',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barth?lemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

const new_horse_data_initial = {
  horse_id: -10,
  name:'',
  sex:'',
  color: '', 
  age:'',
  height: '',
  green: '',
  type:'',
  memberships:[]
};

const new_person_data_initial = {
  people_id: -10,
  isfarmrto: false,
  company_name: '',
  first:'',
  last_name:'',
  lf_name:'',
  fl_name:'',
  address: '', 
  city:'',
  state: '',
  postal_code: '',
  country:'',
  email_address: '',
  mobile_phone: '',
  phonenumber: '',
  memberships:[],
  is_created: false
};


class DigiSignPhone extends React.Component{
    state = {
        people_id: '',
        phoneNumber: '',
        status: true,
        // mobile_phone: {
        //     isValid: false,
        //     rawValue: null,
        //     countryData: null,
        //     formattedValue: "",
        //     extension: null,
        //   }
    }

  componentDidMount() {
    // var phone_component = window.intlTelInput(this.el, {
    //   dropdownContainer: document.body,
    //   formatOnDisplay: true,
    //   nationalMode: true,
    //   placeholderNumberType: "MOBILE",
    //   preferredCountries: ['us', 'ca'],
    //   initialCountry: 'us',
    //   utilsScript: "https://showgroundslive.com/js/utils.js",
    // });

    var people_id = this.props.people_id;
    // let phone_component = window.iti;

    this.setState({people_id: people_id, index: this.props.index});
    //   if(this.state.status) {
    //     document.getElementById('phone_number_' + people_id).value = this.state.phoneNumber;
    //     document.querySelector("#valid_msg_" + people_id).classList.remove('hide');
    //   } else {
    //     document.getElementById('phone_number_' + people_id).value = '';
    //     document.querySelector("#valid_msg_" + people_id).classList.add('hide');
    //   }


  }
  
  componentWillUnmount() {
  }


  handlePhoneChange = (status, phoneNumber, country) => {
    this.setState({ 'phoneNumber': phoneNumber, 'status':status });
    // var phone_number = '+' + phoneNumber.replace(/\D/g, "");


    if(status) {
        document.getElementById('phone_number_' + this.props.people_id).value = phoneNumber;
        document.querySelector("#valid_msg_" + this.props.people_id).classList.remove('hide');
      } else {
        document.querySelector("#valid_msg_" + this.props.people_id).classList.add('hide');
        document.getElementById('phone_number_' + this.props.people_id).value = '';
      }
      this.props.onUpdate(phoneNumber, this.props.index);
  };

  render(){
    return (
      <div style={{display:'inline-block'}}>
        {/* <input
          name={"phone_number_plugin_" + this.props.people_id}
          id={"phone_number_plugin_" + this.props.people_id} 
          ref={el => this.el = el}
          onChange={evt => this.updatePhone(evt.target.value)}
          value={this.props.phonenumber}
        /> */}
        <IntlTelInput
                    style={{
                      width: "100%",
                    }}
                    // allowDropdown={true}
                    // dropdownContainer={document.body}
                    // nationalMode={true}
                    formatOnDisplay={true}
                    // placeholder={"MOBILE"}
                    initialCountry={"us"}
                    // utilsScript={"https://showgroundslive.com/js/utils.js"}
                    preferredCountries={["us", "ca"]}
                    // onPhoneNumberChange={this.handlePhoneNumberChange}
                    onPhoneNumberChange={this.handlePhoneChange}

    
                    // onBlur={handleBlur}
                    // onKeyUp={reset}
                    name={"phone_number_plugin_" + this.props.people_id}
                    id={"phone_number_plugin_" + this.props.people_id} 
                    // ref={el => this.el = el}
                    // onChange={evt => this.updatePhone(evt.target.value)}
                    value={this.props.phonenumber}
                    
                  />
      </div>
    );
  }
}

class AddEntry extends React.Component {
      
    get sgl_webservice_iphone() {
      return this.context.sglApiUrl + '/iphonev2/addentryv2/';
    }

    get user_info_url() {
      return this.context.nestApiUrl + '/users/getLoggedInUser';
    }

    get sgl_webservice_checkout() {
      return this.context.sglApiUrl + '/iphonev2/checkoutv2/';
    }

    state = {
      nextform_urls:[],
      formtype_change_loader: false,
      governing_organization: '',
      person_lookup_organizations: [],
      company_name: '',
      logged_in_people_id: '',
      credit_hold:false,
      refund_policy:'',
      payment_options: {},
      shows_list: [],
      horses_list: [],
      horses_search_list: [],
      people_list: [],
      updated_people_list: [],
      people_search_list:[],
      selected_distinct_people_list:[],
      classes_list: [],
      divisions_list: [],
      divisions_filtered_list: [],
      order_supply_list: [],
      donations_list: [],
      fee_for_entry:{
        class_price_total: 0,
        show_fees_total: 0,
        total_tax: 0,
        show_fees: [],
        class_prices: []
      },
      payment_methods:[],
      can_checkout: true,
      bank_accounts:[],
      check_card_email_phone_info: false,
      check_address_info: false,
      barn_types: [],
      pre_order_datetime: false,

      selected_show: 0,
      selected_show_details: {},
      select_show_error_msg: '',

      selected_horse:{},
      horse_search: 'by_name',
      horse_search_org: 'by_usef',
      horse_search_by_txt_label: 'Enter USEF No.',
      horse_search_by_label: 'by USEF No.',
      horse_search_type: 'by_name',
      horse_search_label_th: 'USEF No.',
      horse_name:'',
      horse_membership_no:'',
      txt_horse_name_disabled:false,
      txt_membership_no_disabled:true,
      new_horse_data: JSON.parse(JSON.stringify(new_horse_data_initial)),
      horse_to_update: {},
      new_horses_count: 0,
      is_editing_horse: false,
      add_horse_error_msg: '',

      notes: '',
      people_search_by_txt_label: 'Enter USEF No.',
      people_search_org:'by_usef',
      people_search_type: 'by_name',
      people_search_label_th: "USEF No.",
      people_search_field: '',
      people_search_field_text: '',
      txt_people_name_disabled:false,
      txt_people_membership_no_disabled:true,
      people_first_name: '',
      people_last_name: '',
      people_membership_no: '',
      add_riders_count: 1,
      selected_search_person: {},
      selected_riders_list: [],
      verified_riders_list:[],
      riders_table_error_msg : '',
      error_riders_list : [],
      selected_rider:{},
      selected_rider2:{},
      selected_rider3:{},
      selected_trainer:{},
      selected_owner:{},
      selected_prize:{},
      selected_responsible:{},
      people_selection_error_msg: '',
      new_person_data: JSON.parse(JSON.stringify(new_person_data_initial)),
      person_to_update: {},
      new_persons_count: 0,
      new_persons_list: [],
      add_people_error_msg: '',
      is_editing_person: false,
      updating_person_field: '',
      selected_guardian:{people_id:0},

      class_rider_id:'-4',
      division_to_add:'-1',
      division_search: '',
      class_to_add:'-1',
      selected_classes:[],
      class_selection_error_msg: '',
      entry_numbers:'',
      class_add_fee:'',
      class_add_fee_each:'',
      class_add_date:'',
      class_add_fee_time:'',
      class_add_fee_amount: '',
      charge_add_fee_on_web: false,

      order_supply_to_add:'-1',
      amount: null,
      order_supply_error_msg: '',
      selected_showfees:[],
      stall_check_in_info: {},
      // stall_check_in_info:{
      //   "stall_collect_checkin_checkout_time":"1",
      //   "days_before_checkin":"2",
      //   "checkin_start_time":"7",
      //   "checkin_end_time":"19",
      //   "first_day_checkin_start_time":"13",
      //   "first_day_checkin_end_time":"19",
      //   "days_after_checkout":"3",
      //   "checkout_start_time":"10",
      //   "checkout_end_time":"20",
      //   "last_day_checkout_start_time":"10",
      //   "last_day_checkout_end_time":"14"
      // },
      stall_checkin_checkout_data: {
        "checkin_date": '',
        "checkin_time": '',
        "checkout_date": '',
        "checkout_time": ''
      },

      review_fees_error_msg: '',
      
      order_delivery_phone_number: '',
      order_delivery_display_phone: '', //used for display only
      order_delivery_barn_location: '',
      order_delivery_stall_location: '',
      order_delivery_arrival_date: '',
      order_delivery_arrival_time: '',
      order_delivery_trainer_name: '',

      series_shows: [],
      series_shows_amount: 0,
      series_shows_service_fee_amount: 0,
      series_shows_ach_service_fee_amount: 0,
      add_to_series_error_msg: '',

      deposit_amount: 0,
      deposit_cvv: "",
      selected_payment_method : '-1',
      selected_deposit_method : '-1',
      deposit_payment_method_type: '',
      selected_payment_method_type: '',
      payment_agree: false,
      payment_error_msg: '',
      payment_A_error_msg: '',
      check_payment_method_info: false,
      acquire_add_entry_tax_info: false,

      digital_sign_people_list: [],
      disallow_agent_signature: false,
      digisign_error_msg: '',
      nextform_error_msg:'',
      create_entry_error_msg: '',

      loading: true,
      switch_allowed: 0,
      switch_company_name: '',
      
      userData: {},
      is_open_horse_modal: false,
      is_open_people_modal: false,
      is_open_select_card_modal: false,
      is_open_add_bank_modal: false,
      is_open_add_card_modal: false,
      formatted_phone_numbers: [],
      deposit_payment_agreement: '',
      securing_entry_agreement: '',
      require_payment_method_agreement: '',
      restrict_junior_riders: false,
      loading_parents: false,
      platform_fee_payment_method: '-1', // payment method that will be used for platform fee payment
      platform_fee_login_id: 0, // RTO whose account will be used for platform fee
      exhibitor_billing_enabled_for_show: false, // flag to check if exhibitor billig is enabled for SMC or not
      currentDefaultPaymentMethod: null,
      processingBillingData: false
    }

    constructor() {
      super();
      this.PaginationElement = React.createRef();
      this.ShowPickerElement = React.createRef();
      // this.onShowChange = this.onShowChange.bind(this);
      // bind function in constructor instead of render
      this.onChangePage = this.onChangePage.bind(this);
    //   this.loadData = this.loadData.bind(this)
      this.openHorseModal = this.openHorseModal.bind(this);
      this.afterOpenModal = this.afterOpenModal.bind(this);
      this.closeHorseModal = this.closeHorseModal.bind(this);
      this.addHorse = this.addHorse.bind(this);

      this.openPeopleModal = this.openPeopleModal.bind(this);
      this.closePeopleModal = this.closePeopleModal.bind(this);
      this.addPerson = this.addPerson.bind(this);

      this.openSelectCardModal = this.openSelectCardModal.bind(this);
      this.closeSelectCardModal = this.closeSelectCardModal.bind(this);
      this.closeAddBankModal = this.closeAddBankModal.bind(this);

      this.getPaymentMethods = this.getPaymentMethods.bind(this);

      this.openViewRefundPolicyModal = this.openViewRefundPolicyModal.bind(this);
      this.closeViewRefundPolicyModal = this.closeViewRefundPolicyModal.bind(this);

      // this.setDepositAmount = this.setDepositAmount.bind(this);


    }
    handlePhoneChange = (status, phoneNumber, country) => {
        this.setState({ 'phoneNumber': phoneNumber, 'status':status });
        // var phone_number = '+' + phoneNumber.replace(/\D/g, "");
    
    
        if(status) {
            document.getElementById('phone_number_order_delivery').value = phoneNumber;
            document.querySelector("#valid_msg_order_delivery").classList.remove('hide');
        } else {
            document.querySelector("#valid_msg_order_delivery").classList.add('hide');
            document.getElementById('phone_number_order_delivery').value = '';
        }
        
        this.updateOrderDeliveryPhone(phoneNumber, -1);
    };

    openHorseModal() {
      this.setState({
        is_open_horse_modal: true,
        add_horse_error_msg: '',
        new_horse_data: JSON.parse(JSON.stringify(new_horse_data_initial)),
        is_editing_horse: false
      });
      
    }
  
    afterOpenModal() {
      // references are now sync'd and can be accessed.
      // this.subtitle.style.color = '#f00';
      
    }
  
    closeHorseModal() {
      this.setState({
        is_open_horse_modal: false,
        new_horse_data: JSON.parse(JSON.stringify(new_horse_data_initial)),
        horse_to_update: {}
      });
      // document.getElementById('add_horse_warning').style.display = "none";
    }

    findCountry(selected_country) {
      return countries_array.find((current_country) => {
        return selected_country.toLowerCase() === current_country.toLowerCase();
      });
    //   return string.charAt(0).toUpperCase() + string.slice(1);
    }
  
    openPeopleModal() {
      const person_field = this.state.people_search_field;
      this.setState({
        is_open_people_modal: true,
        add_people_error_msg: '',
        new_person_data: JSON.parse(JSON.stringify(new_person_data_initial)),
        is_editing_person: false,
        updating_person_field: person_field
      });
    }

    closePeopleModal() {
      this.getPeopleList();
      this.setState({
        is_open_people_modal: false,
        new_person_data: JSON.parse(JSON.stringify(new_person_data_initial)),
        person_to_update: {},
        updating_person_field: ''
      });
      
    }

    openSelectCardModal() {
      this.setState({
        is_open_select_card_modal: true,
      });
    }

    closeSelectCardModal() {
      this.setState({
        is_open_select_card_modal: false,
      });
      
    }

    openAddBankModal() {
      this.setState({
        is_open_add_bank_modal: true,
      });
    }

    closeAddBankModal() {
      this.getPaymentMethods();
      this.setState({
          is_open_add_bank_modal: false,
      });
    }

    openViewRefundPolicyModal() {
      this.setState({
        is_open_view_policy_modal: true,
      });
    }

    closeViewRefundPolicyModal() {
      this.setState({
        is_open_view_policy_modal: false,
      });
      
    }

    componentDidMount() {
        document.title = "Add Entry";
        let value = this.context.company_id;
        var switches = this.context.switches.switches;
        // switch_name: "Online Entries"
        var switch_found = switches.find(el => el.switch_name === "Online Entries");
        var switch_allowed = 0;
        if(switch_found){
            switch_allowed = switch_found.value;
        }
        this.setState({
            switch_allowed: switch_allowed
        });

        if(switch_allowed){
            this.getAllData();
            this.getDefaultPaymentMethodForCurrentUser();
        } else {
            this.setState({
            switch_allowed: switch_allowed,
            switch_company_name: this.context.switches.company_name?this.context.switches.company_name:'The Company',
            loading:false
            })
        }
    }
  
    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleLeavePage);
    }

    async componentDidUpdate(prevProps, prevState) {
      // Compare previous state with current to see if RP is changed or not. If RP is changed then we need to check if onboarding milestone is completed by user
      if (prevState.selected_responsible !== this.state.selected_responsible) {
  
        if(this.state.selected_responsible && this.state.exhibitor_billing_enabled_for_show){
          await this.checkPersonOnboarded()
        }

        // clear the platform fee fields
        this.setState({platform_fee_payment_method: '-1', platform_fee_login_id: 0})
      }

      // When Show is updated need to check if New Billing Model is enabled for that show or not
      if(prevState.selected_show != this.state.selected_show){
        await this.exhibitorBillingEnabledForShow(this.state.selected_show)
      }
    }

    // set the payment method for platform fee
    onPlatformFeePaymentMethodSelect(e) {
      if (e.target.value === 'ManageCards'){
        this.openSelectCardModal();
        this.setState({
          platform_fee_payment_method: '-1',
          platform_fee_login_id: 0
        });
      } else {
        
        this.setState({
          platform_fee_payment_method: e.target.value,
        });
      }
    }

    getPlatformFeeWarning (rp) {
      let message
      if(!rp.hasUserOnboardedMilestone){
        let warnings = [];
        let requirements = [];

        if (rp.hasUnsignedTOS) {
          warnings.push("has not signed the required agreement");
          requirements.push("a signed agreement at the Agreement step");
        }
        if (!rp.hasDefaultPayMethod) {
          warnings.push("has no payment method on file");
          requirements.push("a payment method at the Payment step");
        }

        if (warnings.length > 0) {
          // Build the warning part
          if (warnings.length === 1) {
            message = warnings[0];
          } else {
            message =
              warnings.slice(0, -1).join(", ") +
              " and " +
              warnings[warnings.length - 1];
          }

          // Add requirements part
          if (requirements.length === 1) {
            message = `${rp.fl_name} ${message}. You will be required to provide ${requirements[0]}.`;
          } else {
            message = `${rp.fl_name} ${message}. You will be required to provide ${requirements[0]} and ${requirements[1]}.`;
          }
        }
      }

      return message
    }

    // function to check if action required for platform fee are in place or not
    async checkPersonOnboarded () {

      try{
        if(
          !this.state.exhibitor_billing_enabled_for_show ||
          this.state.selected_responsible.billingDataChecked || 
          (this.state.selected_responsible && Object.keys(this.state.selected_responsible).length === 0)
        ){ // don't check the billing setup is already checked
          return
        }

        if(!this.state.selected_responsible.sgl_logins_id || this.state.selected_responsible.sgl_logins_id < 0){
          
          let rp = this.state.selected_responsible
          // New RTO or RTO with no linked login
          rp['useCurrentUserForPlaformFee'] = true
          rp['hasUserOnboardedMilestone'] = false
          rp['hasUnsignedTOS'] = true
          rp['hasDefaultPayMethod'] = false
          rp['defaultPayMethodFingerprintId'] = 0
          rp['hasValidDefaultPayMethod'] = false
          rp['billingDataChecked'] = true
          rp['account'] = null
          let message = this.getPlatformFeeWarning(rp);
          rp['billingWarning'] = message
          this.setState(rp)
          return
        }

        this.setState({processingBillingData: true})
        document.getElementById('verify-rp').classList.remove('display_none');
        await axios.get(`${process.env.REACT_APP_NEST_API}/billing/checkPersonOnboarded`,{
          params : {
              customer_id: this.context.company_id,
              login_id: this.state.selected_responsible.sgl_logins_id ?? -1,
          }
        }).then(async(results) => {
          
          let message = "";
          let response = results?.data
          let rp = this.state.selected_responsible
          rp['useCurrentUserForPlaformFee'] = true // by default use current user for platform fee

          if(response?.success){
            
            rp['hasUserOnboardedMilestone'] = response.hasUserOnboardedMilestone
            rp['hasUnsignedTOS'] = response.hasUnsignedTOS
            rp['hasDefaultPayMethod'] = response.hasDefaultPayMethod
            rp['defaultPayMethodFingerprintId'] = response.defaultPayMethodFingerprintId
            rp['hasValidDefaultPayMethod'] = response.hasValidDefaultPayMethod
            rp['useCurrentUserForPlaformFee'] = !rp['hasUserOnboardedMilestone'] || !rp['hasValidDefaultPayMethod'] || rp['sgl_logins_id'] == this.context.current_user.sgl_id
            rp['billingDataChecked'] = true
            rp['account'] = response.account
            message = this.getPlatformFeeWarning(rp);
          }else{
            console.log(response?.error)
          }

          if(!rp['useCurrentUserForPlaformFee']){
            rp['rpDefaultPaymentMethodDesc'] = `${response?.defaultPaymentMethod?.name_on_card} - xxxx${response?.defaultPaymentMethod?.card_lastfour}`
          }

          rp['billingWarning'] = message
          this.setState(rp)

          console.log('Data: ', rp['useCurrentUserForPlaformFee'])

        });

      }catch (e) {
        console.log(e)
      }

      document.getElementById('verify-rp').classList.add('display_none');
      this.setState({processingBillingData: false})
    }

    rpHasOnboardingSetup (){
      return (
        this.state.exhibitor_billing_enabled_for_show &&  // exhibitor billing is enabled for SMC
        this.state.selected_responsible.hasUserOnboardedMilestone //exhibitor has Onboarded User Milestone
      )
    }

    async exhibitorBillingEnabledForShow (show_id) {
        let response = await axios.get(`${process.env.REACT_APP_NEST_API}/billing/exhibitorBillingEnabledForShow`,{
          params : {
            show_id,
            company_id: this.context.company_id
          }
        })

        this.setState({ exhibitor_billing_enabled_for_show: response.data })
    }

    async getDefaultPaymentMethodForCurrentUser() {
      // Fetch default payment method
      await axios.get(this.context.nestApiUrl + '/billing/getAccountPaymentMethod', {
        params: {
          user_id: this.context.current_user?.sgl_id,
          company_id: this.context.company_id
        }
      }).then(defaultPaymentMethodRes => {

        if(
          defaultPaymentMethodRes?.data && 
          this.state.payment_methods?.length > 0 &&
          this.state.payment_methods?.find((data) => data.sgl_id == defaultPaymentMethodRes?.data?.fingerprint_id)
        ){
          this.setState({
            currentDefaultPaymentMethod: defaultPaymentMethodRes.data
          })
        }
        
      })
    }
  
    handleLeavePage(e) {
      const confirmationMessage = 'Are you sure you want to leave?';
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
      return confirmationMessage;              // Gecko, WebKit, Chrome <34
    }

    handleArrivalDateChange = (date, event) => {
        this.setState({
            order_delivery_arrival_date: date
        });
    };
    
    renderArrivalDatePicker = () => {
        let dateToday = new Date();
        var dateShowEnd = new Date(this.state.selected_show_details.end_date);

        console.log("previous implementation for end date",dateShowEnd)
        if (this.state.selected_show_details.end_date) {
            // no timezone shift
            const endDateStr = this.state.selected_show_details.end_date.split('T')[0]; // "2025-11-05"
            const [year, month, day] = endDateStr.split('-').map(Number); // [2025, 11, 5]
            dateShowEnd = new Date(year, month - 1, day); // November 5, 2025
        }
        console.log("new implementation for end date",dateShowEnd)

        return <DatePicker
            id="datepicker"
            name="txtArrivalDate"
            minDate={dateToday}
            maxDate= {dateShowEnd}
            renderCustomHeader={this.renderCustomHeader}
            dateFormat={"MM/dd/yyyy"}
            selected={this.state.order_delivery_arrival_date}
            onChange={this.handleArrivalDateChange}
            showMonthDropdown
            dropdownMode="select"
        />
    }

    getAllData(){
      this.getUserData();
      this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath+'/add-entry');
      this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath+'/add-entry');
      axios.all([
        axios.get(this.sgl_webservice_iphone+'Index',{
          params : {
            company_id: this.context.company_id,
            from_plugin_api: true,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }),
        axios.get(this.sgl_webservice_iphone+'GetPaymentMethods',{
          params : {
            company_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          }
        }) 
        
      ]).then(axios.spread((results, paymentMethods) => {
        let person_lookup_organizations = (typeof results.data.person_lookup_organizations !== 'undefined')?results.data.person_lookup_organizations:[];
        this.setState({
          logged_in_people_id: results.data.people_id?results.data.people_id:'',
          company_name: results.data.company_name?results.data.company_name:'',
          governing_organization: results.data.governing_organization?results.data.governing_organization:'',
          person_lookup_organizations: person_lookup_organizations,
          shows_list: results.data.shows?results.data.shows:[],
          horses_list: results.data.horses?results.data.horses:[],
          people_list: results.data.people?results.data.people:[],
          credit_hold: results.data.credit_hold?results.data.credit_hold:false,
          refund_policy: results.data.refund_policy?results.data.refund_policy:'',
          payment_options: results.data.payment_options?results.data.payment_options:{},
          check_payment_method_info: results.data.check_payment_method_info?results.data.check_payment_method_info:false,
          acquire_add_entry_tax_info: results.data.acquire_add_entry_tax_info ? results.data.acquire_add_entry_tax_info : false,
          stall_check_in_info: results.data.stall_checkin_checkout_prefs?results.data.stall_checkin_checkout_prefs:{},
          restrict_junior_riders: results.data.restrict_junior_riders == '1'?true:false,
          payment_methods: paymentMethods.data.payment_methods?paymentMethods.data.payment_methods:[],
          can_checkout: paymentMethods.data.can_checkout,
          bank_accounts: paymentMethods.data.bank_accounts?paymentMethods.data.bank_accounts:[],
          ach_enabled: paymentMethods.data.ach_enabled?true:false,
          ach_service_fee_percent: paymentMethods.data.ach_service_fee_percent,
          ach_service_fee_cap: paymentMethods.data.ach_service_fee_cap,
          check_card_email_phone_info: paymentMethods.data.check_card_email_phone_info,
          check_address_info: paymentMethods.data.check_address_info,
          deposit_payment_agreement: paymentMethods.data.deposit_payment_agreement,
          securing_entry_agreement: paymentMethods.data.securing_entry_agreement,
          require_payment_method_agreement: paymentMethods.data.require_payment_method_agreement,

          loading: false
        })    
        this.setHorseRtoSearchDefaultOrg();
      }))      
    }

    getPaymentMethods(){
      axios.get(this.sgl_webservice_iphone+'GetPaymentMethods',{
        params : {
            company_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        }
      }).then(results => {
        this.setState({
          payment_methods: results.data.payment_methods,
          can_checkout: results.data.can_checkout,
          bank_accounts: results.data.bank_accounts?results.data.bank_accounts:[],
          ach_enabled: results.data.ach_enabled?true:false,
          check_card_email_phone_info: results.data.check_card_email_phone_info,
          check_address_info: results.data.check_address_info,
          loading: false
        })    
      })
    }

    getHorseSearchData(search_by, search_term){
      if(search_term && search_term != ''){
        axios.get(this.sgl_webservice_iphone+'SearchHorse',{
          params : {
              search_by : search_by,
              search_term : search_term,
              company_id: this.context.company_id,
              check_duplicates: true,
              show_id: this.state.selected_show,
              entry_id: 0
          }
        }).then(results => {
          this.setHorseLabelTh();
          document.getElementById('search-horse-please-wait').style.display = "none";
          this.setState({
            horses_search_list: results.data.horses?results.data.horses:[],
            // loading: false
          });
        })
      } else {
        document.getElementById('search-horse-please-wait').style.display = "none";
        this.setState({
          horses_search_list: [],
        });
      }
      
    }
    validateHorse(horse_data){
      axios.get(this.sgl_webservice_iphone+'ValidateHorse',{
        params : {
            horse : horse_data,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.handleValidateHorseResponse(results.data);   
      })
      
    }
    ValidatePerson(person_data){
      axios.get(this.sgl_webservice_iphone+'ValidatePerson',{
        params : {
            person : person_data,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.handleValidatePersonResponse(results.data);
   
      })
      
    }

    getPeopleSearchData(search_by, search_term){
      if(search_term && search_term.trim() != ''){

        axios.get(this.sgl_webservice_iphone+'SearchPerson',{
          params : {
              search_by : search_by,
              search_term : search_term.trim(),
              company_id: this.context.company_id
          }
        }).then(results => {
          document.getElementById('search-people-please-wait').style.display = "none";
          document.getElementById('add_people_button').style.display = "inline";
          this.setPeopleLabelTh();
          this.setState({
            people_search_list: results.data.people,
            loading: false
          })    
        })
      } else {
        document.getElementById('search-people-please-wait').style.display = "none";
        document.getElementById('add_people_button').style.display = "inline";
        this.setState({
          people_search_list: [],
        });
      }
      
    }

    checkRiderStatus(show_id, rider_id, rider_name, horse_id, index){
      axios.get(this.sgl_webservice_iphone+'CheckRiderStatus',{
        params : {
            show_id : show_id,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.handleCheckRiderStatusResponse(results.data, rider_id, rider_name, horse_id, index);
      })
      
    }

    getSelectedShowData(show_id){
      axios.get(this.sgl_webservice_iphone+'GetShowData',{
        params : {
            show_id : show_id,
            company_id: this.context.company_id
        }
      }).then(results => {

        this.setState({
          divisions_list: results.data.divisions?results.data.divisions:[],
          divisions_filtered_list: results.data.divisions?results.data.divisions:[],
          classes_list: results.data.classes?results.data.classes:[],
          order_supply_list: results.data.showfees?results.data.showfees:[],
          donations_list: results.data.donation_fees?results.data.donation_fees:[],
          donation_amounts: results.data.donation_amounts?results.data.donation_amounts:['1','5','10','other'],
          class_add_fee: results.data.class_add_fee?results.data.class_add_fee:'',
          class_add_fee_each: results.data.class_add_fee_each?results.data.class_add_fee_each:'',
          class_add_date: results.data.class_add_date?results.data.class_add_date:'',
          class_add_fee_time: results.data.class_add_fee_time?results.data.class_add_fee_time:'',
          class_add_fee_amount: results.data.class_add_fee_amount?results.data.class_add_fee_amount:'',
          charge_add_fee_on_web: results.data.charge_add_fee_on_web?results.data.charge_add_fee_on_web:false,
          barn_types: results.data.barn_types?results.data.barn_types:[],
          pre_order_datetime: results.data.pre_order_datetime,
          loading: false
        })    
      })
      
    }

    checkSelectClassToAdd(show_id, class_ids, rider_id, horse_id){
      axios.get(this.sgl_webservice_iphone+'SelectClass',{
        params : {
            show_id : show_id,
            class_ids : class_ids,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.setClassResponseData(results.data);
      })
    }

    checkSelectClassToDrop(show_id, classes_list, class_id){
      axios.get(this.sgl_webservice_iphone+'DeleteClass',{
        params : {
            show_id : show_id,
            classes_list : classes_list,
            class_id : class_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.setDropClassResponseData(results.data);
      })
    }

    checkSelectDivisionToAdd(show_id, division_id, rider_id, horse_id){
      axios.get(this.sgl_webservice_iphone+'SelectDivision',{
        params : {
            show_id : show_id,
            division_id : division_id,
            rider_id : rider_id,
            horse_id : horse_id,
            company_id: this.context.company_id
        }
      }).then(results => {
        this.setDivisionResponseData(results.data);
      })
    }

    checkOrderSupplyToAdd(show_id, showfees_id, quantity){      
      document.getElementById('supplies_selected_continue').disabled=true;

      axios.get(this.sgl_webservice_iphone+'SelectShowFee',{
        params : {
            show_id : show_id,
            showfees_id : showfees_id,
            quantity : quantity,
            company_id: this.context.company_id
        }
      }).then(results => {
        document.getElementById('supplies_selected_continue').disabled=false;

        this.setOrderSupplyResponseData(results.data, showfees_id);
      })
    }

    GetFeeForEntry(show_id, classes_list, showfees_list, trainer_id, horse_id, riders_list, stall_checkin_checkout_data, check_stable_reservation_response=false){
      var rider_ids = []
      riders_list.forEach(rider => {
        rider_ids.push(rider.people_id);
      });

      axios.get(this.sgl_webservice_iphone+'GetFeeForEntry',{
        params : {
          showfees_list : showfees_list,
          classes_list : classes_list,
          trainer_id : trainer_id,
          horse_id: horse_id,
          rider_ids: rider_ids.join(','),
          show_id: show_id,
          company_id: this.context.company_id,
          from_plugin_api: true,
          ...((this.state.stall_check_in_info.stall_collect_checkin_checkout_time === '1' && this.checkIfStallOrdered()) ? { stall_checkin_checkout_data: stall_checkin_checkout_data } : {})
        }
      }).then(results => {
        if(check_stable_reservation_response){
          if(results.data.stall_checkin_checkout_data_is_valid && results.data.stall_checkin_checkout_data_is_valid.success){
            document.getElementById('step_5').style.display = "none";
            document.getElementById('change_step_5').style.display = "block";
            document.getElementById('step_5_warning').style.display = "none";
            if (this.state.donations_list.length) {
              document.getElementById('step_11').style.display = "block";
              document.getElementById('step_11_warning').style.display = "none";
              this.activateBlock("step_11_container");
            } else {
              document.getElementById('step_6').style.display = "block";
              document.getElementById('step_6_warning').style.display = "none";
              this.activateBlock("step_6_container");
            }
            
            this.calculateHeight();
            this.setFeeForEntryResponseData(results.data);
          } else {
            this.setState({
              order_supply_error_msg: results.data.stall_checkin_checkout_data_is_valid.error
            });
            document.getElementById('step_5_warning').style.display = "block";
          }
        } else {
          this.setFeeForEntryResponseData(results.data);
        }
      })
    }

    getDigitalSignatureVerification(entry_data){
      axios.post(this.sgl_webservice_iphone+'DigitalSignatureVerification',new URLSearchParams({
            entry_data : entry_data,
            company_id: this.context.company_id
          })
        ).then(results => {
        this.setDigitalSignatureVerificationData(results.data);
      })
    }

    refreshACHBalance(){

      if ( this.state.selected_payment_method_type == 'bank' ) {
        axios.post(this.sgl_webservice_iphone+'RefreshACHBalance?XDEBUG_SESSION_START=netbeans-xdebug', new URLSearchParams({
            payment_method_id: this.state.selected_payment_method,
            company_id: this.context.company_id,
            sgl_plugin: true,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          })
        ).then(results => {

        })
      }
    }

    SaveNewEntry(entry_data){
      axios.post(this.sgl_webservice_iphone+'SaveNewEntry?XDEBUG_SESSION_START=netbeans-xdebug', new URLSearchParams({
            entry_data: entry_data,
            company_id: this.context.company_id,
            sgl_plugin: true,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
          })
        ).then(results => {
        this.handleSaveNewEntryData(results.data);
      })
    }

    onChangePage(page) {
    //   this.getClassSignupData(this.state.show_date, this.state.current_show);
    }

    setShow = (event) => {
        
        var show = this.state.shows_list.find(el => el.show_id === event.currentTarget.value);
        this.setState({
          selected_show : event.currentTarget.value,
          selected_show_details: show,
          entry_code: ''
        });
        if (show.require_web_entry_code){
          document.getElementById('entry_code_container').style.display = "block";
        } else {
          document.getElementById('entry_code_container').style.display = "none";
        }
        document.getElementById('step_1_warning').style.display = "none";


        this.setHorseInitialState();
        this.setPeopleInitialState();
        this.setClassInitialState();
        this.setShowFeesInitialState();
        this.setDonationsInitialState();
        this.setAddToSeriesInitialState();
        this.setPaymentInitialState();
        this.calculateHeight();
    }
    setHorseInitialState(){
      this.setState({
        selected_horse: {}, 
        horse_select_error: ''       
      });
      document.getElementById('detail_horse').style.display = "none";
      document.getElementById('step_2_warning').style.display = "none";
      document.getElementById('horse_selection_warning').style.display = "none";  

    }
    
    setPeopleInitialState() {
      this.setState({
        selected_riders_list: [],
        verified_riders_list: [],
        error_riders_list : [],
        selected_rider:{},
        selected_rider2:{},
        selected_rider3:{},
        selected_trainer:{},
        selected_owner:{},
        selected_prize:{},
        selected_responsible:{},
        add_riders_count: 1,
        order_delivery_trainer_name:'',
      });
      document.getElementById('detail_rider').style.display = "none";
      document.getElementById('detail_rider2').style.display = "none";
      document.getElementById('detail_rider3').style.display = "none";
      document.getElementById('detail_trainer').style.display = "none";
      document.getElementById('detail_owner').style.display = "none";
      document.getElementById('detail_prize').style.display = "none";
      document.getElementById('detail_responsible').style.display = "none";

      document.getElementById('RiderRow2').style.display = "none";
      document.getElementById('RiderRow3').style.display = "none";
      document.getElementById('RiderRemove').style.display = "none";
      document.getElementById('add_rider_button').style.display = "block";
      document.getElementById('add_rider_error').style.display = "none";

      document.getElementById('step_3_warning').style.display = "none";
      document.getElementById('step_3_warning_table').style.display = "none";
      this.calculateHeight();
    }
    setClassInitialState() {
      this.setState({
        class_rider_id:'-4',
        division_to_add:'-1',
        division_search: '',
        class_to_add:'-1',
        selected_classes:[],
        class_selection_error_msg: '',
        entry_numbers:'',
      });
      document.getElementById('step_4_warning').style.display = "none";
    }
    setShowFeesInitialState(){
      this.setState({
        selected_showfees:[],
        order_supply_to_add:'-1',
        amount: ''
      });
      document.getElementById('step_5_warning').style.display = "none";
    }
    setDonationsInitialState(){
      this.setState({
        selected_donation: null
      });
    }
    setAddToSeriesInitialState(){ //Set series shows information
      let series_shows = this.state.fee_for_entry.series_shows ? this.state.fee_for_entry.series_shows : [];
      series_shows.map((data, index) => {
        series_shows[index].amount = data.deposit_amount;
        if(data.has_error){ //Show has error?
          series_shows[index].selected = false;
        }
        else{ //Set show as selected by default only if require all show is enabled in series
          series_shows[index].selected = this.state.fee_for_entry.require_all_shows;
        }
      });
      this.calculateTotalSeriesPayment(series_shows);
    }
    setPaymentStep(){
      document.getElementById('step_8').style.display = "block";
      if((this.state.selected_show_details.web_deposit_required === '1' && this.state.fee_for_entry.deposit_amount > 0) || this.state.series_shows_amount>0){
        document.getElementById('step_8_A').style.display = "block";
        document.getElementById('step_8_heading').innerHTML = "Payment - Entry Deposit";
      }else {
      // } else if(this.state.selected_show_details.web_require_credit_card_on_file){
        document.getElementById('step_8_B').style.display = "block";
        document.getElementById('step_8_heading').innerHTML = "Payment - Securing Entry";
      }
      this.activateBlock("step_8_container");
    }
    setPaymentInitialState(){
      
      let _platform_fee_payment_method = -1
      let _platform_fee_login_id = 0

      if(this.state.exhibitor_billing_enabled_for_show){
        if(this.state.selected_responsible['useCurrentUserForPlaformFee']){
          _platform_fee_payment_method = this.state.currentDefaultPaymentMethod ? this.state.currentDefaultPaymentMethod.fingerprint_id : -1
          _platform_fee_login_id= this.context.current_user.sgl_id
        }else{
          _platform_fee_payment_method = this.state.selected_responsible['defaultPayMethodFingerprintId']
          _platform_fee_login_id = this.state.selected_responsible.sgl_logins_id
        }
      }

      this.setState({
        selected_payment_method : '-1',
        selected_deposit_method : '-1',
        deposit_payment_method_type: '',
        selected_payment_method_type: '',
        platform_fee_payment_method: _platform_fee_payment_method,
        platform_fee_login_id: _platform_fee_login_id,
        deposit_cvv: "",
        payment_agree: false,
      });
      document.getElementById('step_8_warning').style.display = "none";
      document.getElementById('step_platform_fee_warning').style.display = "none";
      document.getElementById('step_8_A_warning').style.display = "none";
    }

    async checkHorseDuplicateEntries (horse_id) {
      if(horse_id < 0 || !horse_id || !this.state.selected_show){ // check duplicate fpr existing horse only ignore new horse
        return false
      }
      // check if selected horse has some existing entry
      let results = await axios.get(this.sgl_webservice_iphone+'CheckHorseForDuplicateEntries',{
        params : {
            show_id : this.state.selected_show,
            horse_id : horse_id,
            company_id: this.context.company_id,
            entry_id: 0
        }
      })
      return results?.data ?? false

    }

    async onHorseChange(e) { // horse selected from drop down
      this.setPeopleInitialState();
      this.setClassInitialState();
      // this.setShowFeesInitialState();
      this.setPaymentInitialState();
      document.getElementById('horse_selection_warning').style.display = "none";
      if (e.target.value !== '-1') {
        
        document.getElementById('detail_horse').style.display = "block";
        const horse = this.state.horses_list.find(el => el.horse_id === e.target.value);
        if(horse.on_vet_hold){
          this.setState({
            horse_select_error: 'Selected horse is on vet hold.'
          })
          
          document.getElementById('step_2_warning').style.display = "none";
          document.getElementById('horse_selection_warning').style.display = "block";
        }else {
          // check if selected horse has some existing entries
          let horseHasDuplicateEntries = await this.checkHorseDuplicateEntries(horse.horse_id)
          if(horseHasDuplicateEntries){// horse has duplicate entries
            this.setState({ horse_select_error: 'The selected horse has already been entered in this show and cannot be added a second time. Please contact the show office for more information.' })
            document.getElementById('step_2_warning').style.display = "none";
            document.getElementById('horse_selection_warning').style.display = "block";  
          }
        }
        this.setState({
          selected_horse : horse,
        });
        this.setDefaultPeople(horse);
      } else {
        document.getElementById('detail_horse').style.display = "none";
        this.setState({
          selected_horse : {},
        });
      }
      this.calculateHeight();
      
    }

    setHorse = (event) => {
      this.setPeopleInitialState();
      this.setClassInitialState();
      this.setPaymentInitialState();
      const horse = this.state.horses_search_list.find(el => el.horse_id === event.currentTarget.value);

      // if(!(this.state.governing_organization=='EC' && horse.ec_suspended) && !(this.state.governing_organization=='USEF' && horse.usef_suspended != '0') && !(this.state.governing_organization=='FEI' && horse.fei_suspended)){
      if(!this.getHorseError(horse).hasError){
      this.setState({
          selected_horse : horse,
        });
        this.setDefaultPeople(horse);
      }
    }

    setHorseSearch = (event) => {
      var membership_disabled = false;
      var horse_disabled = true;

      if (event.target.value === 'by_name'){
        horse_disabled = false;
        membership_disabled = true;
      }
      this.setState({
          horse_search : event.target.value,
          txt_membership_no_disabled: membership_disabled,
          txt_horse_name_disabled: horse_disabled,
          // horse_name: '',
          // horse_membership_no: ''
      });

    }
    setHorseRtoSearchDefaultOrg(){
      var horse_search_org = 'by_usef'
      var horse_search_by_label = 'by USEF No.';
      var horse_search_by_txt_label = 'Enter USEF No.';
      if (this.state.governing_organization === 'EC'){
        horse_search_org = 'by_ec'
        horse_search_by_label = 'by Passport No.';
        horse_search_by_txt_label = 'Enter Passport No.';
      } else if (this.state.governing_organization === 'FEI'){
        horse_search_org = 'by_fei'
        horse_search_by_label = 'by FEI No.';
        horse_search_by_txt_label = 'Enter FEI No.';
      }

      var people_search_org = 'by_usef';
      // var horse_search_by_label = 'by USEF No.';
      var people_search_by_txt_label = 'Enter USEF No.';
      if (this.state.governing_organization === 'EC'){
        people_search_org = 'by_ec'
        // horse_search_by_label = 'by Passport No.';
        people_search_by_txt_label = 'Enter Passport No.';
      } else if (this.state.governing_organization === 'FEI'){
        people_search_org = 'by_fei'
        // horse_search_by_label = 'by FEI No.';
        people_search_by_txt_label = 'Enter FEI No.';
      }
      this.setState({
          people_search_org : people_search_org,
          // horse_search_by_label: horse_search_by_label,
          people_search_by_txt_label: people_search_by_txt_label,
      
          horse_search_org : horse_search_org,
          horse_search_by_label: horse_search_by_label,
          horse_search_by_txt_label: horse_search_by_txt_label
      });
      
    }

    setHorseSearchOrg = (event) => {
      var horse_search_by_label = 'by USEF No.';
      var horse_search_by_txt_label = 'Enter USEF No.';
      if (event.target.value === 'by_ec'){
        horse_search_by_label = 'by Passport No.';
        horse_search_by_txt_label = 'Enter Passport No.';
      } else if (event.target.value === 'by_fei'){
        horse_search_by_label = 'by FEI No.';
        horse_search_by_txt_label = 'Enter FEI No.';
      }
      this.setState({
          horse_search_org : event.target.value,
          horse_search_by_label: horse_search_by_label,
          horse_search_by_txt_label: horse_search_by_txt_label
      });

    }
    setHorseSearchType = (event) => {
      var membership_disabled = false;
      var horse_disabled = true;

      if (event.target.value === 'by_name'){
        horse_disabled = false;
        membership_disabled = true;
      }
      this.setState({
          horse_search_type : event.target.value,
          horse_search : event.target.value,
          txt_membership_no_disabled: membership_disabled,
          txt_horse_name_disabled: horse_disabled
      });

    }

    setPeopleSearchOrg = (event) => {
      var horse_search_by_label = 'by USEF No.';
      var people_search_by_txt_label = 'Enter USEF No.';
      if (event.target.value === 'by_ec'){
        horse_search_by_label = 'by Passport No.';
        people_search_by_txt_label = 'Enter Passport No.';
      } else if (event.target.value === 'by_fei'){
        horse_search_by_label = 'by FEI No.';
        people_search_by_txt_label = 'Enter FEI No.';
      }
      this.setState({
          people_search_org : event.target.value,
          horse_search_by_label: horse_search_by_label,
          people_search_by_txt_label: people_search_by_txt_label
      });

    }
    setPeopleSearchType = (event) => {
      var membership_disabled = false;
      var people_disabled = true;

      if (event.target.value === 'by_name'){
        people_disabled = false;
        membership_disabled = true;
      }
      this.setState({
          people_search_type : event.target.value,
          txt_people_membership_no_disabled: membership_disabled,
          txt_people_name_disabled: people_disabled
      });

    }

    getShowDates(show) {
      // format_date(show.start_date) + 'to' + format_date(show.end_date)
      return show.start_date + ' to ' + show.end_date;
      
    }

    activateBlock(block_id){
      var other_active_blocks = document.getElementsByClassName("active_block");
      for(var index=0; index < other_active_blocks.length; index++){
        other_active_blocks[index].classList.remove("sgl-primary-header");
        other_active_blocks[index].classList.add("add_entry_options");
        var element_id = other_active_blocks[index].getAttribute("rownum");
        document.getElementById("step_"+element_id+"_heading").classList.add("add_entry_menu_title");
      }
      var active_block = document.getElementById(block_id);
      var row_num = active_block.getAttribute("rownum");
      active_block.classList.add("sgl-primary-header");
      active_block.classList.add("active_block");
      active_block.classList.remove("add_entry_options");
      document.getElementById("step_"+row_num+"_heading").classList.remove("add_entry_menu_title");
    }

    updateEntryCode(evt) {
      this.setState({
        entry_code: evt.target.value
      });
    }

    show_selected = () => (e) => {
      var error_message = '';
      if(this.state.selected_show){
        if(this.state.selected_show_details.require_web_entry_code){
          if(this.state.entry_code){
            if (this.state.selected_show_details.web_entry_code != this.state.entry_code) {
              error_message = 'Please enter valid Entry Code for ' + this.state.selected_show_details.show_name + '.';
            }
          }else {
            error_message = 'Please enter Entry Code.';
          }
        }
        
      } else {
          error_message = 'Please select a show to continue.';
      }
      if (error_message !== ''){
        this.setState({
          select_show_error_msg : error_message,
        });
        document.getElementById('step_1_warning').style.display = "block";

      } else {
        localStorage.setItem('show_id', this.state.selected_show);
        this.getSelectedShowData(this.state.selected_show);
        document.getElementById('step_1').style.display = "none";
        document.getElementById('step_2').style.display = "block";
        document.getElementById('change_step_1').style.display = "block";
        document.getElementById('step_1_warning').style.display = "none";
        this.activateBlock("step_2_container");
      }
      this.calculateHeight();
    }

    horse_selected = (from_search) => (e) => {
      this.horseSelected(from_search);
    }

    _handleHorseSearchKeyPress(e) {
      if (e.key === 'Enter') {
        this.horseSelected(false);
      }
    }
    _handleHorseSearchKeyPress2(e) {
      if (e.key === 'Enter') {
        this.horseSearch();      }
    }
    _handlePeopleSearchKeyPress(e) {
      if (e.key === 'Enter') {
        this.peopleSearch();
      }
    }
    

    getPeopleList() {
      axios.get(this.sgl_webservice_iphone+'getPeopleList',{
        params : {
            company_id: this.context.company_id,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        }
      }).then(results => {
        results.data.people.forEach((person, index) => {
          const person_already_exists = this.state.people_list.find(p => p.people_id === person.people_id);
          if (!person_already_exists){
            this.setState(prevState => ({
              people_list: [...prevState.people_list, person],
            }));
          }  
        });
      });
    }

    async horseSelected(from_search){
      document.getElementById('horse_selection_warning').style.display = "none";  
      if(this.state.selected_horse && JSON.stringify(this.state.selected_horse) !== '{}' && this.state.selected_horse.horse_id !== '-1'){
        if(this.state.selected_horse.on_vet_hold){
          this.setState({
            horse_select_error: 'Selected horse is on vet hold.'
          })
          
          document.getElementById('step_2_warning').style.display = "none";
          document.getElementById('horse_selection_warning').style.display = "block";  
        } else {
          let horseHasDuplicateEntries = false
          if(!from_search){ // horse selected from drop down
            // check if selected horse has some existing entries
            horseHasDuplicateEntries = await this.checkHorseDuplicateEntries(this.state.selected_horse.horse_id)
            if(horseHasDuplicateEntries){// horse has duplicate entries
              this.setState({ horse_select_error: 'The selected horse has already been entered in this show and cannot be added a second time. Please contact the show office for more information.' })
              document.getElementById('step_2_warning').style.display = "none";
              document.getElementById('horse_selection_warning').style.display = "block";  
            }
          }
    
          if(!horseHasDuplicateEntries){
          document.getElementById('step_2').style.display = "none";
          document.getElementById('search_horse').style.display = "none";
          document.getElementById('step_3').style.display = "block";
          this.getPeopleList();
          document.getElementById('change_step_2').style.display = "block";
          document.getElementById('step_2_warning').style.display = "none";
          document.getElementById('search-horse-please-wait').style.display = "none";
          document.getElementById('step_2_search_warning').style.display = "none";
          document.getElementById('detail_horse').style.display = "block";
          document.getElementById('horse_selection_warning').style.display = "none";  

          const horse_already_exists = this.state.horses_list.find(p => p.horse_id === this.state.selected_horse.horse_id);

          if (!horse_already_exists){
            this.setState(prevState => ({
              horses_list: [...prevState.horses_list, this.state.selected_horse],
              horse_select_error: ''
              // selected_search_person : {},
            }))
          }
          this.setState({
            horses_search_list: [],
          });
          // this.setDefaultPeople();
          this.activateBlock("step_3_container");
          }
      }
      } else if (!from_search && this.state.horse_search === 'by_name' && this.state.horse_name != ''){
        this.getHorseSearchData(this.state.horse_search, this.state.horse_name)

        document.getElementById('step_2').style.display = "none";
        document.getElementById('search_horse').style.display = "block";
        document.getElementById('step_2_warning').style.display = "none";
        document.getElementById('step_2_search_warning').style.display = "none";
        document.getElementById('search-horse-please-wait').style.display = "inline";


        this.setState({
          horse_name: '',
          horse_membership_no: '',
          horse_search_type: 'by_name'
        });
      } else if (!from_search &&this.state.horse_search != 'by_name' && this.state.horse_membership_no != ''){
        this.getHorseSearchData(this.state.horse_search, this.state.horse_membership_no);

        document.getElementById('step_2').style.display = "none";
        document.getElementById('search_horse').style.display = "block";
        document.getElementById('step_2_warning').style.display = "none";
        document.getElementById('step_2_search_warning').style.display = "none";
        document.getElementById('search-horse-please-wait').style.display = "inline";

        this.setState({
          horse_name: '',
          horse_membership_no: '',
          horse_search_type: 'by_govrn',
          horse_search_org: this.state.horse_search
        });
      }
       else {
        document.getElementById('step_2_warning').style.display = "block";
        document.getElementById('step_2_search_warning').style.display = "block";        
      }
      this.calculateHeight();
    }

    horse_search = () => (e) => {
      this.horseSearch();
      // if (this.state.horse_search_type == 'by_name') {
      //   this.getHorseSearchData(this.state.horse_search_type, this.state.horse_name);
      // } else {
      //   this.getHorseSearchData(this.state.horse_search_org, this.state.horse_membership_no);
      // }
    }
    horseSearch() {
      document.getElementById('search-horse-please-wait').style.display = "inline";
      if (this.state.horse_search_type === 'by_name') {
        this.getHorseSearchData(this.state.horse_search_type, this.state.horse_name);
      } else {
        this.getHorseSearchData(this.state.horse_search_org, this.state.horse_membership_no);
      }
    }

    cancel_horse_search = () => (e) => {
        this.setState({
          horses_search_list: [],
        });
        document.getElementById('search_horse').style.display = "none";
        document.getElementById('step_2').style.display = "block";
        document.getElementById('step_2_warning').style.display = "none";
        document.getElementById('step_2_search_warning').style.display = "none";
        this.calculateHeight();
    }
 
    updateNewHorseData(evt, field, is_membership=false) {
      var horse_data = this.state.new_horse_data;
      if (is_membership){

        var memberships_list = horse_data['memberships'];

        var membership = {
          'organization_code': field,
          'membership_number': evt.target.value,
          'is_edited': true
        }
        const i = memberships_list.findIndex(mem => mem.organization_code === field);
        if (i > -1) {
          memberships_list[i] = membership; // (2)
        } else {
          memberships_list.push(membership);
        }
      } else {
        horse_data[field] = evt.target.value
      }

      this.setState({
        new_horse_data: horse_data
      });
    }

    addHorse() {
      if (this.state.new_horse_data.name === '') {
        this.setState({add_horse_error_msg: "Please enter Name."}); 
        document.getElementById('add_horse_warning').style.display = "block";
      } else if (this.state.new_horse_data.sex === ''){
        this.setState({add_horse_error_msg: "Please enter Sex."}); 
        document.getElementById('add_horse_warning').style.display = "block";
      } else if(this.state.new_horse_data.height === '') {
        this.setState({add_horse_error_msg: "Please enter Height."}); 
        document.getElementById('add_horse_warning').style.display = "block";
      } else {
        var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(this.state.new_horse_data))));
        this.validateHorse(encoded_data);
        
      }
      this.calculateHeight();
    }

    handleValidateHorseResponse(response_data){
      if (response_data.success) {
        document.getElementById('add_horse_warning').style.display = "none";
        var horse = this.state.new_horse_data;
        if (this.state.is_editing_horse){
          horse.is_updated = true;
        }
        this.setState({
          is_open_horse_modal: false,
          add_horse_error_msg: '',
          selected_horse: horse,
          horse_to_update: {}
        }); 
        if (!this.state.is_editing_horse) {
        // document.getElementById('step_2').style.display = "none";
        
          document.getElementById('search_horse').style.display = "none";
          document.getElementById('step_3').style.display = "block";
          this.getPeopleList();
          document.getElementById('change_step_2').style.display = "block";
          document.getElementById('step_2_warning').style.display = "none";
          document.getElementById('horse_selection_warning').style.display = "none";  
          document.getElementById('step_2_search_warning').style.display = "none";
          document.getElementById('detail_horse').style.display = "block";

          var new_horses_count = this.state.new_horses_count;
          horse.horse_id = '-'+(new_horses_count+5);
          
          this.setState(prevState => ({
            horses_list: [...prevState.horses_list, horse],
            new_horses_count: new_horses_count + 1,
          }))
        
          this.activateBlock("step_3_container");
        }
      } else {
        let errors_string = response_data.errors.join(' \n');
        this.setState({add_horse_error_msg: errors_string}); 
        document.getElementById('add_horse_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    async setDefaultPeople(horse) {
      var owner = {};
      var rider = {};
      var trainer = {};
      var prizemoneyrecipient = {};
      var responsibleparty = {};
      
      if(horse.owner_id){
        owner = this.state.people_list.find(p => p.people_id === horse.owner_id);
        if(owner){
          document.getElementById('detail_owner').style.display = "block";
        } else {
          owner = {};
        }
      }
      if(horse.rider_id){
        rider = this.state.people_list.find(p => p.people_id === horse.rider_id);
        if(rider){
          // AR: update linked parents for junior
          if (rider.is_junior) {
            let parents = await this.getLinkedParents(rider.people_id, this.context.company_id)
            const { linked_people = [], pending_linked_people = [] } = parents.data || {};
            const allParents = [...linked_people, ...pending_linked_people];
            const primaryParent = allParents.find(p => p.is_primary == 1) || {};
            rider.parents_list = allParents
            rider.parent_guardian_id = primaryParent.people_id ?? 0
              
          }
          document.getElementById('detail_rider').style.display = "block";
        } else {
          rider = {};
        }
      }
      if(horse.trainer_id){
        trainer = this.state.people_list.find(p => p.people_id === horse.trainer_id);
        if(trainer){
          document.getElementById('detail_trainer').style.display = "block";
        } else {
          trainer = {};
        }
      }
      if(horse.prizemoneyrecipient_id){
        prizemoneyrecipient = this.state.people_list.find(p => p.people_id === horse.prizemoneyrecipient_id);
        if(prizemoneyrecipient){
          document.getElementById('detail_prize').style.display = "block";
        } else {
          prizemoneyrecipient = {};
        }
      }
      if(horse.responsibleparty_id){
        responsibleparty = this.state.people_list.find(p => p.people_id === horse.responsibleparty_id);
        if(responsibleparty){
          document.getElementById('detail_responsible').style.display = "block";
        } else {
          responsibleparty = {};
        }
      }

      this.setState(prevState => ({
        selected_rider:rider,
        selected_trainer:trainer,
        selected_owner:owner,
        selected_prize:prizemoneyrecipient,
        selected_responsible:responsibleparty,
        order_delivery_trainer_name:trainer?.fl_name?trainer.fl_name:'',
      }))
      this.calculateHeight();
      

    }

    people_selected = () => (e) => {
      document.getElementById('step_3_warning').style.display = "none";
      document.getElementById('step_3_warning_table').style.display = "none";
      this.setState({
        error_riders_list: []
      });

      if(!this.state.selected_rider || JSON.stringify(this.state.selected_rider) === '{}' || this.state.selected_rider.people_id === '-4'){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Please select a Rider.',
        });
      } else if (this.state.selected_rider.on_credit_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Rider is on credit hold. Entry cannot be added online.',
        });
      } else if (!this.state.selected_trainer || JSON.stringify(this.state.selected_trainer) === '{}' || this.state.selected_trainer.people_id === '-4'){
        document.getElementById('step_3_warning').style.display = "block";
        if(this.state.governing_organization === 'EC') {
          this.setState({
            people_selection_error_msg : 'Please select a Coach.',
          });
        } else {
          this.setState({
            people_selection_error_msg : 'Please select a Trainer.',
          });
        }
      } else if (this.state.selected_trainer.on_credit_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Trainer is on credit hold. Entry cannot be added online.',
        });
      } else if (this.state.selected_trainer.is_junior){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Juniors cannot be added as trainers in entry.',
        });
      } else if (!this.state.selected_owner || JSON.stringify(this.state.selected_owner) === '{}' || this.state.selected_owner.people_id === '-4'){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Please select an Owner.',
        });
      } else if (this.state.selected_owner.on_credit_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Owner is on credit hold. Entry cannot be added online.',
        });
      } else if (!this.state.selected_prize || JSON.stringify(this.state.selected_prize) === '{}' || this.state.selected_prize.people_id === '-4'){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Please select a Prize Money Recipient.',
        });
      } else if (this.state.selected_prize.on_credit_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Prize Money Recipient is on credit hold. Entry cannot be added online.',
        });
      } else if (!this.state.selected_responsible || JSON.stringify(this.state.selected_responsible) === '{}' || this.state.selected_responsible.people_id === '-4'){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Please select a Responsible Party.',
        });
      } else if (this.state.selected_responsible.on_credit_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Responsible Party is on credit hold. Entry cannot be added online.',
        });
      } else if (this.state.selected_responsible?.account?.sgl_on_hold){
        document.getElementById('step_3_warning').style.display = "block";
        this.setState({
          people_selection_error_msg : 'Responsible Party is on SGL hold. Entry cannot be added online.',
        });
      } else {
        var riders_list = [this.state.selected_rider];
        if(this.state.selected_rider2 && JSON.stringify(this.state.selected_rider2) !== '{}' && this.state.selected_rider2.people_id !== '-4'){
          riders_list.push(this.state.selected_rider2);
        }
        if(this.state.selected_rider3 && JSON.stringify(this.state.selected_rider3) !== '{}' && this.state.selected_rider3.people_id !== '-4'){
          riders_list.push(this.state.selected_rider3);
        }
        const ids = riders_list.map(obj => obj.people_id);
        const set = new Set(ids);
        const hasDuplicates = set.size < riders_list.length;
        const j_rider_without_parent = riders_list.find(r => r.is_junior && (!r.parent_guardian_id|| r.parent_guardian_id == 0))
        if(set.size < riders_list.length) {
          document.getElementById('step_3_warning').style.display = "block";
          this.setState({
            people_selection_error_msg : 'Please select distinct Riders.',
          });
        } else if (this.state.restrict_junior_riders && j_rider_without_parent){
          document.getElementById('step_3_warning').style.display = "block";
          this.setState({
            people_selection_error_msg : 'Please select Parent/Guardian of Junior Riders.',
          });
        
        } else {

          this.setState({
            selected_riders_list : riders_list,
          });
          document.getElementById('select-people-please-wait').style.display = "block";
          document.getElementById('continue_people').style.display = "none";
          riders_list.forEach((rider, index) => {
            this.checkRiderStatus(this.state.selected_show, rider.people_id, rider.lf_name, this.state.selected_horse.horse_id, index);
          });
        }
        // document.getElementById('step_3').style.display = "none";
        // document.getElementById('step_4').style.display = "block";
        // document.getElementById('change_step_3').style.display = "block";
        // document.getElementById('step_3_warning').style.display = "none";
      }
      this.calculateHeight();
    }

    handleCheckRiderStatusResponse(response_data, rider_id, rider_name, horse_id, index){
      var rider_errors = this.state.error_riders_list;
      var riders = this.state.verified_riders_list;
      riders.push(rider_id);
      if (response_data.success) {
        
      } else {
        var error = {
          rider_id: rider_id, 
          rider_name: rider_name,
          horse_id: horse_id,
          horse_name: this.state.selected_horse.name,
          error_message: response_data.error,
          error_type: response_data.error_type,
          entry_id: response_data.entry_id,
          entry_number: response_data.entry_number,
        }
        
        // this.setState(prevState => ({
        //   error_riders_list: [...prevState.error_riders_list, error],
        // }))
        rider_errors.push(error);
          
      }
      if(this.state.selected_riders_list.length === riders.length){
        riders = [];
        document.getElementById('select-people-please-wait').style.display = "none";
        document.getElementById('continue_people').style.display = "block";
        if (rider_errors.length === 0) {
          document.getElementById('step_3').style.display = "none";
          document.getElementById('step_4').style.display = "block";
          document.getElementById('change_step_3').style.display = "block";
          document.getElementById('step_3_warning').style.display = "none";
          document.getElementById('step_3_warning_table').style.display = "none";
          this.setState({
            class_rider_id:'-4',
            division_to_add:'-1',
            division_search: '',
            class_to_add:'-1',
            class_selection_error_msg: '',
          });
          this.activateBlock("step_4_container");
          this.setDistinctPeopleList();
        } else {
          if(rider_errors[0]['error_type'] === 'entry_exist'){
            document.getElementById('step_3_warning_table').style.display = "block";
            this.setState({
              riders_table_error_msg : rider_errors[0]['error_message'],
              // error_riders_list :rider_errors
            });
          } else {
            document.getElementById('step_3_warning').style.display = "block";
            this.setState({
              people_selection_error_msg : rider_errors[0]['error_message'],
            });
          }
        }
      }

      this.setState({
        verified_riders_list : riders,
        error_riders_list: rider_errors
      });
      this.calculateHeight();
    }
    setDistinctPeopleList(){
      var selected_people = this.state.selected_riders_list.concat([this.state.selected_owner, this.state.selected_prize, this.state.selected_responsible, this.state.selected_trainer]);
      const arrUniq = [...new Map(selected_people.map(v => [v.people_id, v])).values()]
      this.setState({
        selected_distinct_people_list : arrUniq
      });
    }
    
    //Get available form types 
    showAvailableForms = async (index) => {
      let selectedLinkId = 'nextform-link-' + index;
      let selectedChangeFormTypeId = 'change-form-type-' + index;
      document.getElementById(selectedLinkId).style.display = "none";
      document.getElementById(selectedChangeFormTypeId).style.display = "block";
      this.state.nextform_urls[index].updatedFormType = '-1';
    }

    //Handle Tax Form Type Change
    handleElectronicFormChange = (e, index, oldFormData) => {
      this.state.nextform_urls[index].updatedFormType = e.target.value;
    }

    //Update the form type and fetch new form URL for the selected form type
    updateElectronicFormUrl = async (index) => {
      this.setState({formtype_change_loader: true})
      let selectedLinkId = 'nextform-link-' + index;
      let selectedChangeFormTypeId = 'change-form-type-' + index;
      const people_id = this.state.nextform_urls[index].entity_id;
      const updatedFormType = this.state.nextform_urls[index].updatedFormType;
      const customer_id = this.context.company_id;
      const show_id = this.state.selected_show;
      const name = this.state.nextform_urls[index].documents[0]?.formData?.name ? this.state.nextform_urls[index].documents[0].formData.name: '';
      //Add email for future use
      // const email = this.state.nextform_urls[index].signerEmail;

      //vaildate dropdown and check for empty
      if(!updatedFormType || parseInt(updatedFormType) <= 0){
        this.setState({nextform_error_msg: 'Please select valid Form.', formtype_change_loader: false})
        document.getElementById('electronic_documents_warning').style.display = "block";
        return false
      }

      const queryParamenters = `?people_id=${people_id}&user_form_id=${updatedFormType}&show_id=${show_id}&customer_id=${customer_id}&name=${name}`
      await axios
        .get(this.context.nestApiUrl + '/add-entry/getPersonElectronicDocument' + queryParamenters)
        .then((response) => {
          this.state.nextform_urls[index].documents[0].id = response.data.id;
          this.state.nextform_urls[index].documents[0].url = response.data.url;
          this.state.nextform_urls[index].documents[0].formType = response.data.formType;
          this.state.nextform_urls[index].documents[0].documentType = response.data.documentType;
          this.state.nextform_urls[index].documents[0].reference = response.data.reference;
          this.state.nextform_urls[index].documents[0].obtained = response.data.obtained;
          this.state.nextform_urls[index].documents[0].alreadySubmittedFormType = response.data.alreadySubmittedFormType;
          document.getElementById(selectedLinkId).style.display = "block";
          document.getElementById(selectedChangeFormTypeId).style.display = "none";
          document.getElementById('electronic_documents_warning').style.display = "none";
          this.setState({nextform_error_msg: '', formtype_change_loader: false})
        })
        .catch((error) => {
          this.setState({nextform_error_msg: '', formtype_change_loader: false})
          console.error('Error changing form type', error)
        })
    }
    
    //Cancel form change
    cancelFormChange = (index) => {
      let selectedLinkId = 'nextform-link-' + index;
      let selectedChangeFormTypeId = 'change-form-type-' + index;
      document.getElementById(selectedLinkId).style.display = "block";
      document.getElementById(selectedChangeFormTypeId).style.display = "none";
      this.setState({nextform_error_msg: '', formtype_change_loader: false})
    }

    searchPeople = (people_search_field, people_search_field_text) => (e) => {
      document.getElementById('search_people').style.display = "block";
      document.getElementById('add_people_button').style.display = "none";
      document.getElementById('step_3').style.display = "none";
      document.getElementById('step_3_search_warning').style.display = "none";
      document.getElementById('search-people-please-wait').style.display = "none";


      this.setState({
        people_search_field : people_search_field,
        people_search_field_text: people_search_field_text,
        people_search_list: [],
        selected_search_person: {},
        // people_search_by_txt_label: 'Enter USEF No.',
        // people_search_org:'by_usef',
        people_search_type: 'by_name',
        txt_people_name_disabled:false,
        txt_people_membership_no_disabled:true,
        people_first_name: '',
        people_last_name: '',
        people_membership_no: '',
      });
      this.setHorseRtoSearchDefaultOrg();
      this.calculateHeight();
    }

    AddRider = () => (e) => {
      var next_row = this.state.add_riders_count+1;
      document.getElementById('RiderRow'+next_row).style.display = "block";
      document.getElementById('RiderRemove').style.display = "block";
      // document.getElementById('add_rider_button_'+this.state.add_riders_count).style.display = "none";

      if(next_row === 3){
        document.getElementById('add_rider_button').style.display = "none";
        document.getElementById('add_rider_error').style.display = "block";
      }
      
      this.setState({
        add_riders_count : this.state.add_riders_count+1,
      });
      this.calculateHeight();
    }

    removeRider = (rider_row_no) => {
      document.getElementById('add_rider_button').style.display = "block";
      document.getElementById('add_rider_error').style.display = "none";
      document.getElementById('detail_rider'+rider_row_no).style.display = "none";

      if (rider_row_no === 2){
        this.dropRiderClasses(this.state.selected_rider2);
        this.setState({
          selected_rider2 : {}
        });
      } else if (rider_row_no === 3){
        this.dropRiderClasses(this.state.selected_rider3);
        this.setState({
          selected_rider3 : {}
        });
      }

      if (rider_row_no === 2 && this.state.add_riders_count === 3){
        document.getElementById('RiderRow3').style.display = "none";
        if(this.state.selected_rider3 && JSON.stringify(this.state.selected_rider3) !== '{}' && this.state.selected_rider3.people_id !== '-4'){
          document.getElementById('detail_rider2').style.display = "block";
          document.getElementById('detail_rider3').style.display = "none";
        }
        this.setState({
          add_riders_count : this.state.add_riders_count-1,
          selected_rider2 : this.state.selected_rider3,
          selected_rider3 : {}
        });
      } else {
        document.getElementById('RiderRow'+rider_row_no).style.display = "none";
        // document.getElementById('detail_rider'+rider_row_no).style.display = "none";
        this.setState({
          add_riders_count : this.state.add_riders_count-1,
        });
      }
      // 
      // document.getElementById('add_rider_button_'+rider_row_no).style.display = "none";
      if(this.state.add_riders_count === 2){
        document.getElementById('RiderRemove').style.display = "none";
      }
      this.calculateHeight();
      
    }

    person_selected = () => (e) => {
      if (Object.keys(this.state.selected_search_person).length > 0){
          
        document.getElementById('search_people').style.display = "none";
        document.getElementById('step_3').style.display = "block";
        this.getPeopleList();
        document.getElementById('step_3_warning').style.display = "none";
        document.getElementById('step_3_warning_table').style.display = "none";
        document.getElementById('add_people_button').style.display = "none";

        // document.getElementById('detail_'+this.state.people_search_field).style.display = "block";
        this.setPersonState(this.state.selected_search_person, this.state.people_search_field);

        const person_already_exists = this.state.people_list.find(p => p.people_id === this.state.selected_search_person.people_id);

        if (!person_already_exists){
          this.setState(prevState => ({
            people_list: [...prevState.people_list, this.state.selected_search_person],
            selected_search_person : {},
          }))
        }
        this.setState({
          people_search_list: []
        });
      } else {
        document.getElementById('step_3_search_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    cancel_people_search = () => (e) => {
      document.getElementById('search_people').style.display = "none";
      document.getElementById('step_3').style.display = "block";
      this.getPeopleList();
      document.getElementById('add_people_button').style.display = "none";
      this.calculateHeight();
    }

    people_search = () => (e) => {
      this.peopleSearch();
      // if (this.state.people_search_type == 'by_name') {
      //     var name = this.state.people_first_name + ' ' + this.state.people_last_name;
      //     this.getPeopleSearchData(this.state.people_search_type, name);
      // } else {
      //   this.getPeopleSearchData(this.state.people_search_org, this.state.people_membership_no);
      // }
      // document.getElementById('add_people_button').style.display = "block";
    }
    peopleSearch() {
      
      document.getElementById('search-people-please-wait').style.display = "inline";

      if (this.state.people_search_type === 'by_name') {
          var name = this.state.people_first_name + ' ' + this.state.people_last_name;
          this.getPeopleSearchData(this.state.people_search_type, name);
      } else {
        this.getPeopleSearchData(this.state.people_search_org, this.state.people_membership_no);
      }
      // document.getElementById('add_people_button').style.display = "inline";
    }


    checkIsFarmChange(e) {
      var people_data = this.state.new_person_data;
      people_data['isfarmrto'] = e.target.checked

      this.setState({
        new_person_data: people_data
      });
      if (e.target.checked){
        document.getElementById('add_people_company_div').style.display = "flex";
        document.getElementById('add_people_name_div').style.display = "none";
      } else {
        document.getElementById('add_people_company_div').style.display = "none";
        document.getElementById('add_people_name_div').style.display = "flex";
      }
      this.calculateHeight();
    }

    updateNewPersonData(evt, field, is_membership=false) {
      var people_data = this.state.new_person_data;
      if (is_membership){

        var memberships_list = people_data['memberships'];

        var membership = {
          'organization_code': field,
          'membership_number': evt.target.value,
          'is_edited': true
        }
        let i = -1;
        if (typeof memberships_list !== 'undefined') {
          i = memberships_list.findIndex(mem => mem.organization_code === field);
        } else {
          people_data['memberships'] = [];
          memberships_list = people_data['memberships'];
        }
        
        if (i > -1) {
          memberships_list[i] = membership; // (2)
        } else {
          memberships_list.push(membership);
        }
      } else {
        people_data[field] = evt.target.value;
      }

      this.setState({
        new_person_data: people_data
      });
    }

    addPerson() {
      var error_msg = '';
      var lf_name = '';
      var fl_name = '';

      if (this.state.new_person_data.isfarmrto){
        lf_name = this.state.new_person_data.company_name;
        fl_name = this.state.new_person_data.company_name;
        if (this.state.new_person_data.company_name === '') {
          error_msg = 'Please enter Company Name';
        }
      } else {
        lf_name = this.state.new_person_data.last_name + ' ' + this.state.new_person_data.first;
        fl_name = this.state.new_person_data.first + ' ' + this.state.new_person_data.last_name;

        if (this.state.new_person_data.first === '') {
          error_msg = 'Please enter First Name';
        } else if (this.state.new_person_data.last_name === '') {
          error_msg = 'Please enter Last Name';
        }
      }
      if (error_msg === ''){
        if (this.state.new_person_data.address === '') {
          error_msg = 'Please enter Address';
        } else if (this.state.new_person_data.city === ''){
          error_msg = 'Please enter City';
        } else if(this.state.new_person_data.state === '') {
          error_msg = 'Please enter State';
        } else if(this.state.new_person_data.postal_code === '') {
          error_msg = 'Please enter Postal Code';
        } else if(this.state.new_person_data.country === '') {
          error_msg = 'Please enter your Country';
        } else if(this.state.new_person_data.email_address === '') {
          error_msg = 'Please enter an Email Address';
        } else if(this.state.new_person_data.mobile_phone === '') {
          error_msg = 'Please enter Mobile number';
        }
      }

      if (error_msg === '' && !this.state.is_editing_person){
        var already_created_person;
        if (this.state.new_person_data.isfarmrto){
          already_created_person = this.state.new_persons_list.find(p => (p.company_name === this.state.new_person_data.company_name && p.email_address === this.state.new_person_data.email_address ) );
        } else {
          already_created_person = this.state.new_persons_list.find(p => (p.first === this.state.new_person_data.first && p.last_name === this.state.new_person_data.last_name && p.email_address === this.state.new_person_data.email_address ) );
        }
        if (already_created_person){
          error_msg = 'you have already created a person with same name and email address.';
        }
      }

      this.state.new_person_data.lf_name = lf_name;
      this.state.new_person_data.fl_name = fl_name;

      if (error_msg === ''){
        var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(this.state.new_person_data))));
        this.ValidatePerson(encoded_data);

        // document.getElementById('add_people_warning').style.display = "none";
        // this.setState({is_open_people_modal: false, add_people_error_msg: ''}); 
      } else {
        this.setState({add_people_error_msg: error_msg}); 
        document.getElementById('add_people_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    handleValidatePersonResponse(response_data){
      if (response_data.success) {
        // update memberships
        if( typeof response_data.memberships.EC !== 'undefined') {
          let membership_number = response_data.memberships.EC[0].membership.membership_number;
          let evt = {
            'target':{
              'value':membership_number
            }
          };
          this.updateNewPersonData(evt,'EC',true);
        }
        if( typeof response_data.memberships.OHJA !== 'undefined') {
          let membership_number = response_data.memberships.OHJA[0].membership.membership_number;
          let evt = {
            'target':{
              'value':membership_number
            }
          };
          this.updateNewPersonData(evt,'OHJA',true);
        }

        document.getElementById('add_people_button').style.display = "none";
        document.getElementById('search_people').style.display = "none";
        document.getElementById('step_3').style.display = "block";
        this.getPeopleList();
        var person = this.state.new_person_data;

        if (this.state.is_editing_person){
          person.is_updated = true;
          document.getElementById('detail_'+this.state.updating_person_field).style.display = "block";
          this.updateOtherSelectedRecords(person, this.state.updating_person_field)

          const is_already_updated = this.state.updated_people_list.find(el => el.people_id === person.people_id);
          if(is_already_updated) {
            this.state.updated_people_list.forEach((updated_person, person_index) => {
              if(updated_person.people_id === person.people_id) {
                this.state.updated_people_list[person_index] = person;
                this.setState({
                  updated_people_list: this.state.updated_people_list
                });
              }
            });
          } else {
            this.setState(prevState => ({
              updated_people_list: [...prevState.updated_people_list, person],
            }))
          }
          
        } else {
        //   const person_already_exists = this.state.people_list.find(p => p.people_id === this.state.selected_search_person.people_id);

        // if (!person_already_exists){
          var new_persons_count = this.state.new_persons_count;
          person.people_id = '-'+(new_persons_count+5);
          person.is_created = true;
          
          this.setState(prevState => ({
            people_list: [...prevState.people_list, person],
            updated_people_list: [...prevState.updated_people_list, person],
            new_persons_count: new_persons_count + 1,
            new_persons_list: [...prevState.new_persons_list, person],
          }))
        // }
        }
        document.getElementById('add_people_warning').style.display = "none";
        this.setPersonState(person, this.state.updating_person_field);

        this.setState({
          is_open_people_modal: false,
          add_people_error_msg: '',
          updating_person_field: '',
          person_to_update: {}
          // new_person_data: new_person_data_initial
        }); 
      } else {
        let errors_string = response_data.errors.join(' \n');
        this.setState({add_people_error_msg: errors_string}); 
        document.getElementById('add_people_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    class_selected = () => (e) => {
        document.getElementById('step_4').style.display = "none";
        document.getElementById('step_5').style.display = "block";
        document.getElementById('change_step_4').style.display = "block";
        this.activateBlock("step_5_container");
        this.calculateHeight();
    }

    supplies_selected = () => (e) => {
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
          'rider_id': s.rider_id,
          'rider' : s.rider_name
        })
      });
      var selected_showfees_ids = this.state.selected_showfees.map((s)=>{
        return ({
          'showfees_id': s.showfees_id,
          'quantity': s.quantity
        })
      });

      var selected_donation = this.state.selected_donation;
      if(selected_donation) {
        selected_showfees_ids.push({
          'showfees_id': selected_donation.showfees_id,
          'quantity': selected_donation.quantity
        });
      }
      if (this.getCheckinValidationMsg() != ''){
        this.setState({
          order_supply_error_msg: this.getCheckinValidationMsg()
        });
        document.getElementById('step_5_warning').style.display = "block";
      }
      else {
        this.GetFeeForEntry(this.state.selected_show, JSON.stringify(selected_class_ids), JSON.stringify(selected_showfees_ids), this.state.selected_trainer.people_id, this.state.selected_horse.horse_id, this.state.selected_riders_list, JSON.stringify(this.state.stall_checkin_checkout_data), true);
        // document.getElementById('step_5').style.display = "none";
        // document.getElementById('change_step_5').style.display = "block";
        // document.getElementById('step_5_warning').style.display = "none";
        // if (this.state.donations_list.length) {
        //   document.getElementById('step_11').style.display = "block";
        //   document.getElementById('step_11_warning').style.display = "none";
        //   this.activateBlock("step_11_container");
        // } else {
        //   document.getElementById('step_6').style.display = "block";
        //   document.getElementById('step_6_warning').style.display = "none";
        //   this.activateBlock("step_6_container");
        // }
        
        // this.calculateHeight();
      }
    }

    donations_selected = () => (e) => {
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
          'rider_id': s.rider_id,
          'rider' : s.rider_name
        })
      });
      var selected_showfees_ids = this.state.selected_showfees.map((s)=>{
        return ({
          'showfees_id': s.showfees_id,
          'quantity': s.quantity
        })
      });

      var selected_donation = $("input[name='selected_donation']:checked").val();
      if(selected_donation) {
        selected_donation = this.state.donations_list.filter(c => c.sgl_id === selected_donation)[0];

        var donation_amount = $("input[name='selected_donation_amount']:checked").val();
        if(donation_amount === "other") {
          donation_amount = $("#donation_amount").val();
        }

        if(!donation_amount) {
          this.setState({
            donation_error_msg: 'Please select donation amount.'
          });
          document.getElementById('step_11_warning').style.display = "block";
          return;
        }

        selected_donation.quantity = donation_amount/selected_donation.unit_price;
        this.setState({
          selected_donation: selected_donation
        });

        selected_showfees_ids.push({
          'showfees_id': selected_donation.showfees_id,
          'quantity': selected_donation.quantity
        });
      }
      
      this.GetFeeForEntry(this.state.selected_show, JSON.stringify(selected_class_ids), JSON.stringify(selected_showfees_ids), this.state.selected_trainer.people_id, this.state.selected_horse.horse_id, this.state.selected_riders_list, JSON.stringify(this.state.stall_checkin_checkout_data));
      document.getElementById('step_11').style.display = "none";
      document.getElementById('change_step_11').style.display = "block";
      document.getElementById('step_11_warning').style.display = "none";

      document.getElementById('step_6').style.display = "block";
      document.getElementById('step_6_warning').style.display = "none";
      this.activateBlock("step_6_container");
    }

    dropDonation = () => {
      this.setState({
        selected_donation: null,
      });
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
          'rider_id': s.rider_id,
          'rider' : s.rider_name
        })
      });
      var selected_showfees_ids = this.state.selected_showfees.map((s)=>{
        return ({
          'showfees_id': s.showfees_id,
          'quantity': s.quantity
        })
      });
      this.GetFeeForEntry(this.state.selected_show, JSON.stringify(selected_class_ids), JSON.stringify(selected_showfees_ids), this.state.selected_trainer.people_id, this.state.selected_horse.horse_id, this.state.selected_riders_list, JSON.stringify(this.state.stall_checkin_checkout_data));
    }
    dropOrderSupplyReviewFee = (showfee_id) => {
      // const classs = this.state.selected_classes.find(c => c.class_id === this.state.class_to_add);

      this.setState(prevState => ({
        selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== showfee_id)
      }));
      var stalls = this.state.selected_showfees.filter(c => c.is_stall_fee && c.showfees_id !== showfee_id);
      if(stalls.length === 0){
        this.setState({
          stall_checkin_checkout_data: {
            "checkin_date": '',
            "checkin_time": '',
            "checkout_date": '',
            "checkout_time": ''
          }
        });
      }
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
          'rider_id': s.rider_id,
          'rider' : s.rider_name
        })
      });
      var selected_showfees_ids = this.state.selected_showfees.filter(c => c.showfees_id !== showfee_id).map((s)=>{
        return ({
          'showfees_id': s.showfees_id,
          'quantity': s.quantity
        })
      });

      var selected_donation = this.state.selected_donation;
      if(selected_donation) {
        selected_showfees_ids.push({
          'showfees_id': selected_donation.showfees_id,
          'quantity': selected_donation.quantity
        });
      }
        this.GetFeeForEntry(this.state.selected_show, JSON.stringify(selected_class_ids), JSON.stringify(selected_showfees_ids), this.state.selected_trainer.people_id, this.state.selected_horse.horse_id, this.state.selected_riders_list, JSON.stringify(this.state.stall_checkin_checkout_data));
        

    }

    review_fees_selected = () => (e) => {
        //Get order delivery phone if required based on show fee selected
        let phone_number = '';
        if (this.state.fee_for_entry.order_delivery_information_required){
          phone_number = document.getElementById('phone_number_order_delivery');
          if(phone_number){
            phone_number = phone_number.value;
          }
        }

        if (!this.state.fee_for_entry.web_entry_stall) {
          this.setState({
            review_fees_error_msg: 'This show requires entry stall. Please order stall fee for entry.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        // } else if (this.state.fee_for_entry.cutoff_time_message && this.state.fee_for_entry.cutoff_time_message != ""){
        //   this.setState({
        //     review_fees_error_msg: this.state.fee_for_entry.cutoff_time_message
        //   });
        //   document.getElementById('step_6_warning').style.display = "block";
        }
        // else if (this.state.fee_for_entry.order_delivery_information_required && this.state.order_delivery_trainer_name === ''){
        //   this.setState({
        //     review_fees_error_msg: 'Please enter Trainer Name.'
        //   });
        //   document.getElementById('step_6_warning').style.display = "block";
        // }
        else if (this.state.fee_for_entry.order_delivery_information_required && this.state.pre_order_datetime && this.state.order_delivery_arrival_date == ''){
          this.setState({
            review_fees_error_msg: 'Please enter Arrival Date.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        }
        else if (this.state.fee_for_entry.order_delivery_information_required && this.state.pre_order_datetime && this.state.order_delivery_arrival_time === ''){
          this.setState({
            review_fees_error_msg: 'Please enter Arrival Time.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        }
        //Validate invalid order delivery notification phone
        else if (this.state.fee_for_entry.order_delivery_information_required && (phone_number != '' || this.state.order_delivery_display_phone != '') && (phone_number.replace(/\D/g, "").length < 7)){
          this.setState({
            review_fees_error_msg: 'Please enter valid Delivery Notification Phone.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        }
        else if (this.state.fee_for_entry.order_delivery_information_required && !this.state.pre_order_datetime && this.state.order_delivery_barn_location.trim() === ''){ //do not require barn for pre order date time threshold
          this.setState({
            review_fees_error_msg: 'Please enter Barn Location.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        }
        else if (this.state.fee_for_entry.order_delivery_information_required && !this.state.pre_order_datetime && this.state.order_delivery_stall_location.trim() === ''){
          this.setState({
            review_fees_error_msg: 'Please enter Stall Location.'
          });
          document.getElementById('step_6_warning').style.display = "block";
        }
        else {
          document.getElementById('step_6').style.display = "none";
          document.getElementById('change_step_6').style.display = "block";
          document.getElementById('step_6_warning').style.display = "none";
          this.setState({
            order_delivery_phone_number: phone_number
          });
          
          if(this.state.fee_for_entry.series_shows.length > 0){
            document.getElementById('step_7').style.display = "block";
            this.activateBlock("step_7_container");
            this.setAddToSeriesInitialState();
          }
          else{
            this.setPaymentStep();
            this.setPaymentInitialState();
          }

        }
        this.calculateHeight();
    }

    add_to_series_selected = () => (e) => {
      document.getElementById('step_7').style.display = "none";
      document.getElementById('change_step_7').style.display = "block";
      document.getElementById('step_7_warning').style.display = "none";
      this.calculateTotalSeriesPayment(null);
      this.setPaymentStep();
      this.setPaymentInitialState();

      this.calculateHeight();
    }

    payment_A_selected = () => (e) => {
      if(this.state.selected_deposit_method !== '-1'){
        if(this.state.check_payment_method_info){
          this.checkPaymentMethodApiCall(this.state.selected_deposit_method);
        } else {
          document.getElementById('step_8_A').style.display = "none";
          document.getElementById('step_8_B').style.display = "block";
          document.getElementById('step_8_heading').innerHTML = "Payment - Securing Entry";
        }
      } else {
        if (this.state.deposit_payment_method_type == 'bank') {
          this.setState({
            payment_A_error_msg: 'Please select a bank account for payment.'
          });
        } else if (this.state.deposit_payment_method_type == 'card') {
          this.setState({
            payment_A_error_msg: 'Please select a credit card for payment.'
          });
        } else {
          this.setState({
            payment_A_error_msg: 'Please select a payment method.'
          });
        }
        
        document.getElementById('step_8_A_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    validatePlatformFeePaymentMethod = async() => {
      
      if(!this.state.exhibitor_billing_enabled_for_show){ return true }
      
      if(!this.state.platform_fee_payment_method || this.state.platform_fee_payment_method <= 0){
        // pay method not selected for platform fee
        this.setState({payment_error_msg: 'Please select a credit card for the platform fee first.'}); 
        document.getElementById('step_platform_fee_warning').style.display = "block";
        return false
      }else{

        try{
            document.getElementById('validate-platform-fee').style.display = "block";
            document.getElementById('secure-payment-button').style.display = "none";
          
            // check if valid card is selected as default payment method
            let result = await axios.get(this.sgl_webservice_iphone+'PreAuthorizeCreditCard',{
                params : {
                  secured_payment_method_fingerprint_id : this.state.platform_fee_payment_method,
                  company_id: -1
                }
            })

            if(result?.data != ''){
                this.setState({payment_error_msg: result.data}); 
                document.getElementById('step_platform_fee_warning').style.display = "block";
                document.getElementById('validate-platform-fee').style.display = "none";
                document.getElementById('secure-payment-button').style.display = "block";
                return false
            }

            console.error("validating payment method message:", result);
        } catch (err) {

          console.error("Error validating payment method:", err);
          this.setState({payment_error_msg: err});
          document.getElementById('step_platform_fee_warning').style.display = "block";
          document.getElementById('validate-platform-fee').style.display = "none";
          document.getElementById('secure-payment-button').style.display = "block";
          return false
        }

        document.getElementById('validate-platform-fee').style.display = "none";
        document.getElementById('secure-payment-button').style.display = "block";
        return true
      }
    }


    payment_selected = () => async(e) => {
      if(this.state.payment_agree){
        
        let hasValidPlatformFee = await this.validatePlatformFeePaymentMethod()
        if(!hasValidPlatformFee){ return }
        if((!this.state.selected_show_details.web_require_credit_card_on_file) || (this.state.selected_payment_method && this.state.selected_payment_method != '-1')){
          document.getElementById('step_8').style.display = "none";
          document.getElementById('step_9').style.display = "block";
          // document.getElementById('change_step_8').style.display = "block";
          document.getElementById('step_8_warning').style.display = "none";
          document.getElementById('step_platform_fee_warning').style.display = "none";
          this.activateBlock("step_9_container");
          this.refreshACHBalance();
          this.getSignatureVarificationList();
        } else {
          this.setState({payment_error_msg: 'Please select a credit card to secure this entry first. '}); 
          document.getElementById('step_8_warning').style.display = "block";
        }
      } else {
        this.setState({payment_error_msg: 'Please agree to the terms and conditions first.'}); 
        document.getElementById('step_platform_fee_warning').style.display = "block";
      }
      this.calculateHeight();
    }
    checkPaymentMethodApiCall(payment_method_id) {
      axios.post(this.sgl_webservice_checkout+'CheckPaymentMethod', null, { params: {
            payment_method_id : payment_method_id,
            customer_id: this.context.company_id,
            cvv: this.state.deposit_cvv,
            team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        }
      })
      .then(results => {

        if(results.data.result) {
          document.getElementById('step_8_A').style.display = "none";
          document.getElementById('step_8_B').style.display = "block"; 
          document.getElementById('step_8_heading').innerHTML = "Payment - Entry Deposit";
        } else {
          this.setState({payment_A_error_msg: results.data.error}); 
          document.getElementById('step_8_A_warning').style.display = "block";
        }
      });
      this.calculateHeight();
    }

    getSignatureVarificationList(){
      var selected_riders_list = this.state.selected_riders_list
      const processedRiders = selected_riders_list.map(rider => {
        if (rider.is_junior && rider.parent_guardian_id) {
          let parent = rider.parents_list.find(p => p.people_id == rider.parent_guardian_id)
          if(!parent && rider.parent_guardian_id == this.state.selected_trainer.people_id){
            parent = this.state.selected_trainer
          }
          
          return parent ?? rider;  // replace with parent ID
        }
        return rider; // keep as is
      });

      console.log(processedRiders)
      var entry_data = {
        shows: {
          show_id: this.state.selected_show
        },
        persons: 
          {
            rider: processedRiders,
            trainer: [this.state.selected_trainer],
            owner: [this.state.selected_owner],
            billTo: [this.state.selected_responsible]

          }
        
      }
      var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(entry_data))));

      this.getDigitalSignatureVerification(encoded_data);
    }

    setDigitalSignatureVerificationData(response_data){
      this.setState({digital_sign_people_list: response_data.people}); 
      this.setState({disallow_agent_signature: response_data.disallow_agent_signature}); 

      document.getElementById('create-entry-please-wait').style.display = "none";
      document.getElementById('continue-signature').style.display = "block";
    }

    // Get digital envelope URL
    async getDigitalEnvelopeLinks(){
      var nextFormError = false;
      var nextFormMsg = '';
      var riders_list = [];
      this.state.selected_riders_list.forEach(rider => {
        if(rider.is_updated || parseInt(rider.people_id) < 0){
          riders_list.push(rider);
        } else {
          riders_list.push({'people_id': rider.people_id});
        }
      });
      const payload={
        show_id: this.state.selected_show,
        persons:{
          rider: this.state.selected_riders_list,
          trainer: [this.state.selected_trainer],
          owner: [this.state.selected_owner],
          prizeMoneyRecipient: [(this.state.selected_prize.is_updated || parseInt(this.state.selected_prize.people_id) < 0)? this.state.selected_prize: this.state.selected_prize],
          billTo: [(this.state.selected_responsible.is_updated || parseInt(this.state.selected_responsible.people_id) < 0)? this.state.selected_responsible: this.state.selected_responsible],
        },
        horse: this.state.selected_horse,
        customer_id: this.context.company_id,
      };

      // Post the request to NestAPI to get URL
      await axios
          .post(this.context.nestApiUrl+'/add-entry/getElectronicDocuments',payload)
          .then((response)=> {
            // update the state with the response
            this.setState({nextform_urls: response.data})
            document.getElementById('step_9').style.display = "none";
            document.getElementById('step_12').style.display = "block";
            document.getElementById('save-electronic-documents-please-wait').style.display = "none";
            document.getElementById('electronic_documents_warning').style.display = "none";
            document.getElementById('continue-electronic-documents').style.display = "block";
          })
          .catch((error)=> {
            nextFormError = true;
            nextFormMsg += "<br/> Process can not be completed, please try again later. "
            this.setState({ nextform_error_msg: nextFormMsg});
            document.getElementById('electronic_documents_warning').style.display = "block";
            console.error("Error getting Electronic Document Link", error)
          })
    }

    //Save Entry
    saveDigitalEnvelope=()=>(e)=>{
      document.getElementById('save-electronic-documents-please-wait').style.display = "block";
      document.getElementById('continue-electronic-documents').style.display = "none";
      this.callCreateEntryAPI();
    }

    signature_selected = () => (e) => {
      // logWPPlugin( 'addentryv2' , "in-signature_selected" , window.location.href , '');
      var digisignerror = false;
      var digisignmsg = '';
      this.state.digital_sign_people_list.forEach(digital_sign_people => {
        if(!digital_sign_people.phone_number_verified && document.getElementById('phone_number_' + digital_sign_people.people_id).value === '' && (!document.getElementById('agent_will_sign_' + digital_sign_people.people_id) || !document.getElementById('agent_will_sign_' + digital_sign_people.people_id).checked)){
          digisignerror = true;
          digisignmsg += "<br/> Please provide valid phone for " + digital_sign_people.fl_name;
        }
      });
        if (!digisignerror) {
          document.getElementById('create-entry-please-wait').style.display = "block";
          document.getElementById('continue-signature').style.display = "none";
          if (this.state.acquire_add_entry_tax_info){
            this.activateBlock("step_12_container");
            this.getDigitalEnvelopeLinks();  //get envelope URL
          }
          else {
            // logWPPlugin( 'addentryv2' , "before-callCreateEntryAPI" , window.location.href , '');
            this.callCreateEntryAPI();
          }
        } else {
          // logWPPlugin( 'addentryv2' , "error-signature_selected" , window.location.href , digisignmsg);
          this.setState({digisign_error_msg: digisignmsg}); 
          document.getElementById('step_9_warning').style.display = "block";
          document.getElementById('create-entry-please-wait').style.display = "none";
          document.getElementById('continue-signature').style.display = "block";
        }
        this.calculateHeight();
    }

    callCreateEntryAPI(){
      var horse = this.state.selected_horse;
      horse.stable_notes = this.state.notes;
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
          'rider_id':s.rider_id,
          'rider':s.rider_name,
        })
      });
      var riders_list = [];
      var parents_list = [];
      this.state.selected_riders_list.forEach(rider => {
        if(rider.is_updated || parseInt(rider.people_id) < 0){
          riders_list.push(rider);
        } else {
          riders_list.push({'people_id': rider.people_id, 'parent_guardian_id': rider.parent_guardian_id??0});
        }
        if(rider.parent_guardian_id && rider.parent_guardian_id != 0){
          let parent_guardian = rider.parents_list?.find(p => p.people_id == rider.parent_guardian_id)
          if(parent_guardian){
            if(parseInt(parent_guardian.people_id) < 0){
              parents_list.push(parent_guardian);
            } else {
              parents_list.push({'people_id': parent_guardian.people_id});
            }
            // parents_list.push(parent_guardian)
          }
        }
      });

      var show_fees = this.state.selected_showfees;
      if(this.state.selected_donation) {
        show_fees.push(this.state.selected_donation);
      }

      let formattedArrivalDate = ''
      if(this.state.order_delivery_arrival_date && this.state.order_delivery_arrival_date != ''){
          // format the date to avoid the timezone offset issues
          const date = new Date(this.state.order_delivery_arrival_date);
          const year = date.getFullYear();
          const month = ('0' + (date.getMonth() + 1)).slice(-2);
          const day = ('0' + date.getDate()).slice(-2);
          formattedArrivalDate = `${year}-${month}-${day}`;
      }

      let platform_fee_payment_method = '-1'
      let platform_fee_login_id = 0

      if(this.state.exhibitor_billing_enabled_for_show){
        platform_fee_payment_method = this.state.platform_fee_payment_method
        platform_fee_login_id = this.state.platform_fee_login_id
      }
      
      var entry_data = {
        shows: {
          show_id: this.state.selected_show
        },
        horse: horse,
        persons: 
          {
            rider: riders_list,
            parents: parents_list,
            trainer: [(this.state.selected_trainer.is_updated || parseInt(this.state.selected_trainer.people_id) < 0)?this.state.selected_trainer:{'people_id': this.state.selected_trainer.people_id}],
            owner: [(this.state.selected_owner.is_updated || parseInt(this.state.selected_owner.people_id) < 0)?this.state.selected_owner:{'people_id': this.state.selected_owner.people_id}],
            prizeMoneyRecipient: [(this.state.selected_prize.is_updated || parseInt(this.state.selected_prize.people_id) < 0)?this.state.selected_prize:{'people_id': this.state.selected_prize.people_id}],
            billTo: [(this.state.selected_responsible.is_updated || parseInt(this.state.selected_responsible.people_id) < 0)?this.state.selected_responsible:{'people_id': this.state.selected_responsible.people_id}],
            parent_guardian: [{'people_id': this.state.selected_guardian.people_id}]
          },
          secure_payment_method_id: this.state.selected_payment_method,
          secure_payment_method_type: this.state.selected_payment_method_type,
          deposit_amount: this.state.deposit_amount,
          deposit_cvv: this.state.deposit_cvv,
          classes: selected_class_ids,
          order_supplies: show_fees,
          platform_fee_payment_method,
          platform_fee_login_id,
          // signature_persons: 

          order_delivery: {
            phone_number: this.state.order_delivery_phone_number.replace(/\D/g, ""),
            barn_location: this.state.order_delivery_barn_location,
            stall_location: this.state.order_delivery_stall_location,
            arrival_date: formattedArrivalDate,
            arrival_time: this.state.order_delivery_arrival_time,
            trainer_name: this.state.order_delivery_trainer_name,
          },
          series_shows: [],
      }
      if(this.state.stall_check_in_info.stall_collect_checkin_checkout_time === '1' && this.checkIfStallOrdered()){
        entry_data.stall_checkin_checkout_data = this.state.stall_checkin_checkout_data
      }

      //Add selected series shows list and deposits information in post data for entry
      this.state.series_shows.map((data, index) => {
        if(data.selected){
          entry_data.series_shows.push({
            show_id: data.show_id,
            amount: parseFloat(data.amount),
          })
        }
      });

      var signature_persons = [];
      this.state.digital_sign_people_list.forEach(digital_sign_people => {
        var digi_sign_data = {};
        digi_sign_data.people_id = digital_sign_people.people_id;
        if (!digital_sign_people.phone_number_verified) {
          digi_sign_data.phone = document.getElementById('phone_number_' + digital_sign_people.people_id).value;
        } else {
          digi_sign_data.phone = digital_sign_people.phone;
        }
        digi_sign_data.agent_will_sign = (document.getElementById('agent_will_sign_' + digital_sign_people.people_id) && document.getElementById('agent_will_sign_' + digi_sign_data.people_id).checked)?true:false;
        signature_persons.push(digi_sign_data);
      });
      entry_data.signature_persons = signature_persons;

      if(this.state.selected_deposit_method !== '-1') {
        entry_data.deposit_payment_method_id = this.state.selected_deposit_method;
        entry_data.deposit_payment_method_type = this.state.deposit_payment_method_type;
      }

      console.log(entry_data)

      // deposit_payment_method_id: this.state.selected_deposit_method == '-1'? null : this.state.selected_deposit_method,

      // var encoded_data = btoa(JSON.stringify(this.state.entry_data));
      // logWPPlugin( 'addentryv2' , "before-btoa" , window.location.href , JSON.stringify(entry_data));
      var encoded_data = btoa(unescape(encodeURIComponent(JSON.stringify(entry_data))));
      // logWPPlugin( 'addentryv2' , "encoded_data" , window.location.href , encoded_data);

      this.SaveNewEntry(encoded_data);

      // remove following lines when calling above api
        // document.getElementById('step_9').style.display = "none";
        // document.getElementById('change_step_9').style.display = "block";
        // document.getElementById('step_10').style.display = "block";
        // this.activateBlock("step_10_container");

    }
    handleSaveNewEntryData(response_data) {
      if(response_data.success){
        document.getElementById('step_9').style.display = "none";
        document.getElementById('step_12').style.display = "none";
        // document.getElementById('change_step_9').style.display = "block";
        document.getElementById('step_10').style.display = "block";
        for (var i = 1; i <= 9; i++) {
          document.getElementById('change_step_'+i).style.display = "none";
        }
        if (this.state.donations_list.length>0) {
          document.getElementById('change_step_11').style.display = "none";
        }

        this.activateBlock("step_10_container");
        window.removeEventListener('beforeunload', this.handleLeavePage);
      } else {
        document.getElementById('create-entry-please-wait').style.display = "none";
        document.getElementById('continue-signature').style.display = "block";
        if (response_data.error_step === 'DigitalSignatureVerification'){
          this.setState({create_entry_error_msg: response_data.error}); 
          document.getElementById('step_10_warning').style.display = "block";
          this.activateBlock('step_10_container');
        } else { // incase error is related to any previous step
          document.getElementById('step_9').style.display = "none";
          if (response_data.error_step === 'CheckForWebPayments'){
            this.setState({deposit_cvv: ''}); 
            document.getElementById('step_8').style.display = "block";
            this.activateBlock('step_8_container');
            if(this.state.selected_show_details.web_deposit_required === '1' && this.state.fee_for_entry.deposit_amount > 0){
              document.getElementById('step_8_A').style.display = "block";
              document.getElementById('step_8_B').style.display = "none";
              document.getElementById('step_8_heading').innerHTML = "Payment - Entry Deposit";
              this.setState({payment_A_error_msg: response_data.error}); 
              document.getElementById('step_8_A_warning').style.display = "block";
            }else {
            // } else if(this.state.selected_show_details.web_require_credit_card_on_file){
              document.getElementById('step_8_B').style.display = "block";
              document.getElementById('step_8_A').style.display = "none";
              document.getElementById('step_8_heading').innerHTML = "Payment - Securing Entry";
              this.setState({payment_error_msg: response_data.error}); 
              document.getElementById('step_8_warning').style.display = "block";
            }

          } else if (response_data.error_step === 'WebPayment'){
            this.setState({deposit_cvv: ''}); 
            document.getElementById('step_8').style.display = "block";
            this.activateBlock('step_8_container');
            if (response_data.error_step_number == "step_8_A") {
              document.getElementById('step_8_A').style.display = "block";
              document.getElementById('step_8_B').style.display = "none";
              document.getElementById('step_8_heading').innerHTML = "Payment - Entry Deposit";
              this.setState({payment_A_error_msg: response_data.error}); 
              document.getElementById('step_8_A_warning').style.display = "block";
            } else {
              document.getElementById('step_8_B').style.display = "block";
              document.getElementById('step_8_A').style.display = "none";
              document.getElementById('step_8_heading').innerHTML = "Payment - Securing Entry";
              this.setState({payment_error_msg: response_data.error}); 
              document.getElementById('step_8_warning').style.display = "block";
            }
          }

        }
      }
      this.calculateHeight();
    }


    changeSelection = (step_number) => (e) => {

      var selections = document.getElementsByClassName("add-entry-div");
      for (var i = 0; i < selections.length; i++) {
        selections[i].style.display = "none";
      }
      for (var i = step_number; i <= 9; i++) {
        document.getElementById('change_step_'+i).style.display = "none";
      }
      if (this.state.donations_list.length>0 && (step_number < 6 || step_number === 11)) {
        document.getElementById('change_step_11').style.display = "none";
      }

      // custom handle to call api on select people step
      if(step_number == 3) {
        this.getPeopleList();
      }
        document.getElementById('step_'+step_number).style.display = "block";
        this.activateBlock('step_'+step_number+'_container');
        this.calculateHeight();
    }

    onPersonSelect(e, section_name){
      // if(e.target.value > 0){
      //   document.getElementById('detail_'+section_name).style.display = "block";
      // }

      if (e.target.value !== '-4') {
        
        document.getElementById('detail_'+section_name).style.display = "block";
        var person = this.state.updated_people_list.find(el => el.people_id === e.target.value);
        if(person === undefined) {
          person = this.state.people_list.find(el => el.people_id === e.target.value);
        }
        this.setPersonState(person, section_name);
        // if (section_name == 'rider'){
        //   this.setState({
        //     selected_rider : person,
        //   });
        // } else if (section_name == 'trainer'){
        //   this.setState({
        //     selected_trainer : person,
        //   });
        // } else if (section_name == 'owner'){
        //   this.setState({
        //     selected_owner : person,
        //   });
        // } else if (section_name == 'prize'){
        //   this.setState({
        //     selected_prize : person,
        //   });
        // } else if (section_name == 'responsible'){
        //   this.setState({
        //     selected_responsible : person,
        //   });
        // }
        // this.props.onShowChange (e.target.value);
        
      } else {
        document.getElementById('detail_'+section_name).style.display = "none";
        if (section_name === 'rider'){
          var prev_rider = this.state.selected_rider;
          this.dropRiderClasses(prev_rider);
          this.setState({
            selected_rider : {},
          });
        } else if (section_name === 'trainer'){
          this.setState({
            selected_trainer : {},
            order_delivery_trainer_name: ''
          });
        } else if (section_name === 'owner'){
          this.setState({
            selected_owner : {},
          });
        } else if (section_name === 'prize'){
          this.setState({
            selected_prize : {},
          });
        } else if (section_name === 'responsible'){
          this.setState({
            selected_responsible : {},
          });
        } else if (section_name === 'rider2'){
          var prev_rider = this.state.selected_rider2;
          this.dropRiderClasses(prev_rider);
          this.setState({
            selected_rider2 : {},
          });
        } else if (section_name === 'rider3'){
          var prev_rider = this.state.selected_rider3;
          this.dropRiderClasses(prev_rider);
          this.setState({
            selected_rider3 : {},
          });
        }
      }
      this.calculateHeight();
    }

    setPerson = (event) => {
      const person = this.state.people_search_list.find(el => el.people_id === event.currentTarget.value);
      
      // this.setPersonState(person, this.state.people_search_field);
      this.setState({
        selected_search_person : person,
      });

    }
    updateOtherSelectedRecords(person, section_name){
      if (section_name.toLowerCase() != 'rider' && this.state.selected_rider.people_id === person.people_id){
        this.setState ({
          selected_rider : person,
        });
      }
      if (section_name.toLowerCase() != 'trainer' && this.state.selected_trainer.people_id === person.people_id){
        this.setState({
          selected_trainer : person,
        });
      }
      if (section_name.toLowerCase() != 'owner' && this.state.selected_owner.people_id === person.people_id){
        this.setState({
          selected_owner : person,
        });
      }
      if (section_name.toLowerCase() != 'prize' && this.state.selected_prize.people_id === person.people_id){
        this.setState({
          selected_prize : person,
        });
      } 
      if (section_name.toLowerCase() != 'responsible' && this.state.selected_responsible.people_id === person.people_id){
        this.setState({
          selected_responsible : person,
        });
      } 
      if (section_name.toLowerCase() != 'rider2' && this.state.selected_rider2.people_id === person.people_id){
        this.setState({
          selected_rider2 : person,
        });

      }
      if (section_name.toLowerCase() != 'rider3' && this.state.selected_rider3.people_id === person.people_id){
        this.setState({
          selected_rider3 : person,
        });
      }
    }


    setPersonState(person, section_name){
      if (section_name.toLowerCase() === 'rider'){
        var prev_rider = this.state.selected_rider;
        this.dropRiderClasses(prev_rider);
        this.setState(prevState => ({selected_rider : person}));
        if (person.is_junior) {
          this.setState({ loading_parents: true });
          this.getLinkedParents(person.people_id, this.context.company_id)
          .then(res => {
            const { linked_people = [], pending_linked_people = [] } = res.data || {};
            const allParents = [...linked_people, ...pending_linked_people];
            // check and add trainer in parent
            
            const primaryParent = allParents.find(p => p.is_primary == 1) || {};
            person.parents_list = allParents
            person.parent_guardian_id = primaryParent.people_id ?? 0
            this.setState(prevState => ({
              // selected_riders_list: [...prevState.selected_riders_list, person],
              selected_rider : person,
              loading_parents: false,
            }));
        })
          .catch(err => {
              console.error('Error fetching linked parents:', err);
              this.setState({ loading_parents: false }); 
          });
        }  else {
          this.setState(prevState => ({
            // selected_riders_list: [...prevState.selected_riders_list, person],
            selected_rider : person,
          }));
        }
      } else if (section_name.toLowerCase() === 'trainer'){
        this.setState({
          selected_trainer : person,
          order_delivery_trainer_name : person.fl_name,
        });
      } else if (section_name.toLowerCase() === 'owner'){
        this.setState({
          selected_owner : person,
        });
      } else if (section_name.toLowerCase() === 'prize'){
        this.setState({
          selected_prize : person,
        });
      } else if (section_name.toLowerCase() === 'responsible'){
        this.setState({
          selected_responsible : person,
        });
      } else if (section_name.toLowerCase() === 'rider2'){
        var prev_rider = this.state.selected_rider2;
        this.dropRiderClasses(prev_rider);
        this.setState(prevState => ({selected_rider2 : person}));
        if (person.is_junior) {
          this.getLinkedParents(person.people_id, this.context.company_id)
          .then(res => {
            const { linked_people = [], pending_linked_people = [] } = res.data || {};
            const allParents = [...linked_people, ...pending_linked_people];
            const primaryParent = allParents.find(p => p.is_primary == 1) || {};
            person.parents_list = allParents
            person.parent_guardian_id = primaryParent.people_id ?? 0
            this.setState({ selected_rider2 : person});
        })
          .catch(err => {
              console.error('Error fetching linked parents:', err);
          });
        }
        else {
          this.setState(prevState => ({selected_rider2 : person}));
        }  
        // this.dropRiderClasses(prev_rider);

      } else if (section_name.toLowerCase() === 'rider3'){
        var prev_rider = this.state.selected_rider3;
        this.dropRiderClasses(prev_rider);
        this.setState(prevState => ({selected_rider3 : person}));
        // this.dropRiderClasses(prev_rider);
        if (person.is_junior) {
          this.getLinkedParents(person.people_id, this.context.company_id)
          .then(res => {
            const { linked_people = [], pending_linked_people = [] } = res.data || {};
            const allParents = [...linked_people, ...pending_linked_people];
            const primaryParent = allParents.find(p => p.is_primary == 1) || {};
            person.parents_list = allParents
            person.parent_guardian_id = primaryParent.people_id ?? 0
            this.setState({ selected_rider3 : person});
          })
          .catch(err => {
              console.error('Error fetching linked parents:', err);
          });
        }
        else {
          this.setState(prevState => ({selected_rider3 : person}));
        }  

      } else if (section_name.toLowerCase() === 'parent') {
        const rider = this.state.selected_rider;
        if (!rider) return;

        if (!Array.isArray(rider.parents_list)) {
          rider.parents_list = [];
        }
        const formattedParent = {...person, name: person.name ||person.fl_name ||person.lf_name,status: 'pending',};
        rider.parents_list.push(formattedParent);
        rider.parent_guardian_id = formattedParent.people_id;
        this.setState({ selected_rider: rider });

      } else if (section_name.toLowerCase() === 'parent2') {
        const rider = this.state.selected_rider2;
        if (!rider) return;

        if (!Array.isArray(rider.parents_list)) {
          rider.parents_list = [];
        }
        const formattedParent = {...person, name: person.name ||person.fl_name ||person.lf_name ,status: 'pending'};
        rider.parents_list.push(formattedParent);
        rider.parent_guardian_id = formattedParent.people_id;
        this.setState({ selected_rider2: rider });

      } else if (section_name.toLowerCase() === 'parent3') {
        const rider = this.state.selected_rider3;
        if (!rider) return;

        if (!Array.isArray(rider.parents_list)) {
          rider.parents_list = [];
        }
        const formattedParent = {...person, name: person.name ||person.fl_name ||person.lf_name,status: 'pending'};
        rider.parents_list.push(formattedParent);
        rider.parent_guardian_id = formattedParent.people_id;
        this.setState({ selected_rider3: rider });
      }
    }



    updateHorseName(evt) {
      this.setState({
        horse_name: evt.target.value
      });
    }

    updateHorseMembership(evt) {
      this.setState({
        horse_membership_no: evt.target.value
      });
    }

    updateNotes(evt) {
      this.setState({
        notes: evt.target.value
      });
    }

    updateFirstName(evt) {
      this.setState({
        people_first_name: evt.target.value
      });
    }

    updateLastName(evt) {
      this.setState({
        people_last_name: evt.target.value
      });
    }

    updatePeopleMembership(evt) {
      this.setState({
        people_membership_no: evt.target.value
      });
    }

    onDivisionSelect(e){
      this.setState({
        division_to_add: e.target.value
      });
    }

    onClassSelect(e){
      this.setState({
        class_to_add: e.target.value
      });
    }

    onClassRiderSelect(e){
      // const person = this.state.people_list.find(el => el.people_id === e.target.value);
      this.setState({
        class_rider_id: e.target.value
      });
    }

    updateDivisionSearch(evt) {
      this.setState({
        division_search: evt.target.value
      });
    }

    filterDivisionsList = () => (e) => {
      
      const divisions = this.state.divisions_list.filter((div) => div.name.toLowerCase().includes(this.state.division_search.toLowerCase()))
      // var class_ids = classes.map(s=>s.class_id);
      this.setState({
        divisions_filtered_list: divisions
      });
    }

    addDivision = () => (e) => {
      if (this.state.class_rider_id != '-4'){
        document.getElementById('step_4_warning').style.display = "none";

        // check rider age and parent
        let rider_parents_check = this.checkRiderParentsForClass(this.state.class_rider_id)
        if(rider_parents_check){
          if (this.state.division_to_add != '-1'){
            this.checkSelectDivisionToAdd( this.state.selected_show, this.state.division_to_add, this.state.class_rider_id, this.state.selected_horse.horse_id);
            this.setState({
              division_to_add: '-1'
            });
          }
        } else {
          this.setState({
            class_selection_error_msg: 'Verified parent is required to add divisions for junior riders.'
          });
          
          document.getElementById('step_4_warning').style.display = "block";
        }
      } else {
        this.setState({
          class_selection_error_msg: 'Please select the Rider.'
        });
        
        document.getElementById('step_4_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    addClass = () => (e) => {
      if (this.state.class_rider_id != '-4'){
        document.getElementById('step_4_warning').style.display = "none";

        // check rider age and parents data
        let rider_parents_check = this.checkRiderParentsForClass(this.state.class_rider_id)
        if(rider_parents_check){

          if (this.state.class_to_add != '-1'){
            this.checkSelectClassToAdd( this.state.selected_show, this.state.class_to_add, this.state.class_rider_id, this.state.selected_horse.horse_id);
            this.setState({
              class_to_add: '-1'
            });
          }
        } else {
          this.setState({
            class_selection_error_msg: 'Verified parent is required to add classes for junior riders.'
          });
          
          document.getElementById('step_4_warning').style.display = "block";
        }
      } else {
        this.setState({
          class_selection_error_msg: 'Please select the Rider.'
        });
        
        document.getElementById('step_4_warning').style.display = "block";
      }
      this.calculateHeight();
    }

    setClassResponseData(response_data){
      var error_msg = '';
      var processed_classes = [];
      for(let i=0; i<response_data.length; i++){
        if (response_data[i].required && response_data[i].division_id && response_data[i].division_id > 0) {
          var already_processed = processed_classes.find(c => c.division_id === response_data[i].division_id);

          if(!already_processed){
            var div_classes = response_data.filter((c) => c.division_id === response_data[i].division_id);
            var errored_div = div_classes.find(c => c.success === false);
            if(errored_div){
              processed_classes.push(errored_div);
            } else {
              processed_classes = processed_classes.concat(div_classes);
            }
          }

        } else {
          processed_classes.push(response_data[i]);
        }
      }
      processed_classes.forEach(class_response => {
          if (class_response.success) {
            var classs = this.state.classes_list.find(c => c.class_id === class_response.class_id);
            const class_already_added = this.state.selected_classes.find(c => c.class_id === class_response.class_id);
            const rider = this.state.people_list.find(c => c.people_id === class_response.rider_id);

            if (!class_already_added){
              classs.rider_id = class_response.rider_id;
              classs.rider_name = rider.fl_name;
              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, classs],
                // class_to_add: 0
              }))
            }
          } else {
            error_msg += class_response.error + ' \n';
          }
      });
      if (error_msg != ''){
        this.setState({
          class_selection_error_msg: error_msg
        });
        
        document.getElementById('step_4_warning').style.display = "block";
      }
      this.calculateHeight();
    }
    setDivisionResponseData(response_data){
      var error_msg = '';
      response_data.forEach(class_response => {
        if (!class_response.success) {
          error_msg += class_response.error + ' \n';
        }
      });
      if (error_msg != ''){
        this.setState({
          class_selection_error_msg: error_msg
        });
        
        document.getElementById('step_4_warning').style.display = "block";
      } else {
        response_data.forEach(class_response => {
          
        //   if (class_response.success) {
            var classs = this.state.classes_list.find(c => c.class_id === class_response.class_id);
            const class_already_added = this.state.selected_classes.find(c => c.class_id === class_response.class_id);
            const rider = this.state.people_list.find(c => c.people_id === class_response.rider_id);
            

            if (!class_already_added){
              classs.rider_id = class_response.rider_id;
              classs.rider_name = rider.fl_name;
              this.setState(prevState => ({
                selected_classes: [...prevState.selected_classes, classs],
                // class_to_add: 0
              }))
            }
          
        });
      }
      this.calculateHeight();
    }
    updateEntryNumbers(evt) {
      var numbers = evt.target.value;
      numbers = numbers.split(/[ ,]+/).map(item => item.trim());

      this.setState({
        entry_numbers: numbers
      });
    }

    checkRiderParentsForClass(rider_id){
      let riders_list = this.state.selected_riders_list
      let class_rider = riders_list.find(r => r.people_id == rider_id)
      if (this.state.restrict_junior_riders && class_rider.is_junior){
        if (class_rider.parent_guardian_id != 0){
          // check if parent is verified
          let parent_guardian = class_rider.parents_list?.find(p => p.people_id == class_rider.parent_guardian_id) // AR: todo
          if((parent_guardian && parent_guardian.peoplexpeople_id > 0) || class_rider.parent_guardian_id == this.state.selected_trainer.people_id){
            return true;
          } else {
            return false
          }
        } else {
          return false;
        }
      }
      return true;
    }
    
    addClassesByNumber = () => (e) => {
      if (this.state.class_rider_id != '-4'){
        document.getElementById('step_4_warning').style.display = "none";

        // check rider age and parents data
        let rider_parents_check = this.checkRiderParentsForClass(this.state.class_rider_id)
        if(rider_parents_check){

          if (this.state.entry_numbers && this.state.entry_numbers != ''){
            const classes = this.state.classes_list.filter((classs) => this.state.entry_numbers.includes(classs.number))
            var class_ids = classes.map(s=>s.class_id);
            this.checkSelectClassToAdd( this.state.selected_show, class_ids.toString(), this.state.class_rider_id, this.state.selected_horse.horse_id);
            // this.setState({
            //   class_to_add: 0
            // });
          }
        } else {
          this.setState({
          class_selection_error_msg: 'Verified parent is required to add classes for junior riders.'
        });
        
        document.getElementById('step_4_warning').style.display = "block";
        }
      } else {
        this.setState({
          class_selection_error_msg: 'Please select the Rider.'
        });
        
        document.getElementById('step_4_warning').style.display = "block";
      }
      this.calculateHeight();
    }
    dropClass = (class_id) => {
      // const classs = this.state.selected_classes.find(c => c.class_id === this.state.class_to_add);

      this.setState(prevState => ({
        selected_classes: prevState.selected_classes.filter(c => c.class_id !== class_id)
      }));

    }

    setDropClassResponseData(response_data){
      response_data.class_ids.forEach(class_id => {
        this.dropClass(class_id);
      })
    }

    dropClassById = (class_id) => {
      var selected_class_ids = this.state.selected_classes.map((s)=>{
        return ({
          'class_id':s.class_id,
        })
      });
      this.checkSelectClassToDrop( this.state.selected_show, JSON.stringify(selected_class_ids), class_id);
    }

    dropClassesByNumber = () => (e) => {
      
      if (this.state.entry_numbers && this.state.entry_numbers != ''){
        const classes = this.state.classes_list.filter((classs) => this.state.entry_numbers.includes(classs.number))
        var class_ids = classes.map(s=>s.class_id);
        var selected_class_ids = this.state.selected_classes.map((s)=>{
          return ({
            'class_id':s.class_id,
          })
        });
        class_ids.forEach(class_id => {
          this.checkSelectClassToDrop( this.state.selected_show, JSON.stringify(selected_class_ids), class_id);
        });
      }

    }

    dropRiderClasses(person){
      if(person && JSON.stringify(person) !== '{}' && person.people_id !== '-4'){
        const classes = this.state.selected_classes.filter((classs) => person.people_id === classs.rider_id)
        classes.forEach(classs => {
          this.dropClass(classs.class_id);
        })
      }
    }
    
    onOrderSupplySelect(e){
      this.setState({
        order_supply_to_add: e.target.value,
        amount:1
      });
    }
    updateAmount(evt) {
      // this.setState({
      //   amount: evt.target.value
      // });
      const re = /^[0-9\b]+$/;
      if (evt.target.value === '' || re.test(evt.target.value)) {
      // if (evt.target.value != '' && !Number(evt.target.value)) {

          this.setState({
            amount: evt.target.value
          });
      }
    }
    
    addOrderSupply = () => (e) => {
      if (this.state.order_supply_to_add != '-1'){
        if (this.state.amount && this.state.amount >= 1){
          if (this.state.amount <= 999){
            document.getElementById('step_5_warning').style.display = "none";
            this.checkOrderSupplyToAdd(this.state.selected_show, this.state.order_supply_to_add, this.state.amount);
          } else {
            this.setState({
              order_supply_error_msg: 'Amount must not be greater than 999.'
            });
            document.getElementById('step_5_warning').style.display = "block";
          }
          
        } else {
          this.setState({
            order_supply_error_msg: 'Quantity must not be 0 or null.'
          });
          document.getElementById('step_5_warning').style.display = "block";
        }
      }
      this.calculateHeight();
    }
    setOrderSupplyResponseData(response_data, showfees_id){
      if(response_data.success){
          const show_fee = this.state.order_supply_list.find(s => s.showfees_id === showfees_id);
          const fees_already_added = this.state.selected_showfees.find(c => c.showfees_id === showfees_id);
          if (!fees_already_added){
            show_fee.quantity = this.state.amount;
            show_fee.total = this.state.amount * show_fee.unit_price;
            this.setState(prevState => ({
              selected_showfees: [...prevState.selected_showfees, show_fee],
              // order_supply_to_add: '-1'
            }))
          }
      } else {
        this.setState({
          order_supply_error_msg: response_data.error
        });
        document.getElementById('step_5_warning').style.display = "block";
      }
      this.calculateHeight();
    }
    setFeeForEntryResponseData(response_data){
      //Set order delivery information >>>
      let order_delivery_display_phone = this.state.order_delivery_display_phone.trim();
      if(order_delivery_display_phone === ''){ //Not already set
        if(this.state.userData.phonenumber_verified){
          order_delivery_display_phone = '+' + this.state.userData.phonenumber.replace(/\D/g, "");
        }
      }
      //Set order delivery information <<<

      this.setState({
        fee_for_entry: response_data,
        order_delivery_phone_number: '',
        order_delivery_display_phone: order_delivery_display_phone,
        deposit_amount: response_data.deposit_amount.toFixed(2)
      });
    }
    dropOrderSupply = (showfee_id) => {
      // const classs = this.state.selected_classes.find(c => c.class_id === this.state.class_to_add);

      this.setState(prevState => ({
        selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== showfee_id)
      }));
      var stalls = this.state.selected_showfees.filter(c => c.is_stall_fee && c.showfees_id !== showfee_id);
      if(stalls.length === 0){
        this.setState({
          stall_checkin_checkout_data: {
            "checkin_date": '',
            "checkin_time": '',
            "checkout_date": '',
            "checkout_time": ''
          }
        });
      }
      this.setState({
        order_supply_error_msg: ''
      });
      document.getElementById('step_5_warning').style.display = "none";

    }

    getTotalFeePrice(){
      return this.state.selected_showfees.reduce(function(prev, current) {
        return prev + +current.total
      }, 0);
    }

    checkSeriesShowChange(evt) {
      let show_id = evt.target.getAttribute('show_id');
      let series_shows = this.state.series_shows;

      series_shows.map((data, index) => {
        if(data.show_id === show_id){
          if(data.has_error){
            series_shows[index].selected = false;
          }
          else if(this.state.fee_for_entry.require_all_shows){
            series_shows[index].selected = true;
          }
          else{
            series_shows[index].selected = evt.target.checked;
          }
        }
      });
      this.calculateTotalSeriesPayment(series_shows);
    }
    
    updateSeriesShowDeposit(evt) {
      let show_id = evt.target.getAttribute('show_id');
      let series_shows = this.state.series_shows;

      series_shows.map((data, index) => {
        if(data.show_id === show_id){
          let value = evt.target.value.trim();
          if(value==="" || isNaN(value) || parseFloat(value) < data.deposit_amount){
            series_shows[index].amount = data.deposit_amount;
          }else{
            series_shows[index].amount = value;
          }
        }
      });
      this.calculateTotalSeriesPayment(series_shows);
    }

    calculateTotalSeriesPayment(series_shows){
      if(!series_shows){
        series_shows = this.state.series_shows;
      }

      let series_shows_amount = 0;
      let series_shows_service_fee_amount = 0;
      let series_shows_ach_service_fee_amount = 0;
      series_shows.map((data, index) => {
        if(data.has_error){
          series_shows[index].selected = false;
        }
        else if(this.state.fee_for_entry.require_all_shows){
          series_shows[index].selected = true;
        }

        if(series_shows[index].selected && parseFloat(data.amount) > 0){
          series_shows_amount += parseFloat(data.amount);

          if(data.credit_card_service_fee && data.credit_card_service_fee_id > 0 && data.credit_card_service_fee_percent > 0 && data.credit_card_service_fee_percent <= 100){
            series_shows_service_fee_amount += parseFloat(data.amount) * (data.credit_card_service_fee_percent/100);
          }

          if(data.ach_service_fee && data.ach_service_fee_id > 0 && this.state.ach_service_fee_percent > 0 && this.state.ach_service_fee_percent <= 100){
            series_shows_ach_service_fee_amount += parseFloat(data.amount) * (this.state.ach_service_fee_percent/100);
          }
        }
      });
      
      this.setState({
        series_shows: series_shows,
        series_shows_amount: series_shows_amount.toFixed(2),
        series_shows_service_fee_amount: series_shows_service_fee_amount.toFixed(2),
        series_shows_ach_service_fee_amount: series_shows_ach_service_fee_amount.toFixed(2),
      });
    }

    updateDepositAmount(evt) {
      if(evt.target.value === '' || (!isNaN(+evt.target.value) && parseFloat(evt.target.value) < 1000000)){
        this.setState({
          deposit_amount: evt.target.value
        });
      }
    }

    setDepositAmount() {
      if (this.state.deposit_amount >= this.state.fee_for_entry.deposit_amount) {
        if(this.state.deposit_amount > 999999.99){
          this.setState({
            deposit_amount: 999999.99
          });
        } else {
          if (this.state.deposit_amount === '' || isNaN(this.state.deposit_amount)){
            this.setState({
              deposit_amount: 0.00.toFixed(2)
            });
          } else {
            this.setState({
              deposit_amount: parseFloat(this.state.deposit_amount).toFixed(2)
            });
          }
        }
      } else {
        this.setState({
          deposit_amount: this.state.fee_for_entry.deposit_amount.toFixed(2)
        });
      } 
    }    

    updateDepositCvv(evt){
        const re = /^[0-9\b]+$/;
        if (evt.target.value === '' || re.test(evt.target.value)) {
        // if (evt.target.value != '' && !Number(evt.target.value)) {

            this.setState({
                deposit_cvv: evt.target.value
            });
        }
      
    }

    updateOrderDeliveryPhone(value, index ){
      this.setState({
        order_delivery_display_phone: value,
      });
    }

    updateOrderDeliveryBarnLocation(evt){
      this.setState({
        order_delivery_barn_location: evt.target.value
      });
    }

    updateOrderDeliveryStallLocation(evt){
      this.setState({
        order_delivery_stall_location: evt.target.value
      });
    }

    updateOrderDeliveryArrivalTime(evt){
      this.setState({
        order_delivery_arrival_time: evt.target.value
      });
    }

    updateOrderDeliveryTrainerName(evt){
      this.setState({
        order_delivery_trainer_name: evt.target.value
      });
    }

    onPaymentMethodSelect(e) {
      if (e.target.value === 'ManageCards'){
        this.openSelectCardModal();
        this.setState({
          selected_payment_method: '-1',
        });
      } else if (e.target.value === 'AddBankAccount'){
        this.openAddBankModal();
        this.setState({
          selected_payment_method: '-1',
        });
      } else {
        // Determine if it's a card or a bank account
        const selectedOption = e.target.selectedOptions[0]; // Get selected <option>
        const type = selectedOption.getAttribute("data-type"); // Retrieve data-type
        this.setState({
          selected_payment_method_type: type,
        });
        
        this.setState({
          selected_payment_method: e.target.value,
        });
      }
    }

    onSelectedPaymentMethodType(e) {
      this.setState({
        selected_payment_method_type: e.target.value,
        selected_payment_method: '-1',
      });
    }

    onDepositPaymentMethodType(e) {
      this.setState({
        deposit_payment_method_type: e.target.value,
        selected_deposit_method: '-1',
      });
    }

    onDepositMethodSelect(e) {
      if (e.target.value === 'ManageCards'){
        this.openSelectCardModal();
        this.setState({
          selected_deposit_method: '-1',
        });
      } else if (e.target.value === 'AddBankAccount'){
        this.openAddBankModal();
        this.setState({
          selected_deposit_method: '-1',
        });
      } else {
        // Determine if it's a card or a bank account
        const selectedOption = e.target.selectedOptions[0]; // Get selected <option>
        const type = selectedOption.getAttribute("data-type"); // Retrieve data-type
        this.setState({
          deposit_payment_method_type: type,
        });

        this.setState({
          selected_deposit_method: e.target.value,
        });
        if(this.state.selected_show_details.web_require_credit_card_on_file){
          this.setState({
            selected_payment_method: e.target.value,
            selected_payment_method_type: type,
          });
        }
      }
    }
    
    updateDigitalSignaturePhone(value, index ){
      this.state.digital_sign_people_list[index].phone = value;
      this.setState({digital_sign_people_list: this.state.digital_sign_people_list});
    }

    paymentAgreeChange(e) {
      this.setState({
        payment_agree: e.target.checked
      });
    }

    getUserData(){
      axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if(response.data.user && response.data.user != null){
          this.setState({
            userData : response.data.user,
          });
        }else{
        }
        window.onbeforeunload = "Are you sure you want to leave?";
        window.addEventListener('beforeunload', this.handleLeavePage);
      }, (error) => {
      });
    }

    getMembershipNumber(){
      var membership_no = '';
      if(this.state.governing_organization==="USEF"){
        membership_no = this.state.selected_horse.usef_no;
      }
      else if(this.state.governing_organization==="FEI"){
        membership_no = this.state.selected_horse.fei_id;
      }
      else{
        membership_no = this.state.selected_horse.ec_ppn;
      }
      if (membership_no === ''){
        membership_no = 'N/A';
      }
      return membership_no;
    }

    getMembershipNumberToUpdate(org, memberships_list = []){
      const membership = memberships_list.find(mem => mem.organization_code === org);
      if (membership){
        return membership.membership_number;
      }
      return;
    }

    getPeopleMembershipNumber(person, gov_org){
      
      var membership_no = '';
      if (person && person.memberships && person.memberships.length > 0) {
        person.memberships.forEach(membership => {
          if(membership.organization_code === gov_org && membership.membership_number != ''){
            membership_no = membership.membership_number;
          }
        });
  
        // membership_no = person.memberships[0].membership_number;
      }
      if (membership_no === ''){
        membership_no = 'N/A';
      }
      return membership_no;
    }

    getMembershipWarning(memberships = []){
      var membership_warning = false;
      memberships.forEach(membership => {
        if(!membership.membership_number || membership.membership_number === ''){
          membership_warning = true;
        }
      });
      return membership_warning;
    }

    getHasMissingInfo(object, mandatory_fields){
      var has_missing_info = false;
      mandatory_fields.forEach(field => {
        if(!object[field] || object[field] === ''){
          has_missing_info = true;
        }
      });
      return has_missing_info;
    }

    getHorseUpdateMessage(horse){
      if (this.getMembershipWarning(horse.memberships)){
        return 'Click here to add this membership.';
      } else if (this.getHasMissingInfo(horse, ["name", "sex", "height"])){
        return 'There is some missing information on file. Click here to update this horse.';
      }  else {
        return 'Click here to update this horse.';
      }
    }

    openUpdateHorseModel = (horse) => (e) => { 
      this.setState({
        is_open_horse_modal: true,
        add_horse_error_msg: '',
        new_horse_data: JSON.parse(JSON.stringify(horse)),
        horse_to_update: this.state.horses_list.find(el => el.horse_id === horse.horse_id),
        // JSON.parse(JSON.stringify(horse)),
        is_editing_horse: true
      });
      
    }

    openUpdatePeopleModel = (person, field) => (e) => { 
      this.setState({
        is_open_people_modal: true,
        add_people_error_msg: '',
        new_person_data: JSON.parse(JSON.stringify(person)),
        person_to_update: this.state.people_list.find(el => el.people_id === person.people_id),
        // JSON.parse(JSON.stringify(person)),
        is_editing_person: true,
        updating_person_field: field
      });
      
    }

    getPeopleUpdateMsg(person, area){
      var required_fields = ["first", "last_name", "address", "city", "state", "postal_code", "country", "email_address", "mobile_phone"];

      if(person.isfarmrto){
        required_fields = ["company_name", "address", "city", "state", "postal_code", "country", "email_address", "mobile_phone"];
      }
      if(area === 'rider'){
        if (person.on_medical_hold){
          return <p style={{color: "red"}}><img src={warning_red} className='warning-icon'/> {person.fl_name} is on medical hold. Cannot be added to this entry.</p>;
        }
      } 
      // if(area === 'responsible'){ //if person is on credit hold, display error message during add entry and disallow add entry for all roles
      if (person.on_credit_hold){
        return <p style={{color: "red"}}><img src={warning_red} className='warning-icon'/> {person.fl_name} is on credit hold. Cannot be added to this entry.</p>;
      }
      // }
      if(area === 'responsible'){ //if person is on credit hold, display error message during add entry and disallow add entry for all roles
        if (person?.account?.sgl_on_hold){
          return <p style={{color: "red"}}><img src={warning_red} className='warning-icon'/> {person.fl_name} is on SGL hold. Cannot be added to this entry.</p>;
        }
      }
      if (this.getMembershipWarning(person.memberships)){
        return 'Click here to add this membership.';
      } else if (this.getHasMissingInfo(person, required_fields)){
        return 'There is some missing information on file. Click here to update this person.';
      }  else {
        return 'Click here to update this person.';
      }
    }

    getPersonName(person){
      // var name = person.fl_name
      if (this.state.people_search_field === 'Rider' || this.state.people_search_field === 'rider2' || this.state.people_search_field === 'rider3'){
        if (person.on_medical_hold){
          return '\n [On Medical Hold.]';
        }
      }
      if (this.state.people_search_field === 'responsible'){
        if (person.on_credit_hold){
          return '\n [On Credit Hold.]';
        } 

        if (person?.account?.sgl_on_hold){
          return '\n [On SGL Hold.]';
        } 
      }
      if (this.state.governing_organization==='EC' && person.ec_suspended) {
        return '\n [Not In Good Standing.]';
      }

      if(this.state.people_search_field === 'Parent' || this.state.people_search_field === 'Parent2' || this.state.people_search_field === 'Parent3'){
        if (person.is_junior) {
          return '\n [Junior Rider.]';
        }
        if (!person.email_address) {
          return '\n [No Email Address.]';
        }
      }
      return null;
    }
    getHorseError(horse){
      let hasError = false
      let error = ''
      if(horse.on_vet_hold){
        hasError = true
        error = '\n [On vet hold]'
      }else if(horse.has_duplicate_entries){
        hasError = true
        error = '\n [The selected horse has already been entered in this show.]'
      }
      // if (this.state.governing_organization=='EC' && horse.ec_suspended) {
      //   return '\n [EC Suspended]';
      // }
      // if (this.state.governing_organization=='USEF' && horse.usef_suspended != '0'){
      //   return '\n [USEF Suspended]';
      // }
      // if (this.state.governing_organization=='FEI' && horse.fei_suspended){
      //   return '\n [FEI Suspended]';
      // }

      return {hasError, error}
    }
    getHorseLabelTh(){
      var organization_label = this.state.governing_organization;
      if(this.state.governing_organization === "EC"){
          organization_label = "Passport";
      }else if(this.state.governing_organization === "USEF"){
          organization_label = "USEF";
      }
      return organization_label + " No.";
    }
    setHorseLabelTh(){
      var organization_label = this.state.governing_organization;
      if(this.state.horse_search_type === 'by_name'){
        if(this.state.governing_organization === "EC"){
            organization_label = "Sport License";
        }else if(this.state.governing_organization === "USEF"){
            organization_label = "USEF";
        }
        organization_label = organization_label + " No.";
      } else {
        organization_label = 'USEF No.';
        if (this.state.horse_search_org === 'by_ec'){
          organization_label = 'Sport License No.';
        } else if (this.state.horse_search_org === 'by_fei'){
          organization_label = 'FEI No.';
        }
      }
      this.setState({
        horse_search_label_th: organization_label
      })
    }

    getHorseUsefNo(horse){
      if(this.state.horse_search_type === 'by_name'){

        if(this.state.governing_organization === "EC"){
          return horse["ec_ppn"];
        } else if(this.state.governing_organization === "FEI"){
          return horse["fei_id"];
        } else {
          return horse["usef_no"];
        }
      } else {
        if(this.state.horse_search_label_th === "Sport License No."){
          return horse["ec_ppn"];
        } else if(this.state.horse_search_label_th === "FEI No."){
          return horse["fei_id"];
        } else {
          return horse["usef_no"];
        }
      }
    }

    getPersonUsefNo(person){
      var usef_no = '';
      if(this.state.governing_organization==="EC"){
        usef_no = person["ec_sln"];
      }
      else if(this.state.governing_organization==="FEI"){
        usef_no = person["fei_id"];
      }
      else{
        usef_no = person["usef_number_ahsa_number"];
      }

      return usef_no;
    }
    getPeopleLabelTh(){
      var organization_label = this.state.governing_organization;
      if(this.state.governing_organization === "EC"){
          organization_label = "Sport License";
      }else if(this.state.governing_organization === "USEF"){
          organization_label = "USEF";
      }
      return organization_label + " No.";
    }
    setPeopleLabelTh(){
      var organization_label = this.state.governing_organization;
      if(this.state.people_search_type === 'by_name'){
        if(this.state.governing_organization === "EC"){
            organization_label = "Sport License";
        }else if(this.state.governing_organization === "USEF"){
            organization_label = "USEF";
        }
        organization_label = organization_label + " No.";
      } else {
        organization_label = 'USEF No.';
        if (this.state.people_search_org === 'by_ec'){
          organization_label = 'Sport License No.';
        } else if (this.state.people_search_org === 'by_fei'){
          organization_label = 'FEI No.';
        }
      }
      this.setState({
        people_search_label_th: organization_label
      })
    }

    format_currancy(amount){
      if(amount === undefined){
        return '';
      }
      // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    }

    format_date(unformatted_date){
      var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
      var formatted_date = (new Date(unformatted_date_split));
      formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
      return parseInt(formatted_date.getMonth()+1) +"/"+ formatted_date.getDate() +"/"+ formatted_date.getFullYear();
    }
    format_time(timeString) {
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = H < 12 || H === 24 ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }

    getExpYearsArray(){
      var years_array = [];
      var now = new Date().getFullYear()-1;
      const years = Array(now - (now - 20)).fill('').map((v, idx) => now + idx);
      years.forEach(year => {
        years_array.push({
          year_name: year,
          year_value: year
        })
      });
      return years_array;
    }
    getACHServiceFee(){
      let total_service_fee = parseFloat(this.state.series_shows_ach_service_fee_amount);
      var fee_percent = parseFloat(this.state.ach_service_fee_percent);
      var fee_cap = parseFloat(this.state.ach_service_fee_cap);
      var deposit_amount_val = this.state.deposit_amount;
      if (isNaN(this.state.deposit_amount) || this.state.deposit_amount === '') {
        deposit_amount_val = 0;
      }
      if(this.state.selected_show_details.ach_service_fee){
        if(fee_percent > 0 && fee_percent < 100){
          let calculated_service_fee = (total_service_fee + (parseFloat(deposit_amount_val) * (fee_percent/100)));
          if ( calculated_service_fee <= fee_cap ) {
            return calculated_service_fee.toFixed(2)
          } else {
            return fee_cap.toFixed(2)
          }
        } else {
          return total_service_fee;
        }
      } else {
        return total_service_fee;
      }
    }
    getCreditCardServiceFee(){
      let total_service_fee = parseFloat(this.state.series_shows_service_fee_amount);
      var fee_percent = parseFloat(this.state.selected_show_details.credit_card_service_fee_percent);
      var deposit_amount_val = this.state.deposit_amount;
      if (isNaN(this.state.deposit_amount) || this.state.deposit_amount === '') {
        deposit_amount_val = 0;
      }
      if(this.state.selected_show_details.credit_card_service_fee){
        if(fee_percent > 0 && fee_percent < 100){
          return (total_service_fee + (parseFloat(deposit_amount_val) * (fee_percent/100))).toFixed(2)
        } else {
          return total_service_fee;
        }
      } else {
        return total_service_fee;
      }
    }
    getTotalAmountToDisplay(){
      var deposit_amount_val = this.state.deposit_amount;
      if (isNaN(this.state.deposit_amount) || this.state.deposit_amount === '') {
        deposit_amount_val = 0;
      }
      if (this.state.deposit_payment_method_type=='bank') {
        return parseFloat(deposit_amount_val) + parseFloat(this.state.series_shows_amount) + parseFloat(this.getACHServiceFee());
      } else {
        return parseFloat(deposit_amount_val) + parseFloat(this.state.series_shows_amount) + parseFloat(this.getCreditCardServiceFee());
      }
    }
    calculateHeight(){
    //   var body = document.body, html = document.documentElement;
    //   var height = Math.max( body.scrollHeight, body.offsetHeight);
    //   parent.postMessage("height:"+height, "*")
    }
    getDataRoles(roles, people_id){

      let updatedRoles = [...roles]; // Create a copy to modify

      if (people_id !== undefined && people_id !== null && updatedRoles.includes('Rider')) {
        const selectedRidersList = this.state.selected_riders_list; // Get the list from state

        // Find the original rider from the state's selected list by their ID
        const originalRider = selectedRidersList.find(r => r.people_id == people_id);
        if(!originalRider && selectedRidersList.find(r => r.parent_guardian_id == people_id)){
          updatedRoles = updatedRoles.map(role =>
              role === 'Rider' ? 'Rider Parent' : role
          );
        }

      }

      var roles_str = updatedRoles.join(', ');

      if(this.state.governing_organization === 'EC'){
        return roles_str.replace('Trainer', 'Coach')
      }
      return roles_str;
    }

    getFormattedPhoneNumber = (number, index) => {
      let newNumber = number;
      if(this.state.formatted_phone_numbers.indexOf(index) < 0){
        if(newNumber[0] != '0' && newNumber[0] != '(' && newNumber[0] != '+'){
          newNumber = number.replace(/[+]/g, '')
          newNumber = newNumber[0] != '0' && newNumber[0] != '(' ? '+' + newNumber : newNumber
          this.setState({ formatted_phone_numbers: [...this.state.formatted_phone_numbers, index] })
        }
      }
      return newNumber
    }
    onGuardianSelect(e){
      if (e.target.value !== '-4') {
        var person = this.state.selected_distinct_people_list.find(el => el.people_id === e.target.value);
        this.setState({
          selected_guardian: person
        })
      } else {
        this.setState({
          selected_guardian:{people_id:0}
        })
      }
    }
    
    ///// stable reservation functions ////////////
    checkIfStallOrdered(){
      var ordered_stalls = this.state.selected_showfees.filter(c => c.is_stall_fee);
      if(ordered_stalls.length > 0){
        return true;
      }
      return false;
    }
    getCheckinDates(chechin_out){
      var start_date = new Date(this.state.selected_show_details.start_date);
      start_date.setDate(start_date.getDate() - parseInt(this.state.stall_check_in_info.days_before_checkin));
      var end_date = new Date(this.state.selected_show_details.end_date);
      if(chechin_out === 'out'){
        end_date.setDate(end_date.getDate() + parseInt(this.state.stall_check_in_info.days_after_checkout));
      }

      var dates_list = [];
      // loop for every day
      for (var day = start_date; day <= end_date; day.setDate(day.getDate() + 1)) {
            dates_list.push({
              display_date: parseInt(day.getMonth()+1) +"/"+ day.getDate() +"/"+ day.getFullYear(),
              date_value: day.getFullYear() +"-"+ parseInt(day.getMonth()+1) +"-"+ day.getDate()
            })
      }
      return dates_list;
    }
    getCheckinOutTime(chechin_out){
      var start_time,end_time,selected_date,first_date, last_date;
      if(chechin_out === 'in'){
        selected_date = this.state.stall_checkin_checkout_data.checkin_date;
        if(!selected_date || selected_date === ''){
          return []
        }
        first_date = this.getCheckinDates(chechin_out)[0].date_value;
        if(selected_date === first_date){
          start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
          end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
        } else {
          start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
          end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
        }

      } else {
        
        selected_date = this.state.stall_checkin_checkout_data.checkout_date;
        if(!selected_date || selected_date === ''){
          return []
        }
        last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length-1].date_value;

        if(selected_date === last_date){
          start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
          end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
        } else {
          start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
          end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
        }
      }
      var time_list = [];
      
      // loop for every hour
      for (var hour = start_time; hour <= end_time; hour++) {
          var suffix = hour >= 12 ? "PM":"AM";
          var hours = ((hour + 11) % 12 + 1) +':00 '+ suffix;
          if(((hour + 11) % 12 + 1) < 10){
            hours = '0'+hours;
          }
            time_list.push({
              display_time: hours,
              time_value: hour
            });
      }
      return time_list;
    }
    getFormattedDisplayTime(chechin_out){
      var start_time,end_time,selected_date,first_date, last_date;
      if(chechin_out === 'in'){
        selected_date = this.state.stall_checkin_checkout_data.checkin_date;
        if(!selected_date || selected_date === ''){
          return 'Select check-in date'
        }
        first_date = this.getCheckinDates(chechin_out)[0].date_value;
        if(selected_date === first_date){
          start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
          end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
        } else {
          start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
          end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
        }

      } else {
        
        selected_date = this.state.stall_checkin_checkout_data.checkout_date;
        if(!selected_date || selected_date === ''){
          return 'Select check-out date'
        }
        last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length-1].date_value;

        if(selected_date === last_date){
          start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
          end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
        } else {
          start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
          end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
        }
      }
      return this.getFormattedTime(start_time) + ' - ' + this.getFormattedTime(end_time);
    }

    getFormattedTime(hour){
      var suffix = parseInt(hour) >= 12 ? "PM":"AM";
      return ((parseInt(hour) + 11) % 12 + 1) +':00 '+ suffix
    }
    updateCheckinInfo(evt, field){
      var stall_checkin_checkout_data = this.state.stall_checkin_checkout_data;
      stall_checkin_checkout_data[field] = evt.target.value;
      if(field === 'checkin_date')
      {
        stall_checkin_checkout_data['checkin_time'] = '';
      }
      if(field === 'checkout_date')
      {
        stall_checkin_checkout_data['checkout_time'] = '';
      }
      this.setState({
        stall_checkin_checkout_data: stall_checkin_checkout_data
      })
    }
    getCheckinValidationMsg(){
      var error_msg = '';
      if(this.state.stall_check_in_info.stall_collect_checkin_checkout_time === '1' && this.checkIfStallOrdered()){
        if(this.state.stall_checkin_checkout_data.checkin_date === ''){
          error_msg = 'Please select check-in date'
        } else if(this.state.stall_checkin_checkout_data.checkin_time === ''){
          error_msg = 'Please select check-in time'
        } else if(this.state.stall_checkin_checkout_data.checkout_date === ''){
          error_msg = 'Please select check-out date'
        } else if(this.state.stall_checkin_checkout_data.checkout_time === ''){
          error_msg = 'Please select check-out time'
        } else if(new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() < new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()){
          error_msg = 'Check-out date cannot be before check-in date'
        } else if((new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() === new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()) && (parseInt(this.state.stall_checkin_checkout_data.checkout_time) < parseInt(this.state.stall_checkin_checkout_data.checkin_time))){
          error_msg = 'Check-out time cannot be before check-in time'
        }
      }
      return error_msg
    }
  async getLinkedParents(peopleId, customerId, field='rider') {  
    if (!peopleId || !customerId) return { linked_people: [], pending_linked_people: [] };
    try {
        const response = await axios.get('add-entry/getLinkedParentsFromCloud', {
            params: {
                people_id: peopleId,
                customer_id: customerId, 
            }
        });
        return response.data || { linked_people: [], pending_linked_people: [] };
    } catch (error) {
        console.error('Error fetching linked parents:', error);
        return { linked_people: [], pending_linked_people: [] };
    }
  }
    ///// end stable reservation functions ////////////
    render(){
        const loading = this.state.loading;

        // this.setRingExpStatus();
        if(loading) {
            return null;
        }
        if(this.state.switch_allowed != 1){
          return(
            <div>
              <h2>Online Entry</h2>
              <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
            </div>
          )
        }
        return(
            <div className="sgl-plugin add-entry-page">
              {(this.state.credit_hold) ?
                <div id='checkout_redirect'>
                    <div id='credit_hold_warning'>
                        <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p>
                    </div>
                    <button className='sgl-button' >
                        <Link to='/checkout-entries' className="button-link">Pay Now</Link>
                    </button>
                         
                </div>
              :
              <div>

                <h2>Add Entry</h2>
                <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />

                {/* <div className="credit-text">{credit_text} <a href={credit_url}>{credit_company}</a></div><br/> */}
                <div id="ringWrapper" className='ringWrapper'>
                        
                    <div className="div-responsive">
                      {/* add entry step 1 - select show */}
                        <div id="step_1_container" className='sgl-primary-header active_block className-details, primary-header className-details-header' rownum="1">
                            <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name">Select Show</p>
                            <div id='change_step_1' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('1')}>Change</a>
                            </div>
                        </div>

                        <div id='step_1' className='add_entry_show add-entry-div'> 
                        <ul>    
                          <li className='entry_people_li'>
                            <div>Please select the show you would like to enter by simply clicking on its name below.
                                If you do not see the show you are looking for, please contact the show office.</div>
                          </li>
                          <li className='entry_people_li'>
                            <table className="table table-striped table-hover">
                    
                                <tbody>
                                    <tr className="sgl-primary-header">
                                        <th className='required center-align' style={{width: '20px'}}>*</th>
                                        <th>Shows</th>
                                    </tr>
                                    { (this.state.shows_list.length > 0)?
                                        this.state.shows_list.map((show, index) => {
                                        return (
                                            <tr className='' key={show.show_id}>
                                                <td style={{width: '20px'}} nowrap="nowrap">
                                                    <input type="radio" name="show" 
                                                        value={show.show_id} 
                                                        checked={this.state.selected_show === show.show_id} 
                                                        onChange={this.setShow}
                                                        disabled={show.no_add_entry}
                                                    />
                                                </td>

                                                <td onClick={(show.no_add_entry)? undefined : () => this.setShow({currentTarget:{value:show.show_id}})}>
                                                  {this.getShowDates(show)} - {show.show_name}
                                                  {(show.require_web_entry_code) &&
                                                    <div className="required"><b>Show requires Entry Code</b></div>
                                                  }
                                                  {(show.no_add_entry) &&
                                                    <div className="required"><b>{show.no_add_entry_reason}</b></div>
                                                  }
                                                </td>
                                        </tr>
                                        )
                                        })
                                    :
                                        <tr>
                                            <td> </td>
                                            <td>No shows are available</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                          </li>
                          <li className='entry_people_li'>
                            <div id='entry_code_container' className='display_none'>
                              <label className='add_entry_label'>Entry Code</label>
                              <div style={{clear: "both"}}></div>
                              <input style={{width: "250px"}} className="input-height input-text mr-15" type="text" name="entry_code" id='entry_code'  value={this.state.entry_code} onChange={evt => this.updateEntryCode(evt)}/>
                            </div>
                          </li>
                          <li className='entry_people_li'>
                            <div id='step_1_warning' className='required display_none'>{this.state.select_show_error_msg}</div>
                          </li>
                        </ul>
                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={this.show_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>

                      {/* add entry step 2 - select horse */}

                        <div id="step_2_container" className='className-details, primary-header className-details-header add_entry_options' rownum="2">
                            <p id="step_2_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Select Horse</p>
                            <div id='change_step_2' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('2')}>Change</a>
                            </div>
                        </div>
                        <div id='step_2' className='add_entry_horse add-entry-div display_none'> 
                          <ul>
                            <li className='entry_people_li'>
                              <p className="add-entry-p">Choose from horses that you have been associated with in the past. You can manage your horse list on Account page:</p>
                            </li>
                            <li className='entry_people_li'>
                              <select className="selection-list" value={this.state.selected_horse.horse_id?this.state.selected_horse.horse_id:'-1'} onChange={(e) => this.onHorseChange(e)} >
                                <option value="-1">Select a horse...</option>
                                {
                                    this.state.horses_list.map((horse,index) => {
                                    return (
                                        <option key={horse.horse_id} value={`${horse.horse_id}`}>
                                            {horse.name}
                                        </option>
                                    )
                                    })
                                }
                              </select>
                              <div id="detail_horse" className="detail_box display_none">
                                <p className='link_color'><b>{this.state.selected_horse.name}</b></p>
                                <p>{this.state.governing_organization}: {this.getMembershipNumber()}</p>
                                <div><a onClick={this.openUpdateHorseModel(this.state.selected_horse)}>{this.getHorseUpdateMessage(this.state.selected_horse)}</a></div>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div>

                                  <p className="add-entry-p">Or Search for a horse:</p> 
                                  <input id="by_horse_field" type="radio" name="horse" className="sgl-mr-5"
                                      value='by_name' onChange={this.setHorseSearch}
                                      checked={this.state.horse_search === 'by_name'} 
                                  /> 
                                  <label className='add_entry_custom_label' htmlFor='by_horse_field'>  by Name</label>
                                  
                                  <br/>
                                  <input id="by_usef_field" type="radio" name="horse" className="sgl-mr-5"
                                      value='by_usef' onChange={this.setHorseSearch}
                                      checked={this.state.horse_search === 'by_usef'} 
                                  />
                                  <label className='add_entry_custom_label' htmlFor='by_usef_field'>  by USEF No.</label>
                                  <br/>
                                  <input id="by_passport_field" type="radio" name="horse" className="sgl-mr-5"
                                      value='by_ec' onChange={this.setHorseSearch}
                                      checked={this.state.horse_search === 'by_ec'} 
                                  />
                                  <label className='add_entry_custom_label' htmlFor='by_passport_field'>   by Passport No.</label>

                                  <br/>
                                  <input id="by_fei_field" type="radio" name="horse" className="sgl-mr-5"
                                      value='by_fei' onChange={this.setHorseSearch}
                                      checked={this.state.horse_search === 'by_fei'} 
                                  />
                                  <label className='add_entry_custom_label' htmlFor='by_fei_field'>   by FEI No.</label>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label sgl-add_entry'>Horse Name</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="people_selection_div txt-field-container">
                                      <input onKeyPress={evt => this._handleHorseSearchKeyPress(evt)} style={{backgroundColor: this.state.txt_horse_name_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="name" id='txt_horse_name' className="input-height horse_name" value={this.state.horse_name} disabled={this.state.txt_horse_name_disabled} onChange={evt => this.updateHorseName(evt)}/>
                                    </div>
                                  </div>
                                  <div className="txt-field-container-div">
                                    <div className="people_selection_div txt-field-container">
                                        
                                            <label className='add_entry_label sgl-add_entry'>Membership No.</label>
                                            <div style={{clear: "both"}}></div>
                                            <div className="input-box txt-field-container">
                                              <input onKeyPress={evt => this._handleHorseSearchKeyPress(evt)} className="input-height" style={{backgroundColor: this.state.txt_membership_no_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="txt_membership_no" value={this.state.horse_membership_no} disabled={this.state.txt_membership_no_disabled} onChange={evt => this.updateHorseMembership(evt)}/>
                                            </div>
                                        
                                    </div>
                                  </div>
                                  
                                </div>
                            </li>
                            <li className='entry_people_li'>
                              <div style={{clear: "both"}}></div>
                              <div id='step_2_warning' className='required display_none'>Please, select a horse from the drop-down list or enter Passport No. or Name to search horse.</div>
                              <div id='horse_selection_warning' className='required display_none'>{this.state.horse_select_error}</div>
                            </li>
                          </ul>
                            
                            {/* <hr/> */}
                          <div className='continue-button-div'>
                            <div className='required float_right'>
                              * Required Fields
                            </div>
                            <br className="sgl-mb-5"/>
                            <button className='sgl-button float_right' onClick={this.horse_selected(false)}>
                              Continue
                            </button>
                          </div>
                        </div>
                    
                      {/* search horse */}
                        <div id='search_horse' className='add_entry_horse add-entry-div display_none'> 
                          <ul>
                            
                            <li className='entry_people_li'>
                              <div>

                                  <label className='add_entry_label'>Governing Organization</label>
                                  <div style={{clear: "both"}}></div>
                                  <input type="radio" id="us_ef" name="horse_search_org" className="sgl-mr-5"
                                      value='by_usef' onChange={this.setHorseSearchOrg}
                                      checked={this.state.horse_search_org === 'by_usef'} 
                                  />
                                  <label htmlFor='us_ef' className='add_entry_custom_label'>  United States Equestrian Federation (USEF)</label>
                                  <br/>
                                  <input type="radio" id="ec_field" name="horse_search_org" className="sgl-mr-5"
                                      value='by_ec' onChange={this.setHorseSearchOrg}
                                      checked={this.state.horse_search_org === 'by_ec'} 
                                  />
                                  <label htmlFor='ec_field' className='add_entry_custom_label'>  Equine Canada (EC)</label>

                                  <br/>
                                  <input type="radio" id="fei_field" name="horse_search_org" className="sgl-mr-5"
                                      value='by_fei' onChange={this.setHorseSearchOrg}
                                      checked={this.state.horse_search_org === 'by_fei'} 
                                  />
                                  <label htmlFor='fei_field' className='add_entry_custom_label'>  Federation Equestre Internationale (FEI)</label>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div>

                                  <label className='add_entry_label'>Search for a horse:</label>
                                  <div style={{clear: "both"}}></div>
                                  <input type="radio" id="by_horse_name_field" name="horse_search_type" className="sgl-mr-5"
                                      value='by_name' onChange={this.setHorseSearchType}
                                      checked={this.state.horse_search_type === 'by_name' || this.state.horse_search === 'by_name'} 
                                  />
                                  <label htmlFor='by_horse_name_field' className='add_entry_custom_label'>  by Name</label>
                                  
                                  <br/>
                                  <input type="radio" id="by_selected_label" name="horse_search_type" className="sgl-mr-5"
                                      value='by_govrn' onChange={this.setHorseSearchType}
                                      checked={this.state.horse_search_type === 'by_govrn' || this.state.horse_search !== 'by_name'} 
                                  />
                                  <label htmlFor='by_selected_label' className='add_entry_custom_label'>  {this.state.horse_search_by_label}</label>

                              </div>
                            </li>
                            <li className='entry_people_li'>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label'>Enter Horse Name</label>
                                    <div className="people_selection_div txt-field-container">
                                      <input  onKeyPress={evt => this._handleHorseSearchKeyPress2(evt)} style={{backgroundColor: this.state.txt_horse_name_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="name" id='txt_search_horse_name' value={this.state.horse_name} className="input-height horse_name" disabled={this.state.txt_horse_name_disabled} onChange={evt => this.updateHorseName(evt)}/>

                                    </div>
                                  </div>
                                  <div className="txt-field-container-div">
                                    <div className="people_selection_div txt-field-container">
                                        
                                            <label className='add_entry_label'>{this.state.horse_search_by_txt_label}.</label>
                                            <div style={{clear: "both"}}></div>
                                            <div className="input-box txt-field-container">
                                              <input  onKeyPress={evt => this._handleHorseSearchKeyPress2(evt)} className="input-height" style={{backgroundColor: this.state.txt_membership_no_disabled ? "#D3D3D3" : 'transparent'}} type="text" name="txt_search_membership_no" value={this.state.horse_membership_no} disabled={this.state.txt_membership_no_disabled} onChange={evt => this.updateHorseMembership(evt)}/>
                                            </div>
                                        
                                    </div>
                                  </div>
                                  
                                </div>
                            </li>
                            <li className='entry_people_li'>
                              <div style={{clear: "both"}}></div>
                              <div>
                                <button className='sgl-button horse_search-button' onClick={this.horse_search()}>
                                  Search
                                </button>
                                <button className='sgl-button horse_search-button' onClick={this.openHorseModal}>
                                  Can't Find Your Horse?
                                </button>
                                <span id="search-horse-please-wait" className='display_none'><img src={indicator_icon} /></span>
                                <div>
                                  
                                  <AddModal
                                    isOpen={this.state.is_open_horse_modal}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={this.closeHorseModal}
                                    className="mymodal modal-width-responsive add-entry-page"
                                    overlayClassName="myoverlay"
                                    ariaHideApp={false}
                                    // style={customStyles}
                                    // contentLabel="Example Modal"
                                  >

                                    {/* <div ref={subtitle => this.subtitle = subtitle} className='sgl-primary-header modal_heading'> */}
                                    <h2 className="sgl-label-border">{this.state.is_editing_horse?'Update Horse':'Add Horse'}</h2>
                                    {/* </div> */}
                                    {/* <h2 ref={subtitle => this.subtitle = subtitle}>Add Horse</h2> */}
                                    
                                    {/* <div>I am a modal</div> */}
                                    <div>
                                      <form>
                                        <ul>
                                          {/* <input /> */}
                                          <li className='entry_people_li'>
                                            <div className="">
                                              <label className='add_entry_label_modal'>Horse name &nbsp;<em  className="required">*</em></label>
                                              <div style={{clear: "both"}}></div>
                                              <div  className="add_modal_div">
                                                { (this.state.is_editing_horse && this.state.horse_to_update.name !== '') ?
                                                  <span>{this.state.new_horse_data.name}</span>
                                                :
                                                  <input type="text" name="name" value={this.state.new_horse_data.name} className="modal_input_right" id='txt_add_horse_name' onChange={evt => this.updateNewHorseData(evt, 'name')}/>
                                                }
                                                </div>
                                            </div>
                                          </li><li className='entry_people_li'>
                                            <div style={{clear: "both"}}></div>
                                            <div>
                                              <div className='txt-field-container-div-modal'>
                                                <label className='add_entry_label_modal'>Sex &nbsp;<em  className="required">*</em></label>
                                                <div style={{clear: "both"}}></div>
                                                <div  className="add_modal_div txt-field-container-modal right_padding">
                                                  { (this.state.is_editing_horse && this.state.horse_to_update.sex !== '') ?
                                                    <span>{this.state.new_horse_data.sex}</span>
                                                  :
                                                    <select className="modal_select" onChange={(e) => this.updateNewHorseData(e, 'sex')}  value={this.state.new_horse_data.sex}>
                                                      <option value="-1">Select...</option>
                                                      {
                                                          horse_genders_array.map((gender,index) => {
                                                          return (
                                                              <option key={gender} value={`${gender}`}>
                                                                  {gender}
                                                              </option>
                                                          )
                                                          })
                                                      }
                                                    </select>
                                                  }
                                                  {/* <input  type="text" name="name" id='txt_add_horse_sex' className="horse_name"  onChange={evt => this.updateNewHorseData(evt, 'sex')}/> */}

                                                </div>
                                              </div>
                                              <div className='txt-field-container-div-modal'>
                                                <div  className="txt-field-container-modal">
                                                    
                                                  <label className='add_entry_label_modal'>Color</label>
                                                  <div style={{clear: "both"}}></div>
                                                  <div className="add_modal_div txt-field-container-modal right_padding">
                                                    { (this.state.is_editing_horse && this.state.horse_to_update.color !== '') ?
                                                      <span>{this.state.new_horse_data.color}</span>
                                                    :
                                                      <input type="text" name='color' id="txt_add_horse_color" className="modal_input_right"  value={this.state.new_horse_data.color} onChange={evt => this.updateNewHorseData(evt, 'color')}/>
                                                    }
                                                    </div>
                                                    
                                                </div>
                                              </div>
                                              
                                            </div>
                                          </li><li className='entry_people_li'>
                                          <div style={{clear: "both"}}></div>
                                            <div className="add_modal_div" >
                                              <div  className='txt-field-container-div-modal'>
                                                <label className='add_entry_label_modal'>Height &nbsp;<em  className="required">*</em></label>
                                                <div style={{clear: "both"}}></div>
                                                <div className="txt-field-container-modal right_padding">
                                                  { (this.state.is_editing_horse && this.state.horse_to_update.height !== '') ?
                                                      <span>{this.state.new_horse_data.height}</span>
                                                    :
                                                      <input type="text" name="height" id='txt_add_horse_height' className="modal_input"  value={this.state.new_horse_data.height} onChange={evt => this.updateNewHorseData(evt, 'height')}/>
                                                  }
                                                </div>
                                              </div>
                                              <div  className='txt-field-container-div-modal'>
                                                <div  className="add_modal_div txt-field-container-modal">
                                                    
                                                  <label className='add_entry_label_modal'>Age</label>
                                                  <div style={{clear: "both"}}></div>
                                                  <div className="input-box txt-field-container-modal right_padding">
                                                  { (this.state.is_editing_horse && this.state.horse_to_update.age !== '') ?
                                                      <span>{this.state.new_horse_data.age}</span>
                                                    :
                                                      <input  type="text" name="age" id="txt_add_horse_age" className="modal_input_right"  value={this.state.new_horse_data.age} onChange={evt => this.updateNewHorseData(evt, 'age')}/>
                                                  }
                                                </div>
                                                    
                                                </div>
                                              </div>
                                              
                                            </div>
                                          </li><li className='entry_people_li'>
                                          <div style={{clear: "both"}}></div>
                                            <div  className="add_modal_div">
                                              <div  className='txt-field-container-div-modal'>
                                                <label className='add_entry_label_modal'>Green</label>
                                                <div className="txt-field-container-modal right_padding">
                                                  { (this.state.is_editing_horse && this.state.horse_to_update.green !== '') ?
                                                      <p>{this.state.new_horse_data.green}</p>
                                                  :
                                                    <select className="modal_select" id='txt_add_horse_green'  value={this.state.new_horse_data.green} onChange={(e) => this.updateNewHorseData(e, 'green')} >
                                                      <option value="-1">Select...</option>
                                                      {
                                                          horse_greens_array.map((green,index) => {
                                                          return (
                                                              <option key={green} value={`${green}`}>
                                                                  {green}
                                                              </option>
                                                          )
                                                          })
                                                      }
                                                    </select>
                                                    }
                                                  {/* <input type="text" name="green" id='txt_add_horse_green' className="horse_name"  onChange={evt => this.updateNewHorseData(evt, 'green')}/> */}

                                                </div>
                                              </div>
                                              <div className='txt-field-container-div-modal'>
                                                <div className="add_modal_div txt-field-container-modal">
                                                    
                                                    <label className='add_entry_label_modal'>Type</label>
                                                    <div style={{clear: "both"}}></div>
                                                    <div className="input-box txt-field-container-modal right_padding">
                                                      { (this.state.is_editing_horse && this.state.horse_to_update.type !== '') ?
                                                        <p>{this.state.new_horse_data.type}</p>
                                                      :
                                                        // <select className="modal_select" id="txt_add_horse_type"  value={this.state.new_horse_data.type} onChange={(e) => this.updateNewHorseData(e, 'type')} >
                                                        //   <option value="-1">Select...</option>
                                                        //   {
                                                        //       horse_types_array.map((type,index) => {
                                                        //       return (
                                                        //           <option value={`${type}`}>
                                                        //               {type}
                                                        //           </option>
                                                        //       )
                                                        //       })
                                                        //   }
                                                        // </select>
                                                        <select className="modal_select" id='txt_add_horse_green'  value={this.state.new_horse_data.type} onChange={(e) => this.updateNewHorseData(e, 'type')} >
                                                        <option value="-1">Select...</option>
                                                        {
                                                            horse_types_array.map((green,index) => {
                                                            return (
                                                                <option key={green} value={`${green}`}>
                                                                    {green}
                                                                </option>
                                                            )
                                                            })
                                                        }
                                                      </select>
                                                      }
                                                    </div>
                                                </div>
                                              </div>
                                              
                                            </div>
                                          </li>
                                          <hr style={{margin_top: '10px'}} />
                                          <li className='entry_people_li'>
                                            <div style={{clear: "both"}}></div>
                                            <div>
                                              <label className='add_entry_label'>MEMBERSHIPS</label>
                                            </div>
                                          </li>
                                          <li className='entry_people_li'>
                                          <div style={{clear: "both"}}></div>
                                            {/* // <div> */}
                                              {
                                                membership_organizations.map((membership_organization,index) => {
                                                return (
                                                  <div key={membership_organization} className='add_modal_div modal-membership-div'>
                                                    <div style={{clear: "both"}}></div>
                                                    <label className='membership_label add_entry_label'>{membership_organization}</label>
                                                    <div className='membership_input_div'>
                                                    { (this.state.is_editing_horse && this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships) && this.getMembershipNumberToUpdate(membership_organization, this.state.horse_to_update.memberships) !== '') ?
                                                        <span>{this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)}</span>
                                                      :
                                                       (associated_membership_organizations.some(item => membership_organization === item)) ?
                                                        <span>{this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)?this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships):'N/A'}</span>
                                                        :
                                                        <input  type="text" name="age" id={"txt_add_horse_membership_"+membership_organization}  value={this.getMembershipNumberToUpdate(membership_organization, this.state.new_horse_data.memberships)} className="modal_input" onChange={evt => this.updateNewHorseData(evt, membership_organization, true)}/>
                                                      
                                                    }
                                                    </div>
                                                  </div>
                                                )
                                                })
                                              }
                                            {/* // </div> */}
                                          </li>
                                          <li className='entry_people_li'>
                                            <div style={{clear: "both"}}></div>
                                            <div id='add_horse_warning' className='required display_none new-line'>{this.state.add_horse_error_msg}</div>
                                          </li>
                                          
                                        </ul>
                                      </form>
                                    </div>
                                    <div className='continue-button-div'>
                                      <div className='required float_right'>
                                        * Required Fields
                                      </div>
                                      <br className="sgl-mb-5"/>
                                      <button className='sgl-button float_right horse_search-button' onClick={this.closeHorseModal}>
                                        Cancel
                                      </button>
                                      <button className='sgl-button float_right horse_search-button' onClick={this.addHorse}>
                                        Save
                                      </button>
                                    </div>
                                  </AddModal>
                                </div>
                              </div>
                            </li>
                            { (this.state.horses_search_list && this.state.horses_search_list.length === 0) &&
                              <li className='entry_people_li'>
                                <p>0 records found.</p>
                              </li>
                            }
                            <li className='entry_people_li'>
                              <div className="">
                              <table className="table table-striped table-hover scroll_table">
                                <thead className="classes-header">                    
                                  <tr className="sgl-primary-header">
                                    <th style={{min_width: '20px', width: '40px'}}>*</th>
                                    <th className="display_on_mobile_th"></th>
                                    <th className="display_on_desktop">{this.state.horse_search_label_th}</th>
                                    <th className="display_on_desktop">Name</th>
                                    <th className="display_on_desktop">Owner</th>
                                    <th className="display_on_desktop" style={{ width: '70px'}}><img src={red_dot} className="placing-icon"/><img src={green_dot} className="placing-icon"/></th>
                                  </tr>
                                </thead>
                                <tbody className="table-scroll">
                                { 
                                  this.state.horses_search_list.map((data, index) => {
                                    let suspended = (this.state.governing_organization==='EC' && data.ec_suspended) || (this.state.governing_organization==='USEF' && data.usef_suspended != '0') || (this.state.governing_organization==='FEI' && data.fei_suspended);
                                    return (
                                      <tr key={data.horse_id} className="">
                                        <td style={{min_width: '20px', width: '40px'}} nowrap="nowrap">
                                            <input type="radio" name="horse_select" 
                                                value={data.horse_id} 
                                                checked={this.state.selected_horse.horse_id === data.horse_id} 
                                                // onChange={(e) => this.onHorseChange(e)}
                                                disabled={this.getHorseError(data).hasError}
                                                onChange={this.setHorse}
                                            />
                                        </td>
                                        <td className="display_on_mobile mbl_custom_row new-line" onClick={() => this.setHorse({currentTarget: {value: data.horse_id}})}>
                                          <p className="table_row_p">
                                            <span><strong>{this.state.horse_search_label_th}</strong> {this.getHorseUsefNo(data)}</span>
                                            <span className="right-align status_icon"><img src={suspended ? red_dot: green_dot} className="placing-icon"/></span>
                                            <br></br>
                                            <span><strong>Name:</strong> {data.name}
                                              <text className='required'>{this.getHorseError(data).error}</text>
                                            </span>
                                            <br></br>
                                            <span><strong>Owner:</strong> {data.owner_name}</span>
                                          </p>
                                        </td>
                                        <td className="display_on_desktop" onClick={() => this.setHorse({currentTarget: {value: data.horse_id}})}>{this.getHorseUsefNo(data)} </td>
                                        <td className="new-line display_on_desktop" onClick={() => this.setHorse({currentTarget: {value: data.horse_id}})}>{data.name}
                                          <text className='required'>{this.getHorseError(data).error}</text>
                                        </td>
                                        <td className="display_on_desktop" onClick={() => this.setHorse({currentTarget: {value: data.horse_id}})}>{data.owner_name}</td>
                                        <td className="display_on_desktop" onClick={() => this.setHorse({currentTarget: {value: data.horse_id}})} style={{width: '40px'}}><img src={suspended ? red_dot: green_dot} className="placing-icon"/></td>
                                      </tr>
                                    )
                                  })
                                }
                                </tbody>
                              </table>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div style={{clear: "both"}}></div>
                              <div id='step_2_search_warning' className='required display_none'>Please select a horse to continue.</div>
                            </li>
                          </ul>
                            
                            {/* <hr/> */}
                          <div className='continue-button-div'>
                            <div>
                              <span className="color-gray"><img src={red_dot} className="placing-icon"/> indicates that the USEF / EC / FEI Membership has been suspended.</span>
                              <br/>
                              <span className="color-gray"><img src={green_dot} className="placing-icon"/> indicates that the USEF / EC / FEI Membership is active.</span>
                            </div>
                            <div className='required float_right'>
                              * Required Fields
                            </div>
                            <br className="sgl-mb-5"/>
                            <button className='sgl-button float_right horse_search-button' onClick={this.horse_selected(true)}>
                              Continue
                            </button>
                            <button className='sgl-button float_right horse_search-button' onClick={this.cancel_horse_search()}>
                              Cancel
                            </button>
                          </div>
                        </div>
                    
                      {/* add entry step 3 - select people */}

                        <div id="step_3_container" className='className-details, primary-header className-details-header add_entry_options' rownum="3">
                            <p id="step_3_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Select People</p>
                            <div id='change_step_3' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('3')}>Change</a>
                            </div>
                        </div>
                        <div id='step_3' className='add_entry_people add-entry-div display_none'> 
                        <ul>    
                          <li className='entry_people_li'>
                            <p className="add-entry-p">Select people to be associated with this entry by:</p>
                          </li>
                          <li className='entry_people_li'>
                            <p className="add-entry-p">
                              - Select from the dropdown lists; people who have been associated with you in the past. You can manage this list on Account page <br/>
                              - If they are not listed, please click the 'Search' button.
                            </p>
                          </li>
                          <li id="HorseRow" className='entry_people_li'>
                              <label className="sgl-label-border">Horse</label>
                              {/* <hr className='hr_divider'/> */}
                              <div style={{clear: "both"}}></div>
                              <div className="input-box">
                                  {this.state.selected_horse.name} 
                                  {/* may get it from api */}
                              </div>
                          </li>
                          <li id="RiderRow" className='entry_people_li'>
                            <div id="RiderRow1" className='rider_row'>
                            {/* <ul>
                              <li id="RiderRow1" className='entry_people_li'> */}
                                <label className=" sgl-label-border"> Rider&nbsp;<em className='required'>*</em></label>
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                    {/* <div className="input-box"> */}
                                        <select id="rider" className="input-height people_selection" value={this.state.selected_rider.people_id?this.state.selected_rider.people_id:'-4'} onChange={(e) => this.onPersonSelect(e, 'rider')}>
                                            <option value="-4">Select...</option>
                                            {
                                                this.state.people_list
                                                .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                                .map((person,index) => {
                                                return (
                                                    <option key={person.people_id} value={`${person.people_id}`}>
                                                        {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                    </option>
                                                )
                                                })
                                            }
                                        </select>
                                    {/* </div> */}
                                </div>
                              {this.state.selected_rider.is_junior && (
                                <div className="people_selection_div" style={{marginTop: '10px',marginBottom: '15px'}}>
                                    <label className="sgl-label-border" style={{marginRight: '10px'}}>Parent/Guardian</label>
                                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <select
                                        className="input-height people_selection"
                                        style={{flex: 'none'}}
                                        value={this.state.selected_rider.parent_guardian_id || '0'}
                                        onChange={(e) => this.setState(prevState => ({
                                            selected_rider: {
                                                ...prevState.selected_rider,
                                                parent_guardian_id: e.target.value
                                            }
                                        }))}
                                        // onChange={(e) => this.setState({selected_rider.parent_guardian_id: e.target.value})}
                                    >
                                        <option value="0">Select...</option>
                                        {this.state.selected_rider?.parents_list?.map(parent => (
                                            <option key={parent.people_id} value={parent.people_id}>
                                                {parent.name} {parent.status === 'pending' ? ' (PENDING)' : ''}
                                            </option>
                                        ))}
                                        {(this.state.governing_organization != 'EC' && this.state.selected_trainer && JSON.stringify(this.state.selected_trainer) !== '{}' && this.state.selected_trainer.people_id != '-4') &&
                                          !this.state.selected_rider?.parents_list?.some(parent => parent.people_id == this.state.selected_trainer.people_id) && (
                                          <option key={this.state.selected_trainer.people_id} value={this.state.selected_trainer.people_id}>{this.state.selected_trainer.fl_name} (TRAINER)</option>
                                        )}
                                    </select>
                                    {!this.state.loading_parents && (!(this.state.selected_rider?.parents_list) || this.state.selected_rider?.parents_list?.length == 0) && (
                                        <>
                                          <button
                                            className="search_button sgl-button display_on_desktop"
                                            type="button"
                                            title="Search"
                                            onClick={this.searchPeople('Parent', 'Parent')}
                                            style={{marginLeft: '10px'}}
                                          >
                                            Search
                                          </button>
                                          <div className="icon_container display_on_mobile">
                                            <a className="display_on_mobile" style={{ marginLeft: '12px' }} onClick={this.searchPeople('Parent', 'Parent')}>
                                              <img className="search_icon" src={search_icon} />
                                            </a>
                                          </div>
                                        </>
                                    )}
                                </div>
                              </div>
                              )}
                                <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('Rider', 'Rider')}>
                                    Search
                                </button>
                                <div className="icon_container display_on_mobile">
                                  <a className="display_on_mobile"  onClick={this.searchPeople('Rider', 'Rider')}>
                                    <img className="search_icon" src={search_icon} />
                                  </a>
                                </div>
                                <div id="detail_rider" className={["detail_box", Object.keys(this.state.selected_rider).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                                  <Link to={'/people/detail?pid='+this.state.selected_rider.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_rider.fl_name}</b></Link>
                                  <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_rider, this.state.governing_organization)}</p>
                                  <div><a onClick={this.openUpdatePeopleModel(this.state.selected_rider, 'rider')}><b>{this.getPeopleUpdateMsg(this.state.selected_rider, 'rider')}</b></a></div>
                                </div>
                                <div style={{clear: "both"}}></div>
                                {/* <button  className="add_rider_button horse_search-button" id='add_rider_button_1' type="button" title="AddRider" onClick={this.AddRider(1)}>
                                    + Add another Rider
                                </button> */}
                            </div>
                            <div id="RiderRow2" className='display_none rider_row' style={{margin_top: "10px"}}>
                              {/* </li>
                              <li id="RiderRow2" className='entry_people_li display_none'> */}
                                {/* <label className=" sgl-label-border"> Rider&nbsp;<em className='required'>*</em></label> */}
                                {/* <hr className='hr_divider'/> */}
                                {/* <div style={{clear: "both"}}></div> */}
                                <div className="people_selection_div addtional_riders">
                                    {/* <div className="input-box"> */}
                                        <select id="rider" className="input-height people_selection" value={this.state.selected_rider2.people_id ? this.state.selected_rider2.people_id : '-4'} onChange={(e) => this.onPersonSelect(e, 'rider2')}>
                                            <option value="-4">Select...</option>
                                            {
                                                this.state.people_list
                                                .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                                .map((person,index) => {
                                                return (
                                                    <option key={person.people_id} value={`${person.people_id}`}>
                                                        {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                    </option>
                                                )
                                                })
                                            }
                                        </select>
                                    {/* </div> */}
                                </div>
                                {/* Rider 2 Parent/Guardian */}
                              {this.state.selected_rider2.is_junior && (
                                <div className="people_selection_div" style={{marginTop: '10px',marginBottom: '15px'}}>
                                    <label className="sgl-label-border" style={{marginRight: '10px'}}>Parent/Guardian</label>
                                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <select
                                        className="input-height people_selection"
                                        style={{flex: 'none'}}
                                        value={this.state.selected_rider2.parent_guardian_id || '0'}
                                        onChange={(e) => this.setState(prevState => ({
                                            selected_rider2: {
                                                ...prevState.selected_rider2,
                                                parent_guardian_id: e.target.value
                                            }
                                        }))}
                                        // onChange={(e) => this.setState({selected_rider.parent_guardian_id: e.target.value})}
                                    >
                                        <option value="0">Select...</option>
                                        {this.state.selected_rider2?.parents_list?.map(parent => (
                                            <option key={parent.people_id} value={parent.people_id}>
                                                {parent.name} {parent.status === 'pending' ? ' (PENDING)' : ''}
                                            </option>
                                        ))}
                                        {(this.state.governing_organization != 'EC' && this.state.selected_trainer && JSON.stringify(this.state.selected_trainer) !== '{}' && this.state.selected_trainer.people_id != '-4') &&
                                          !this.state.selected_rider2?.parents_list?.some(parent => parent.people_id == this.state.selected_trainer.people_id) && (
                                          <option key={this.state.selected_trainer.people_id} value={this.state.selected_trainer.people_id}>{this.state.selected_trainer.fl_name} (TRAINER)</option>

                                        )}
                                    </select>
                                    {!this.state.loading_parents && (!(this.state.selected_rider2?.parents_list) || this.state.selected_rider2?.parents_list?.length == 0) && (
                                      <>
                                        <button
                                          className="search_button sgl-button display_on_desktop"
                                          type="button"
                                          title="Search"
                                          onClick={this.searchPeople('Parent2', 'Parent')}
                                          style={{marginLeft: '10px'}}
                                        >
                                          Search
                                        </button>
                                        <div className="icon_container display_on_mobile">
                                          <a className="display_on_mobile" style={{ marginLeft: '12px' }} onClick={this.searchPeople('Parent2', 'Parent')}>
                                            <img className="search_icon" src={search_icon} />
                                          </a>
                                        </div>
                                      </>
                                    )}
                                </div>
                              </div>
                              )}

                                <div className="icon_container display_on_mobile">
                                  <a className="display_on_mobile right-float" style={{marginLeft: "8px"}}>    <img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.removeRider(2)}/></a>
                                  <a className="display_on_mobile right-float" onClick={this.searchPeople('rider2', 'Rider')}>
                                    <img className="search_icon" src={search_icon} />
                                  </a>
                                </div>
                                <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('rider2', 'Rider')}>
                                    Search
                                </button>
                                <a className="display_on_desktop">    <img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.removeRider(2)}/></a>
                                
                                <div id="detail_rider2" className={["detail_box", Object.keys(this.state.selected_rider2).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                                  <Link to={'/people/detail?pid='+this.state.selected_rider2.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_rider2.fl_name}</b></Link>
                                  <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_rider2,this.state.governing_organization)}</p>
                                  <div><a onClick={this.openUpdatePeopleModel(this.state.selected_rider2, 'rider2')}><b>{this.getPeopleUpdateMsg(this.state.selected_rider2, 'rider')}</b></a></div>
                                </div>
                                <div style={{clear: "both"}}></div>
                                {/* <button  className="add_rider_button horse_search-button" id='add_rider_button_2' type="button" title="AddRider" onClick={this.AddRider(2)}>
                                    + Add another Rider
                                </button> */}
                            </div>
                            <div id="RiderRow3" className='display_none rider_row' style={{margin_top: "10px"}}>
                              {/* </li>
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                    {/* <div className="input-box"> */}
                                        <select id="rider" className="input-height people_selection" value={this.state.selected_rider3.people_id ? this.state.selected_rider3.people_id : '-4'} onChange={(e) => this.onPersonSelect(e, 'rider3')}>
                                            <option value="-4">Select...</option>
                                            {
                                                this.state.people_list
                                                .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                                .map((person,index) => {
                                                return (
                                                    <option key={person.people_id} value={`${person.people_id}`}>
                                                        {person.lf_name}  {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                    </option>
                                                )
                                                })
                                            }
                                        </select>
                                    {/* </div> */}
                                </div>
                              {/* Rider 3 Parent/Guardian */}
                              {this.state.selected_rider3.is_junior && (
                                <div className="people_selection_div" style={{marginTop: '10px',marginBottom: '15px'}}>
                                    <label className="sgl-label-border" style={{marginRight: '10px'}}>Parent/Guardian</label>
                                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                                    <select
                                        className="input-height people_selection"
                                        style={{flex: 'none'}}
                                        value={this.state.selected_rider3.parent_guardian_id || '0'}
                                        onChange={(e) => this.setState(prevState => ({
                                            selected_rider3: {
                                                ...prevState.selected_rider3,
                                                parent_guardian_id: e.target.value
                                            }
                                        }))}
                                        // onChange={(e) => this.setState({selected_rider.parent_guardian_id: e.target.value})}
                                    >
                                        <option value="0">Select...</option>
                                        {this.state.selected_rider3?.parents_list?.map(parent => (
                                            <option key={parent.people_id} value={parent.people_id}>
                                                {parent.name} {parent.status === 'pending' ? ' (PENDING)' : ''}
                                            </option>
                                        ))}
                                      {(this.state.governing_organization != 'EC' && this.state.selected_trainer && JSON.stringify(this.state.selected_trainer) !== '{}' && this.state.selected_trainer.people_id != '-4') &&
                                        !this.state.selected_rider3?.parents_list?.some(parent => parent.people_id == this.state.selected_trainer.people_id) && (
                                        <option key={this.state.selected_trainer.people_id} value={this.state.selected_trainer.people_id}>{this.state.selected_trainer.fl_name} (TRAINER)</option>
                                      )}
                                    </select>
                                    
                                    {!this.state.loading_parents && (!(this.state.selected_rider3?.parents_list) || this.state.selected_rider3?.parents_list?.length == 0) && (
                                      <>
                                        <button
                                          className="search_button sgl-button display_on_desktop"
                                          type="button"
                                          title="Search"
                                          onClick={this.searchPeople('Parent3', 'Parent')}
                                          style={{marginLeft: '10px'}}
                                        >
                                          Search
                                        </button>
                                        <div className="icon_container display_on_mobile">
                                            <a className="display_on_mobile" style={{ marginLeft: '12px' }} onClick={this.searchPeople('Parent3', 'Parent')}>
                                              <img className="search_icon" src={search_icon} />
                                            </a>
                                        </div>
                                      </>
                                    )} 
                                </div>
                              </div>
                              )}
                                <div className="icon_container display_on_mobile">
                                  <a className="display_on_mobile right-float" style={{marginLeft: "8px"}}>    <img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.removeRider(3)}/></a>
                                  <a className="display_on_mobile right-float" onClick={this.searchPeople('rider3', 'Rider')}>
                                    <img className="search_icon" src={search_icon} />
                                  </a>
                                </div>
                                <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('rider3', 'Rider')}>
                                    Search
                                </button>
                                <a className="display_on_desktop">   <img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.removeRider(3)}/></a>
                                
                                <div id="detail_rider3" className={["detail_box", Object.keys(this.state.selected_rider3).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                                  <Link to={'/people/detail?pid='+this.state.selected_rider3.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_rider3.fl_name}</b></Link>
                                  <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_rider3,this.state.governing_organization)}</p>
                                  <div><a onClick={this.openUpdatePeopleModel(this.state.selected_rider3, 'rider3')}><b>{this.getPeopleUpdateMsg(this.state.selected_rider3, 'rider')}</b></a></div>
                                </div>
                                <div style={{clear: "both"}}></div>
                                {/* <p className="required">Additional Riders must be added through the show office.</p> */}
                                
                                
                            </div>
                            
                            <div>
                                <button  className="add_rider_button horse_search-button sgl-button" id='add_rider_button' type="button" title="AddRider" onClick={this.AddRider()}>
                                    + Add another Rider
                                </button>
                            </div>
                            <div id='add_rider_error' className='display_none'>
                              <p className="required">Additional Riders must be added through the show office.</p>
                            </div>
                            <div id="RiderRemove" className='display_none'>
                              <p>Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove Rider</p>
                            </div>
                              {/* </li>
                            </ul> */}

                          </li>
                          <li id="TrainerRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <label className="sgl-label-border"> {this.state.governing_organization === 'EC'?'Coach':'Trainer'}&nbsp;<em className="required">*</em></label>
                            {/* <hr className='hr_divider'/> */}
                            <div style={{clear: "both"}}></div>
                            <div className="people_selection_div">
                                {/* <div className="input-box"> */}
                                    <select id="trainer" className="input-height people_selection" value={this.state.selected_trainer.people_id?this.state.selected_trainer.people_id:'-4'} onChange={(e) => this.onPersonSelect(e, 'trainer')}>
                                        <option value="-4">To Be Determined</option>
                                        {
                                            this.state.people_list
                                            .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                            .map((person,index) => {
                                            return (
                                                <option key={person.people_id} value={`${person.people_id}`}>
                                                    {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                </option>
                                            )
                                            })
                                        }
                                    </select>
                                {/* </div> */}
                            </div>
                            <div className="icon_container display_on_mobile">
                              <a className="display_on_mobile" onClick={this.searchPeople('Trainer', 'Trainer')}>
                                <img className="search_icon" src={search_icon} />
                              </a>
                            </div>
                            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" id="sbTrainer" name="sbTrainer" onClick={this.searchPeople('Trainer', 'Trainer')}>
                                Search
                            </button>
                            <div id="detail_trainer" className={["detail_box", Object.keys(this.state.selected_trainer).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                              <Link to={'/people/detail?pid='+this.state.selected_trainer.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_trainer.fl_name}</b></Link>
                              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_trainer,this.state.governing_organization)}</p>
                              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_trainer, 'trainer')}><b>{this.getPeopleUpdateMsg(this.state.selected_trainer, 'trainer')}</b></a></div>
                            </div>
                          </li>
                          <li id="OwnerRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <label className="sgl-label-border"> Owner&nbsp;<em className="required">*</em></label>
                            {/* <hr className='hr_divider'/> */}
                            <div style={{clear: "both"}}></div>
                            <div className="people_selection_div">
                                {/* <div className="input-box"> */}
                                    <select id="owner" className="input-height people_selection" value={this.state.selected_owner.people_id?this.state.selected_owner.people_id:'-4'} onChange={(e) => this.onPersonSelect(e, 'owner')}>
                                        <option value="-4">Select an Owner</option>
                                        {
                                            this.state.people_list
                                            .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                            .map((person,index) => {
                                            return (
                                                <option key={person.people_id} value={`${person.people_id}`}>
                                                    {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                </option>
                                            )
                                            })
                                        }
                                    </select>
                                {/* </div> */}
                            </div>
                            <div className="icon_container display_on_mobile">
                              <a className="display_on_mobile" onClick={this.searchPeople('Owner', 'Owner')}>
                                <img className="search_icon" src={search_icon} />
                              </a>
                            </div>
                            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('Owner', 'Owner')}>
                                Search
                            </button>
                            <div id="detail_owner" className={["detail_box", (JSON.stringify(this.state.selected_owner) === '{}') ? 'display_none' : 'display_detail_block'].join(' ')}>
                              <Link to={'/people/detail?pid='+this.state.selected_owner.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_owner.fl_name}</b></Link>
                              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_owner,this.state.governing_organization)}</p>
                              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_owner, 'owner')}><b>{this.getPeopleUpdateMsg(this.state.selected_owner, 'owner')}</b></a></div>
                            </div>
                          </li>
                          <li id="PrizeRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <label className="sgl-label-border"> Prize Money Recipient&nbsp;<em className="required">*</em></label>
                            {/* <hr className='hr_divider'/> */}
                            <div style={{clear: "both"}}></div>
                            <div className="people_selection_div">
                                {/* <div className="input-box"> */}
                                    <select id="prize" className="input-height people_selection" value={this.state.selected_prize.people_id?this.state.selected_prize.people_id:'-4'} onChange={(e) => this.onPersonSelect(e, 'prize')}>
                                        <option value="-4">To Be Determined</option>
                                        {
                                            this.state.people_list
                                            .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                            .map((person,index) => {
                                            return (
                                                <option key={person.people_id} value={`${person.people_id}`}>
                                                    {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                </option>
                                            )
                                            })
                                        }
                                    </select>
                                {/* </div> */}
                            </div>
                            <div className="icon_container display_on_mobile">
                              <a className="display_on_mobile"  onClick={this.searchPeople('Prize', 'Prize Money Recipient')}>
                                <img className="search_icon" src={search_icon} />
                              </a>
                            </div>
                            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('Prize', 'Prize Money Recipient')}>
                                Search
                            </button>
                            <div id="detail_prize" className={["detail_box", Object.keys(this.state.selected_prize).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                              <Link to={'/people/detail?pid='+this.state.selected_prize.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_prize.fl_name}</b></Link>
                              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_prize,this.state.governing_organization)}</p>
                              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_prize, 'prize')}><b>{this.getPeopleUpdateMsg(this.state.selected_prize, 'prize')}</b></a></div>
                            </div>                          </li>
                          <li id="NotesRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <label className="sgl-label-border"> Notes/Requests</label>
                            <div style={{clear: "both"}}></div>
                            {/* <div className="people_selection_div"> */}
                                {/* <div className="input-box"> */}
                                    <textarea style={{height: "50px", width: "500px"}} id="notes" className=""  onChange={evt => this.updateNotes(evt)}>
                                    </textarea>
                                {/* </div> */}
                            {/* </div> */}
                          </li>
                          <li id="ResponsiblePersonRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <label className="sgl-label-border"> Financially Responsible Person &nbsp;<em  className="required">*</em></label>
                            {/* <hr className='hr_divider'/> */}
                            <div style={{clear: "both"}}></div>
                            <div className="people_selection_div">
                                {/* <div className="input-box"> */}
                                    <select id="responsible" className="input-height people_selection" value={this.state.selected_responsible.people_id?this.state.selected_responsible.people_id:'-4'} onChange={(e) => this.onPersonSelect(e, 'responsible')}>
                                        <option value="-4">To Be Determined</option>
                                        {
                                            this.state.people_list
                                            .sort((a, b) => a.lf_name.localeCompare(b.lf_name))
                                            .map((person,index) => {
                                            return (
                                                <option key={person.people_id} value={`${person.people_id}`}>
                                                    {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                </option>
                                            )
                                            })
                                        }
                                    </select>
                                {/* </div> */}
                            </div>
                            <div className="icon_container display_on_mobile">
                              <a className="display_on_mobile"  onClick={this.searchPeople('responsible', 'Responsible Person')}>
                                <img className="search_icon" src={search_icon} />
                              </a>
                            </div>
                            <button  className="search_button sgl-button display_on_desktop" type="button" title="Search" onClick={this.searchPeople('responsible', 'Responsible Person')}>
                                Search
                            </button>
                            <div id="detail_responsible" className={["detail_box", Object.keys(this.state.selected_responsible).length === 0 ? 'display_none' : 'display_detail_block'].join(' ')}>
                              <Link to={'/people/detail?pid='+this.state.selected_responsible.people_id+'&sid='+this.state.selected_show}><b>{this.state.selected_responsible.fl_name}</b></Link>
                              <p className="add-entry-p">{this.state.governing_organization}: {this.getPeopleMembershipNumber(this.state.selected_responsible,this.state.governing_organization)}</p>
                              <div><a onClick={this.openUpdatePeopleModel(this.state.selected_responsible, 'responsible')}><b>{this.getPeopleUpdateMsg(this.state.selected_responsible, 'responsible')}</b></a></div>
                              {
                                (
                                  this.state.exhibitor_billing_enabled_for_show &&
                                  this.state.selected_responsible && 
                                  Object.keys(this.state.selected_responsible).length > 0 && 
                                  !this.state.selected_responsible.on_credit_hold && 
                                  !this.state.selected_responsible?.account?.sgl_on_hold && 
                                  this.state.selected_responsible.billingWarning && 
                                  this.state.selected_responsible.billingWarning != '' && 
                                  !this.rpHasOnboardingSetup()
                                ) ?
                                <p style={{ color: "red" }}>
                                  <img src={warning_red} className="warning-icon" />{" "}
                                  {this.state.selected_responsible.billingWarning}
                                </p>
                                : null
                              } 
                            </div>
                            <p id="verify-rp" className='display_none'>
                              <span><img src={indicator_icon} /></span>
                              Verifying onboarding details...
                            </p>
                          </li>

                            
                        </ul>
                        <div style={{clear: "both"}}></div>
                        <div id='step_3_warning' className='required display_none'>{this.state.people_selection_error_msg}</div>
                        {/* <hr/> */}
                        <div id='step_3_warning_table' className='display_none'>
                          <div className="center-align" style={{clear: "both", width: "100%"}}>
                            <span>{this.state.riders_table_error_msg}</span>
                          </div>
                              <table className="table table-striped table-hover">
                                <thead>
                                  <tr className="sgl-primary-header">
                                    <th className="display_on_mobile_th"></th>
                                    <th className="display_on_desktop">Entry</th>
                                    <th className="display_on_desktop">Horse</th>
                                    <th className="display_on_desktop">Rider(s)</th>
                                    <th className="display_on_desktop"></th>
                                    <th className="display_on_desktop"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                { 
                                  this.state.error_riders_list.map((data, index) => {
                                    return (
                                      <tr key={data.entry_number + '-' + data.horse_name + '-' + data.rider_name} className="">
                                        
                                        <td className="display_on_mobile mbl_custom_row">
                                          <p className="table_row_p">
                                            <span><strong>Horse: </strong>{data.horse_name}</span>
                                            <br></br>
                                            <span><strong>Rider: </strong>{data.rider_name}</span>
                                            <br></br>
                                            <Link to={'/class-adds-drops/'} target="_blank">Add/Drop Classes</Link>
                                          </p>
                                        </td>
                                        <td className="display_on_desktop" >{data.entry_number}</td>
                                        <td className="display_on_desktop" >{data.horse_name} </td>
                                        <td className="display_on_desktop" >{data.rider_name} </td>
                                        <td className="display_on_desktop" >
                                            <Link to={'/class-adds-drops/'} target="_blank">Add/Drop Classes</Link>
                                        </td>
                                        {/* <td className="display_on_desktop">&nbsp;</td> */}
                                        <td className="display_on_desktop" ><Link to={'/entries/detail?eid='+data.entry_id+'&sid='+this.state.selected_show}>View</Link></td>
                                      </tr>
                                    )
                                  })
                                }
                                </tbody>
                              </table>
                        </div>
                        <div className='continue-button-div'>
                          <div className='required float_right'>
                            * Required Fields
                          </div>
                          <br className="sgl-mb-5"/>
                          <span id="select-people-please-wait" className='display_none float_right'><img src={indicator_icon} /></span>
                          <button id='continue_people' className='sgl-button float_right' onClick={this.people_selected()} disabled={this.state.processingBillingData}>
                            Continue
                          </button>
                        </div>
                    </div>

                      {/* search people */}
                        <div id='search_people' className='add_entry_horse add-entry-div display_none'> 
                          <ul>
                            
                            <li className='entry_people_li'>
                              <div>

                                  <label className='add_entry_label'>Governing Organization</label>
                                  <div style={{clear: "both"}}></div>
                                  <input type="radio" id='ppl_by_usef' name="people_search_org" className="sgl-mr-5"
                                      value='by_usef' onChange={this.setPeopleSearchOrg}
                                      checked={this.state.people_search_org === 'by_usef'} 
                                  />
                                  <label htmlFor='ppl_by_usef' className='add_entry_custom_label'>  United States Equestrian Federation (USEF)</label>
                                  <br/>
                                  <input type="radio"  id='ppl_by_ec' name="people_search_org" className="sgl-mr-5"
                                      value='by_ec' onChange={this.setPeopleSearchOrg}
                                      checked={this.state.people_search_org === 'by_ec'} 
                                  />
                                  <label htmlFor='ppl_by_ec' className='add_entry_custom_label'>  Equine Canada (EC)</label>

                                  <br/>
                                  <input type="radio" id='ppl_by_fei' name="people_search_org" className="sgl-mr-5"
                                      value='by_fei' onChange={this.setPeopleSearchOrg}
                                      checked={this.state.people_search_org === 'by_fei'} 
                                  />
                                  <label htmlFor='ppl_by_fei' className='add_entry_custom_label'>  Federation Equestre Internationale (FEI)</label>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div>

                                  <label className='add_entry_label'>Search for a {(this.state.governing_organization === 'EC' && this.state.people_search_field_text === 'Trainer')? 'Coach':this.state.people_search_field_text}:</label>
                                  <div style={{clear: "both"}}></div>
                                  <input type="radio" id='ppl_by_name' name="people_search_type" className="sgl-mr-5"
                                      value='by_name' onChange={this.setPeopleSearchType}
                                      checked={this.state.people_search_type === 'by_name'} 
                                  />
                                  <label htmlFor='ppl_by_name' className='add_entry_custom_label'>  by Name</label>
                                  
                                  <br/>
                                  <input type="radio" id='ppl_by_gvrn' name="people_search_type" className="sgl-mr-5"
                                      value='by_govrn' onChange={this.setPeopleSearchType}
                                      checked={this.state.people_search_type === 'by_govrn'} 
                                  />
                                  <label htmlFor='ppl_by_gvrn' className='add_entry_custom_label'>  {this.state.horse_search_by_label}</label>

                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div>
                                <div style={{clear: "both"}}></div>
                                <div className="txt-field-container-div mb-10">
                                  <label className='add_entry_label'>First Name</label>
                                  <div className="people_selection_div txt-field-container">
                                    <input style={{backgroundColor: this.state.txt_people_name_disabled ? '#D3D3D3' : 'transparent'}} 
                                      type="text" name="name" id='txt_people_first_name' className="input-height horse_name"
                                      value={this.state.people_first_name}
                                      disabled={this.state.txt_people_name_disabled}
                                      onChange={evt => this.updateFirstName(evt)}
                                      onKeyPress={evt => this._handlePeopleSearchKeyPress(evt)}
                                    />

                                  </div>
                                </div>
                                <div className="txt-field-container-div">
                                      
                                  <label className='add_entry_label'>Last Name</label>
                                  <div style={{clear: "both"}}></div>
                                  <div className="input-box txt-field-container">
                                    <input className="input-height" style={{backgroundColor: this.state.txt_people_name_disabled ? '#D3D3D3' : 'transparent'}}
                                      type="text" name="txt_people_last_name" 
                                      value={this.state.people_last_name}
                                      disabled={this.state.txt_people_name_disabled}
                                      onChange={evt => this.updateLastName(evt)}
                                      onKeyPress={evt => this._handlePeopleSearchKeyPress(evt)} 
                                    />
                                      
                                  </div>
                                      
                                </div>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div>
                                <div style={{clear: "both"}}></div>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label'>{this.state.people_search_by_txt_label}</label>
                                    <div className="people_selection_div txt-field-container">
                                    <input className="input-height" style={{backgroundColor: this.state.txt_people_membership_no_disabled ? '#D3D3D3' : 'transparent'}} 
                                      type="text" name="txt_people_membership_no" 
                                      value={this.state.people_membership_no}
                                      disabled={this.state.txt_people_membership_no_disabled}
                                      onChange={evt => this.updatePeopleMembership(evt)}
                                      onKeyPress={evt => this._handlePeopleSearchKeyPress(evt)} 
                                    />

                                    </div>
                                  </div>
                                  <div className="people_search_wrapper">
                                    {/* <div className=""> */}
                                        
                                      <button className='sgl-mb-5 mt-20 horse_search-button sgl-button' onClick={this.people_search()}>
                                        Search
                                      </button>
                                      {/* <div style={{clear: "both"}}></div> */}
                                      <button id = 'add_people_button' className='sgl-button display_none horse_search-button sgl-mb-5 mt-20' onClick={this.openPeopleModal}>
                                        Can't Find Your {(this.state.governing_organization === 'EC' && this.state.people_search_field_text === 'Trainer')? 'Coach':this.state.people_search_field_text}
                                      </button>
                                      <span id="search-people-please-wait" className='display_none vertical-align-middle'><img src={indicator_icon} /></span>
                                      <div>
                                      
                                  
                                        <AddModal
                                          isOpen={this.state.is_open_people_modal}
                                          onAfterOpen={this.afterOpenModal}
                                          onRequestClose={this.closePeopleModal}
                                          className="mymodal modal-width-responsive add-entry-page"
                                          overlayClassName="myoverlay"
                                          ariaHideApp={false}
                                          // style={customStyles}
                                          // contentLabel="Example Modal"
                                        >

                                          {/* <h2 ref={subtitle => this.subtitle = subtitle}>Add Person</h2> */}
                                          {/* <div ref={subtitle => this.subtitle = subtitle} className='sgl-primary-header modal_heading'> */}
                                            <h2>{this.state.is_editing_person?'Update Person':'Add Person'}</h2>

                                          {/* </div> */}
                                          
                                          {/* <div>I am a modal</div> */}
                                          <div>
                                            <form>
                                              <ul>
                                                { (!this.state.is_editing_person || this.state.new_person_data.is_created) && 
                                                  <li className='entry_people_li'>
                                                    <div className="my-row">
                                                      <div className = 'input-group-full' id="is-farm-input-area">
                                                        <input type="checkbox" name="checkIsFarm" id="checkIsFarm"  checked={this.state.new_person_data.isfarmrto} onChange={e => this.checkIsFarmChange(e)}/>
                                                        <label htmlFor='checkIsFarm' className='farm-label add_entry_label_modal' id="checkIsFarmLabel">  Is this a Farm?</label>
                                                      </div>
                                                    </div>
                                                  </li>
                                                }
                                                <li className='entry_people_li'>
                                                  {/* { (this.state.new_person_data.isfarmrto) ?  */}
                                                      <div className={ this.state.new_person_data.isfarmrto ? 'my-row' : 'display_none'} id='add_people_company_div'>
                                                        <div className = 'input-group-full'>
                                                          <label className='add_entry_label_modal'>Company name &nbsp;<em  className="required">*</em></label>
                                                          <div style={{clear: "both"}}></div>
                                                          <div  className="add_modal_div right_padding">
                                                            { (this.state.is_editing_person && this.state.person_to_update.company_name !== '' && !this.state.new_person_data.is_created) ?
                                                              <span>{this.state.new_person_data.company_name}</span>
                                                            :
                                                              <input type="text" name="companyname" className="modal_input_right" id='txt_add_people_company_name' value={this.state.new_person_data.company_name} onChange={evt => this.updateNewPersonData(evt, 'company_name')}/>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                  {/* : */}
                                                      <div className={["add_modal_div ", this.state.new_person_data.isfarmrto ? 'display_none' : 'my-row'].join(' ')} id='add_people_name_div'>
                                                        <div className='input-group'>
                                                          <label className='add_entry_label_modal'>First Name &nbsp;<em  className="required">*</em></label>
                                                          <div style={{clear: "both"}}></div>
                                                          <div className="txt-field-container-modal right_padding">
                                                            { (this.state.is_editing_person && this.state.person_to_update.first !== '' && !this.state.new_person_data.is_created) ?
                                                              <span>{this.state.new_person_data.first}</span>
                                                            :
                                                              <input type="text" name="first_name" id='txt_add_people_first_name' className="modal_input_half"  value={this.state.new_person_data.first} onChange={evt => this.updateNewPersonData(evt, 'first')}/>
                                                            }
                                                          </div>
                                                        </div>
                                                        <div className='input-group'>
                                                          <div  className="add_modal_div">
                                                              
                                                                  <label className='add_entry_label_modal'>Last Name &nbsp;<em  className="required">*</em></label>
                                                                  <div style={{clear: "both"}}></div>
                                                                  <div className="input-box txt-field-container-modal right_padding">
                                                                    { (this.state.is_editing_person && this.state.person_to_update.last_name !== '' && !this.state.new_person_data.is_created) ?
                                                                      <span>{this.state.new_person_data.last_name}</span>
                                                                    :
                                                                      <input  type="text" name="last_name" id="txt_add_people_last_name" className="modal_input_half" value={this.state.new_person_data.last_name} onChange={evt => this.updateNewPersonData (evt, 'last_name')}/>
                                                                    }
                                                                  </div>
                                                              
                                                          </div>
                                                        </div>
                                                        
                                                      </div>
                                                  {/* } */}
                                                </li>
                                                <li className='entry_people_li'>
                                                  <div className="my-row">
                                                    <div className = 'input-group-full'>
                                                      <label className='add_entry_label_modal'>Address &nbsp;<em  className="required">*</em></label>
                                                      <div style={{clear: "both"}}></div>
                                                      <div  className="add_modal_div right_padding">
                                                        { (!this.state.is_editing_person || this.state.person_to_update.address === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                            <input style={{width: "95% !important"}} type="text" name="address" className="modal_input_right" id='txt_add_people_address' value={this.state.new_person_data.address} onChange={evt => this.updateNewPersonData(evt, 'address')}/>

                                                          :
                                                          <span> XXXXXXXXXXXXXXXXXXXXXXXXXXXX </span>

                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li className='entry_people_li'>
                                                    <div className="add_modal_div  my-row">
                                                      <div className='input-group'>
                                                        <label className='add_entry_label_modal'>City &nbsp;<em  className="required">*</em></label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div className="txt-field-container-modal right_padding">
                                                          { (!this.state.is_editing_person || this.state.person_to_update.city === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                            <input type="text" name="city" id='txt_add_people_city' className="modal_input_half" value={this.state.new_person_data.city}  onChange={evt => this.updateNewPersonData(evt, 'city')}/>

                                                          :
                                                            <span> XXXXXXXXXXXXXXX </span>

                                                          }

                                                        </div>
                                                      </div>
                                                      <div className=' input-group'>
                                                        <div  className="add_modal_div txt-field-container-modal">
                                                            
                                                                <label className='add_entry_label_modal'>State &nbsp;<em  className="required">*</em></label>
                                                                <div style={{clear: "both"}}></div>
                                                                <div className="input-box txt-field-container-modal right_padding">
                                                                  { (!this.state.is_editing_person || this.state.person_to_update.state === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                                    <input  type="text" name="state" id="txt_add_people_state" className="modal_input_half" value={this.state.new_person_data.state} onChange={evt => this.updateNewPersonData (evt, 'state')}/>

                                                                  :
                                                                    <span> XX </span>

                                                                  }
                                                                </div>
                                                            
                                                        </div>
                                                      </div>
                                                      
                                                    </div>
                                                </li>
                                                <li className='entry_people_li'>
                                                    <div className="add_modal_div my-row">
                                                      <div className='input-group'>
                                                        <label className='add_entry_label_modal'>Postal Code &nbsp;<em  className="required">*</em></label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div className="txt-field-container-modal right_padding">
                                                          { (!this.state.is_editing_person || this.state.person_to_update.postal_code === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                            <input type="text" name="postal_code" id='txt_add_people_postal_code' className="modal_input_half"  value={this.state.new_person_data.postal_code} onChange={evt => this.updateNewPersonData(evt, 'postal_code')}/>

                                                          :
                                                            <span> XXXXX </span>

                                                          }

                                                        </div>
                                                      </div>
                                                      <div className=' input-group'>
                                                        <label className='add_entry_label_modal'>Country &nbsp;<em  className="required">*</em></label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div  className="add_modal_div txt-field-container-modal">
                                                        { (!this.state.is_editing_person || this.state.person_to_update.country === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                          <select className="modal_input_half right_padding"  value={this.findCountry(this.state.new_person_data.country)} onChange={(e) => this.updateNewPersonData(e, 'country')} >
                                                            <option value="-1">Select...</option>
                                                            {
                                                                countries_array.map((country,index) => {
                                                                  return (
                                                                      <option key={country} value={`${country}`}>
                                                                          {country}
                                                                      </option>
                                                                  )
                                                                })
                                                            }
                                                          </select>
                                                        :
                                                          <span> {this.state.new_person_data.country} </span>

                                                        }
                                                          
                                                        </div>
                                                      </div>
                                                      
                                                    </div>
                                                </li>
                                                <li className='entry_people_li'>
                                                  <div className="add_modal_div my-row">
                                                    <div className = 'input-group-full'>
                                                    <label className='add_entry_label_modal'>Email Address &nbsp;<em  className="required">*</em></label>
                                                    <div style={{clear: "both"}}></div>
                                                    <div  className="add_modal_div right_padding">
                                                        { (!this.state.is_editing_person || this.state.person_to_update.email_address === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                          <input type="text" name="email_address" className="modal_input_right" id='txt_add_people_email_address' value={this.state.new_person_data.email_address} onChange={evt => this.updateNewPersonData(evt, 'email_address')}/>

                                                        :
                                                          <span> XXXXXXXXXXXXXXXXXXXXXXXX </span>

                                                        }
                                                    </div>
                                                    </div>
                                                  </div>
                                                </li>
                                                <li className='entry_people_li'>
                                                    <div className="add_modal_div my-row">
                                                      <div className=' input-group'>
                                                        <label className='add_entry_label_modal'>Mobile &nbsp;<em  className="required">*</em></label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div className="txt-field-container-modal right_padding">
                                                          { (!this.state.is_editing_person || this.state.person_to_update.mobile_phone === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                              <input type="text" name="mobile" id='txt_add_people_mobile' className="modal_input_half"  value={this.state.new_person_data.mobile_phone} onChange={evt => this.updateNewPersonData(evt, 'mobile_phone')}/>
                                                            :
                                                              <span> (XXX) XXX-XXXX </span>

                                                          }

                                                        </div>
                                                      </div>
                                                      <div className=' input-group'>
                                                        <div  className="add_modal_div txt-field-container-modal">
                                                            
                                                                <label className='add_entry_label_modal'>Phone Number</label>
                                                                <div style={{clear: "both"}}></div>
                                                                <div className="input-box txt-field-container-modal right_padding">
                                                                  { (!this.state.is_editing_person || this.state.person_to_update.phonenumber === '' || this.state.new_person_data.people_id === this.state.logged_in_people_id || this.state.new_person_data.is_created) ?
                                                                    <input  type="text" name="phone_number" id="txt_add_people_phone_number" className="modal_input_half" value={this.state.new_person_data.phonenumber} onChange={evt => this.updateNewPersonData (evt, 'phonenumber')}/>

                                                                    :
                                                                      <span> (XXX) XXX-XXXX </span>

                                                                    }
                                                                </div>
                                                            
                                                        </div>
                                                      </div>
                                                      
                                                    </div>
                                                </li>

                                                {/* Emergency Contact Information */}
                                                <li className='entry_people_li'>
                                                    <div className="add_modal_div my-row">
                                                      {/* Emergency Contact Name */}
                                                      <div className='input-group'>
                                                        <label className='add_entry_label_modal'>Emergency Contact</label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div className="txt-field-container-modal right_padding">
                                                          <input type="text" name="emergency_contact" id='txt_add_emergency_contact' className="modal_input_half"  value={this.state.new_person_data.emergency_contact} onChange={evt => this.updateNewPersonData(evt, 'emergency_contact')}/>
                                                        </div>
                                                      </div>
                                                      {/* Emergency Contact Number */}
                                                      <div className=' input-group'>
                                                        <label className='add_entry_label_modal'>Emergency Number</label>
                                                        <div style={{clear: "both"}}></div>
                                                        <div className="txt-field-container-modal right_padding">
                                                          <input type="text" name="emergency_phone" id='txt_add_people_emergency_phone' className="modal_input_half"  value={this.state.new_person_data.emergency_phone} onChange={evt => this.updateNewPersonData(evt, 'emergency_phone')}/>
                                                        </div>
                                                      </div>
                                                    </div>
                                                </li>
                                                
                                                <hr style={{margin_top: '30px'}} />
                                                <li className='entry_people_li'>
                                                  <div>
                                                    <label className='add_entry_label'>MEMBERSHIPS</label>
                                                  </div>
                                                </li>
                                                <li className='entry_people_li'>
                                                  <div style={{clear: "both"}}></div>
                                                  {/* // <div> */}
                                                    {
                                                      this.state.person_lookup_organizations.map((membership_organization,index) => {
                                                      return (
                                                        <div key={membership_organization.code} className='add_modal_div modal-membership-div'>
                                                          <div style={{clear: "both"}}></div>
                                                          <label className='membership_label add_entry_label'>{membership_organization.code}</label>
                                                          <div className='membership_input_div'>
                                                          { (this.state.is_editing_person && this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships) && this.getMembershipNumberToUpdate(membership_organization.code, this.state.person_to_update.memberships) !== '' && !this.state.new_person_data.is_created) ?
                                                            <span>{this.getMembershipNumberToUpdate(membership_organization.code, this.state.new_person_data.memberships)}</span>
                                                          :
                                                            (associated_membership_organizations.some(item => membership_organization.code === item)) ?
                                                              <span>{this.getMembershipNumberToUpdate(membership_organization.code, this.state.new_person_data.memberships)?this.getMembershipNumberToUpdate(membership_organization.code, this.state.new_person_data.memberships):'N/A'}</span>
                                                            :
                                                              <input className='modal_input' type="text" name="membership" id={"txt_add_people_membership_"+membership_organization.code}  value={this.getMembershipNumberToUpdate(membership_organization.code, this.state.new_person_data.memberships)} onChange={evt => this.updateNewPersonData(evt, membership_organization.code, true)}/>
                                                          }
                                                          </div>

                                                        </div>
                                                      )
                                                      })
                                                    }
                                                  {/* // </div> */}
                                                </li>
                                                <li className='entry_people_li'>
                                                  <div style={{clear: "both"}}></div>
                                                  <div id='add_people_warning' className='required display_none new-line'>
                                                    {this.state.add_people_error_msg}
                                                  </div>

                                                  <div className='required float_right'>
                                                      * Required Fields
                                                    </div>
                                                </li>
                                                
                                              </ul>
                                            </form>
                                          </div>
                                          <div className='continue-button-div'>
                                            
                                            <button className='sgl-button float_right horse_search-button' onClick={this.closePeopleModal}>
                                              Cancel
                                            </button>
                                            <button className='sgl-button float_right horse_search-button' onClick={this.addPerson}>
                                              Save
                                            </button>
                                          </div>
                                        </AddModal>
                                      </div>
                                        
                                    {/* </div> */}
                                  </div>
                                </div>

                                  
                            </li>

                            <li className='entry_people_li'>
                              <div className="" style={{clear: "both"}}>
                              <table className="table table-striped table-hover scroll_table">
                                <thead className="classes-header">                    
                                  <tr className="sgl-primary-header">
                                    <th style={{min_width: '20px', width: '40px'}}>*</th>
                                    <th className="display_on_mobile_th"></th>
                                    {/* <th className="display_on_desktop">{this.getPeopleLabelTh()}</th> */}
                                    <th className="display_on_desktop">{this.state.people_search_label_th}</th>
                                    <th className="display_on_desktop">Name</th>
                                    <th className="display_on_desktop">Type</th>
                                    <th className="display_on_desktop">State</th>
                                    <th className="status_icon display_on_desktop" style={{ width: '70px'}}><img src={red_dot} className="placing-icon"/><img src={green_dot} className="placing-icon"/></th>
                                  </tr>
                                </thead>
                                <tbody className="table-scroll">
                                { 
                                  this.state.people_search_list.map((data, index) => {
                                    var disable_person = (((this.state.people_search_field === 'Rider' || this.state.people_search_field === 'rider2' || this.state.people_search_field === 'rider3') && (data.on_medical_hold || data.isfarmrto)) || ( this.state.people_search_field === 'Trainer' && data.isfarmrto) || ( this.state.people_search_field === 'responsible' && data.on_credit_hold) || ((this.state.people_search_field === 'Parent' || this.state.people_search_field === 'Parent2' || this.state.people_search_field === 'Parent3') && (data.is_junior || !data.email_address))) ? true : false;
                                    var rto_ec_suspended = (this.state.governing_organization==='EC' && data.ec_suspended)
                                    let rto_suspended = (this.state.governing_organization==='EC' && data.ec_suspended) || (this.state.governing_organization==='USEF' && data.usef_suspended != '0') || (this.state.governing_organization==='FEI' && data.fei_suspended);
                                    return (
                                      <tr key={data.people_id} className="sgl-anchor">
                                        <td style={{min_width: '20px', width: '40px'}} nowrap="nowrap">
                                            <input type="radio" name="person_select" 
                                                value={data.people_id} 
                                                checked={this.state.selected_search_person.people_id === data.people_id} 
                                                // onChange={(e) => this.onHorseChange(e)}
                                                onChange={this.setPerson}
                                                disabled = {(disable_person || rto_ec_suspended) ? true : false}
                                            />
                                        </td>
                                        {/* onClick={(data.on_medical_hold || data.on_credit_hold)? undefined : () => this.setShow */}
                                        <td className="display_on_mobile mbl_custom_row new-line" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})}>
                                          <p className="table_row_p">
                                            <span><strong>{this.state.people_search_label_th} </strong>{this.getPersonUsefNo(data)}</span>
                                            <span className="status_icon"><img src={rto_suspended ? red_dot: green_dot} className="placing-icon"/></span>
                                            <br></br>
                                            <span><strong>Name: </strong>{data.fl_name}<text className='required'>{this.getPersonName(data)}</text></span>
                                            <br></br>
                                            <span><strong>State: </strong>{data.state}</span>
                                            <span className="status_icon"><strong>Type: </strong>{data.isfarmrto?'F':'I'}</span>
                                          </p>
                                        </td>
                                        <td className="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})}>{this.getPersonUsefNo(data)} </td>
                                        <td className="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})}>{data.fl_name}<text className='required'>{this.getPersonName(data)}</text></td>
                                        <td className="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})}>{data.isfarmrto?'F':'I'}</td>
                                        <td className="new-line display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})}>{data.state}</td>
                                        <td className="new-line status_icon display_on_desktop" onClick={(disable_person || rto_ec_suspended)? undefined : () => this.setPerson({currentTarget: {value: data.people_id}})} style={{width: '40px'}}><img src={rto_suspended ? red_dot: green_dot} className="placing-icon"/></td>
                                      </tr>
                                    )
                                  })
                                }
                                </tbody>
                              </table>
                              </div>
                            </li>
                            <li className='entry_people_li'>
                              <div style={{clear: "both"}}></div>
                              <div id='step_3_search_warning' className='required display_none'>Please select a person to continue.</div>
                            </li>
                          </ul>
                            
                            {/* <hr/> */}
                          <div className='continue-button-div'>
                            <span className="color-gray"><img src={red_dot} className="placing-icon"/> indicates that the USEF / EC / FEI Membership has been suspended.</span>
                            <br/>
                            <span className="color-gray"><img src={green_dot} className="placing-icon"/> indicates that the USEF / EC / FEI Membership is active.</span>
                            <div className='required float_right'>
                              * Required Fields
                            </div>
                            <br className="sgl-mb-5"/>
                            <button className='sgl-button float_right horse_search-button' onClick={this.person_selected()}>
                              Continue
                            </button>
                            <button className='sgl-button float_right horse_search-button' onClick={this.cancel_people_search()}>
                              Cancel
                            </button>
                          </div>
                        </div>


                      {/* add entry step 4 - Choose classes */}

                    
                        <div id="step_4_container" className='className-details, primary-header className-details-header add_entry_options' rownum="4">
                            <p id="step_4_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Choose Classes</p>
                            <div id='change_step_4' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('4')}>Change</a>
                            </div>
                        </div>
                        <div id='step_4' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p className="add-entry-p">Select or type the classes you would like to enter, then click 'Add'.</p>
                              </li>
                              <li className='entry_people_li'>
                                <p className="add-entry-p">A list below will be created of successfully entered classes/divisions.</p>
                              </li>

                              <li id="RiderRow" className='entry_people_li'>
                                <label className="sgl-label-border">Select Rider</label>
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                    {/* <div className="input-box"> */}
                                        <select id="class_rider" className="input-height class_selection" 
                                          value={this.state.class_rider_id}
                                          onChange={(e) => this.onClassRiderSelect(e)}>
                                            <option value="-4">Select Rider...</option>
                                            {
                                              this.state.selected_riders_list.map((person,index) => {
                                              return (
                                                  <option key={person.people_id} value={`${person.people_id}`}>
                                                      {person.lf_name} {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                  </option>
                                              )
                                              })
                                            }
                                        </select>
                                    {/* </div> */}
                                </div>
                                <div style={{clear: "both"}}></div>

                              </li>
                              <li id="FilterDivisionRow" className='entry_people_li'>
                                <label className="sgl-label-border">Add Division</label>
                                {/* <hr className='hr_divider'/> */}
                                
                                <div className="people_selection_div">
                                  <input className="input-height input-text class_selection" type="text" name="txtFilterDivision" id="txtFilterDivision" onChange={evt => this.updateDivisionSearch(evt)}/>
                                </div>
                                <button  className="sgl-button search_button" type="button" title="Search" id="divisionFilter" name="divisionFilter"  onClick={this.filterDivisionsList()}>
                                    Search
                                </button>
                              </li>
                              <li id="DivisionRow" className='entry_people_li'>
                                {/* <label className="required sgl-label-border"> Owner&nbsp;<em>*</em></label> */}
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                    {/* <div className="input-box"> */}
                                        <select id="division" className="input-height class_selection" value={this.state.division_to_add} onChange={(e) => this.onDivisionSelect(e)}>
                                            <option value="-1">Select Division...</option>
                                            {
                                                this.state.divisions_filtered_list
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((division,index) => {
                                                return (
                                                    <option key={division.division_id} value={`${division.division_id}`}>
                                                        {division.name}
                                                    </option>
                                                )
                                                })
                                            }
                                        </select>
                                    {/* </div> */}
                                </div>
                                <button  className="sgl-button search_button" type="button" title="Add" onClick={this.addDivision()}>
                                    Add
                                </button>
                              </li>
                              <li id="ClassRow" className='entry_people_li'>
                              <div style={{clear: "both"}}></div>
                                <label className="sgl-label-border">Add Class</label>
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                    {/* <div className="input-box"> */}
                                        <select id="class_list" className="input-height class_selection" value={this.state.class_to_add} onChange={(e) => this.onClassSelect(e)}>
                                            <option value="-1">Select Class...</option>
                                            {
                                              this.state.classes_list
                                              .sort((a, b) => (a.number === 0) - (b.number === 0) || a.number - b.number)
                                              .map((classs,index) => {
                                              return (
                                                  <option key={classs.class_id} value={`${classs.class_id}`}>
                                                      {classs.number} - {classs.name}
                                                  </option>
                                              )
                                              })
                                            }
                                          
                                        </select>
                                    {/* </div> */}
                                </div>
                                <button  className="sgl-button search_button" type="button" title="add"  onClick={this.addClass()}>
                                    Add
                                </button>
                              </li>
                              <li id="EnterClassRow" className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <label className="sgl-label-border"> Enter Classes</label>
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                  <input className="input-height input-text class_selection" type="text" name="txtEnterClass" id="txtEnterClass" onChange={evt => this.updateEntryNumbers(evt)} />

                                </div>
                                <button  className="sgl-mr-5 sgl-button search_button" type="button" title="Search" onClick={this.addClassesByNumber()}>
                                    Add
                                </button>
                                <button  className="drop_button sgl-button search_button" type="button" title="Search" onClick={this.dropClassesByNumber()}>
                                    Drop
                                </button>
                              </li>
                              {(this.state.charge_add_fee_on_web && this.state.class_add_fee_amount > 0) &&
                                <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div id='class_add_amount' className='new-line required'>
                                    {(this.state.class_add_fee_each)?
                                      <p>After {this.format_date(this.state.class_add_date)} {this.format_time(this.state.class_add_fee_time)} you will be charged an additional fee of ${this.state.class_add_fee_amount} per className add operation.</p>
                                    :
                                      <p>After {this.format_date(this.state.class_add_date)} {this.format_time(this.state.class_add_fee_time)} you will be charged an additional fee of ${this.state.class_add_fee_amount} for className add operation.</p>
                                    }
                                      </div>
                                </li>
                              }
                              
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_4_warning' className='new-line required display_none'>{this.state.class_selection_error_msg}</div>
                              </li>

                              <li className='entry_people_li'>

                                    <table className="table table-striped table-hover">
                                      <thead className="classes-header">                    
                                        <tr className="sgl-primary-header">
                                          <th>Your Classes</th>
                                          <th className="delete-column">&nbsp;</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      { 
                                        this.state.selected_classes
                                        .sort((a, b) => (a.number === 0) - (b.number === 0) || a.number - b.number)
                                        .map((data, index) => {
                                          return (
                                            <tr key={data.class_id} className="">
                                              <td>{data.number} {data.name} [{data.rider_name} {data.rider_id === this.state.logged_in_people_id? '(ME)' : ''}]</td>
                                              <td className='center-align'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropClassById(data.class_id)}/></td>
                                            </tr>
                                          )
                                        })
                                      }
                                      </tbody>
                                </table>

                              </li>
                              <li className='entry_people_li'>
                                  <p>Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove An Item</p>
                              </li>
                            </ul>
                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={this.class_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>

                      {/* add entry step 5 - Order supplies */}

                        <div id="step_5_container" className='className-details, primary-header className-details-header add_entry_options' rownum="5">
                            <p id="step_5_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Order Supplies</p>
                            <div id='change_step_5' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('5')}>Change</a>
                            </div>
                        </div>
                        <div id='step_5' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p className="add-entry-p">Please order your supplies, here. If you would like to skip this step, please click 'Continue'.</p>
                              </li>

                              <li id="OrderSuppliesRow" className='entry_people_li'>
                                {/* <label className="required sgl-label-border"> Owner&nbsp;<em>*</em></label> */}
                                {/* <hr className='hr_divider'/> */}
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label'>Order Supplies</label>
                                    <div className="people_selection_div txt-field-container">
                                        {/* <div className="input-box"> */}
                                            
                                            <select id="FeesList" className="input-height class_selection" value={this.state.order_supply_to_add} onChange={(e) => this.onOrderSupplySelect(e)}>
                                                <option value="-1">Select an item to order... </option>
                                                {
                                                  this.state.order_supply_list.map((showfees,index) => {
                                                  return (
                                                      <option key={showfees.showfees_id} value={`${showfees.showfees_id}`}>
                                                          {showfees.description}
                                                      </option>
                                                  )
                                                  })
                                                }

                                            </select>
                                        {/* </div> */}
                                    </div>
                                  </div>
                                  <div className="txt-field-container-div">
                                    <div>
                                        
                                            <label className='add_entry_label'>Amount</label>
                                            <div style={{clear: "both"}}></div>
                                            <div className="input-box" style={{width: '400px'}} >
                                              <input style={{width: "250px"}}
                                                className="input-height input-text mr-15" type="text" name="txtAmount" id="txtAmount" 
                                                value={this.state.amount} 
                                                onChange={evt => this.updateAmount(evt)}  
                                              />
                                              <button  className="sgl-button search_button" type="button" title="Add" onClick={this.addOrderSupply()}>
                                                Add
                                              </button>
                                            </div>
                                            {/* <div style={{clear: "both"}}></div> */}
                                            {/* <button  className="search_button" type="button" title="Add" onClick={this.addOrderSupply()}>
                                              Add
                                            </button> */}
                                        
                                    </div>
                                  </div>
                                  
                                </div>
                              </li>
                              {(this.state.stall_check_in_info.stall_collect_checkin_checkout_time === '1' && this.checkIfStallOrdered()) &&
                                <div id='checkout_stall'>
                                  {/* <div style={{clear: "both"}}></div> */}
                                  <li className='entry_people_li'>
                                    <div style={{clear: "both"}}></div>
                                    <label className='sgl-label-border link_color mr-top-15'>Stable Reservation</label>                                  
                                  </li>
                                  <li className='entry_people_li'>
                                    <div style={{clear: "both"}}></div>
                                    <div className="txt-field-container-div checkin-field-container-div">
                                      <label className='add_entry_label'>Check-in Date</label>
                                      <div style={{clear: "both"}}></div>
                                      <div className="txt-field-container">
                                            <select id="checkinDate" className="input-height class_selection" 
                                              value={this.state.stall_checkin_checkout_data.checkin_date} 
                                              onChange={(e) => this.updateCheckinInfo(e, 'checkin_date')}
                                            >
                                                <option value="">Select check-in date... </option>
                                                {
                                                  this.getCheckinDates('in').map((date_range,index) => {
                                                  return (
                                                      <option key={date_range.date_value} value={date_range.date_value}>
                                                          {date_range.display_date}
                                                      </option>
                                                  )
                                                  })
                                                }
                                            </select>
                                      </div>
                                    </div>
                                    <div className="txt-field-container-div checkin-field-container-div">
                                      <div>
                                            <label className='add_entry_label'>Check-in Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('in')})</span></label>
                                            <div style={{clear: "both"}}></div>
                                            <div className="txt-field-container">
                                              <select id="checkinTime" className="input-height class_selection" 
                                              value={this.state.stall_checkin_checkout_data.checkin_time} 
                                              onChange={(e) => this.updateCheckinInfo(e, 'checkin_time')}
                                              >
                                                  <option value="">Select check-in time... </option>
                                                  {
                                                    this.getCheckinOutTime('in').map((time_range,index) => {
                                                    return (
                                                        <option key={time_range.time_value} value={time_range.time_value}>
                                                            {time_range.display_time}
                                                        </option>
                                                    )
                                                    })
                                                  }
                                              </select>
                                            </div>
                                      </div>
                                    </div> 
                                  </li>
                                  <li className='entry_people_li'>
                                    <div style={{clear: "both"}}></div>
                                    <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                      <label className='add_entry_label'>Check-out Date</label>
                                      <div style={{clear: "both"}}></div>
                                      <div className="txt-field-container">
                                            
                                            <select id="checkoutDate" className="input-height class_selection" 
                                            value={this.state.stall_checkin_checkout_data.checkout_date} 
                                              onChange={(e) => this.updateCheckinInfo(e, 'checkout_date')}
                                            >
                                                <option value="">Select check-out date... </option>
                                                {
                                                  this.getCheckinDates('out').map((date_range,index) => {
                                                  return (
                                                      <option value={date_range.date_value}>
                                                          {date_range.display_date}
                                                      </option>
                                                  )
                                                  })
                                                }
                                            </select>
                                      </div>
                                    </div>
                                    <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                      <div>
                                            <label className='add_entry_label'>Check-out Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('out')})</span></label>
                                            <div style={{clear: "both"}}></div>
                                            <div className="txt-field-container">
                                              <select id="checkoutTime" className="input-height class_selection" 
                                                value={this.state.stall_checkin_checkout_data.checkout_time} 
                                                onChange={(e) => this.updateCheckinInfo(e, 'checkout_time')}
                                              >
                                                  <option value="">Select check-out time... </option>
                                                  {
                                                    this.getCheckinOutTime('out').map((time_range,index) => {
                                                    return (
                                                        <option value={time_range.time_value}>
                                                            {time_range.display_time}
                                                        </option>
                                                    )
                                                    })
                                                  }
                                              </select>
                                            </div>
                                      </div>
                                    </div>
                                  </li>
                                </div>
                              }
                            
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_5_warning' className='required display_none'>{this.state.order_supply_error_msg}</div>
                              </li>
                              {/* { (this.state.fee_error) &&
                                <li>
                                  <div className='required'>{this.state.fee_error}</div>
                                </li>
                              } */}
                              <li className='entry_people_li'>
                                    <table className="table">
                                      <thead className="classes-header">                    
                                        <tr className="sgl-primary-header">
                                          <th>Qty</th>
                                          <th >Description</th>
                                          <th className='right-align display_on_desktop'>Unit Price</th>
                                          <th className='right-align'>Total</th>
                                          <th className='right-align'>Tax Abbr.</th>
                                          <th className="delete-column">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      
                                      { 
                                        this.state.selected_showfees.map((data, index) => {
                                          return (
                                            <tr>
                                              <td>{data.quantity}</td>
                                              <td>{data.description}</td>
                                              <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                              <td className='right-align'>{this.format_currancy(data.unit_price*data.quantity)}</td>
                                              <td className='center-align'>{data.tax_abbr}</td>
                                              <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td>
                                            </tr>
                                          )
                                        })
                                      }
                                      
                                      <tr>
                                        <td >&nbsp;</td>
                                        <td className="right-align"><span className="display_on_mobile"><strong>Subtotal</strong></span></td>
                                        <td className='right-align display_on_desktop'><strong>Subtotal</strong></td>
                                        <td className='right-align'><strong>
                                          {this.format_currancy(this.getTotalFeePrice())}
                                          </strong>
                                        </td>
                                        <td >&nbsp;</td>
                                        <td >&nbsp;</td>
                                      </tr>
                                    </tbody>
                                    
                                </table>
                              </li>
                              <li className='entry_people_li'>
                                  <p>Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove An Item</p>
                              </li>
                              

                            </ul>
                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button id='supplies_selected_continue' className='sgl-button float_right' onClick={this.supplies_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>


                      {/* add entry step 11 - Donations */}
                      {
                        (this.state.donations_list.length>0) &&
                        [
                        <div id="step_11_container" className='className-details, primary-header className-details-header add_entry_options' rownum="11">
                            <p id="step_11_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Donation</p>
                            <div id='change_step_11' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('11')}>Change</a>
                            </div>
                        </div>
                        ,
                        <div id='step_11' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p className="add-entry-p">Would you like to make a donation? If you would like to skip , please click 'Continue'.</p>
                              </li>
                            
                              <li className='entry_people_li DonationsRow'>
                                    <table className="table">
                                    <tbody>
                                      <tr>
                                        <td style={{'width':'20px'}}><input value='' name='selected_donation' id='nodonation' type="radio"/></td>
                                        <td><label style={{'margin':'0px','font-size':'13px','font-weight':'normal'}} htmlFor='nodonation'>No, thank you</label></td>
                                      </tr>

                                      { 
                                        this.state.donations_list.map((data, index) => {
                                          return (
                                            <tr>
                                              <td><input value={data.sgl_id} name='selected_donation' id={'donation_'+data.sgl_id} type="radio"/></td>
                                              <td><label style={{'margin':'0px','font-size':'13px','font-weight':'normal'}} htmlFor={'donation_'+data.sgl_id}>{data.description}</label></td>
                                            </tr>
                                          )
                                        })
                                      }                                      
                                    </tbody>
                                    
                                </table>
                              </li>

                              <li id="DonationsRow" className='entry_people_li DonationsRow'>
                                <div style={{clear: "both"}}>
                                  <div>
                                    <div>
                                      <label className='add_entry_label'>Amount</label>
                                      <div style={{clear: "both"}}></div>
                                      { 
                                        this.state.donation_amounts.map((data, index) => {
                                          return (
                                            <div style={{'display': 'inline-block', 'margin-right': '10px'}}>
                                              <input name='selected_donation_amount' id={'donation_amount_'+data.sgl_id} type="radio" value={data.value}/>
                                              <label style={{'margin':'0px','font-size':'13px','font-weight':'normal'}} htmlFor={'donation_amount_'+data.sgl_id}>&nbsp;{data.name}</label>
                                            </div>
                                          )
                                        })
                                      }                                      
                                      <div className="input-box" style={{width: '150px', 'display': 'inline-block'}} >
                                        <input style={{width: "100px"}}
                                          className="input-height input-text mr-15" min='1' type="number" name="donation_amount" id="donation_amount" 
                                        />
                                      </div>                                       
                                    </div>
                                  </div>
                                  
                                </div>
                              </li>
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_11_warning' className='required display_none'>{this.state.donation_error_msg}</div>
                              </li>                              

                            </ul>
                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={this.donations_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>
                        ]
                      }

                      {/* add entry step 6 - Review fees */}


                        <div id="step_6_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="6">
                            <p id="step_6_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Review fees</p>
                            <div id='change_step_6' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('6')}>Change</a>
                            </div>
                        </div>
                        <div id='step_6' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p className="add-entry-p">Please review your entry fees.  When complete click the 'Continue' button. Some fees are mandatory and can only be adjusted by speaking with the show office.</p>
                              </li>

                              <li className='entry_people_li'>
                                  {/* <table >
                                    <thead> */}
                                    <table className="table">
                                      <thead className="classes-header">                    
                                        <tr className="sgl-primary-header">
                                          <th>Qty</th>
                                          <th >Description</th>
                                          <th className='right-align display_on_desktop'>Unit Price</th>
                                          <th className='right-align'>Tax Abbr.</th>
                                          <th className='right-align'>Total</th>
                                          <th className="delete-column">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    { 
                                        this.state.fee_for_entry.show_fees.map((data, index) => {
                                          return (
                                            <tr>
                                              <td>{(!data.donation)?data.quantity:""}</td>
                                              <td>{data.description}</td>
                                              <td className='right-align display_on_desktop'>{(!data.donation)?this.format_currancy(data.unit_price):""}</td>
                                              <td className='right-align'>{data.tax_abbr}</td>
                                              <td className='right-align'>{this.format_currancy(data.unit_price*data.quantity)}</td>
                                              { (data.standard)?
                                                  <td></td>
                                                :
                                                (!data.donation)?
                                                  <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropOrderSupplyReviewFee(data.showfees_id)}/></td>
                                                  :
                                                  <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon add-entry-trash-icon" onClick={() => this.dropDonation()}/></td>
                                              }
                                              

                                            </tr>
                                          )
                                        })
                                      }
                                      {/* { 
                                        this.state.selected_showfees.map((data, index) => {
                                          return (
                                            <tr className="sgl-anchor">
                                              <td>{data.quantity}</td>
                                              <td>{data.description}</td>
                                              <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                              <td>{data.tax_abbr}</td>
                                              <td className='right-align'>{this.format_currancy(data.unit_price*data.quantity)}</td>
                                              <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td>
                                            </tr>
                                          )
                                        })
                                      } */}
                                    
                                      <tr>
                                        <td >&nbsp;</td>
                                        <td >&nbsp;</td>
                                        <td className="display_on_desktop">&nbsp;</td>
                                        <td className='right-align'>Subtotal</td>
                                        <td  className='right-align'>
                                          {this.format_currancy(this.state.fee_for_entry.show_fees_total)}
                                        </td>
                                        <td >&nbsp;</td>
                                        
                                      </tr>
                                      { (this.state.fee_for_entry.class_prices.length > 0) &&
                                        // <thead className="classes-header">                    
                                          <tr className="sgl-primary-header">
                                            <th colSpan="4" className="display_on_desktop">Description</th>
                                            <th colSpan="3" className="display_on_mobile mobile_table_cell">Description</th>
                                            <th className='right-align'>Price</th>
                                            <th className="delete-column">&nbsp;</th>
                                          </tr>
                                        // </thead>
                                      }
                                      
                                    {/* </tbody>
                                </table>
                              </li>
                              <li className='entry_people_li'>
                                  <p>Click <img src={delete_image} className="placing-icon trash-icon" /> To Remove An Item</p>
                              </li>
                              <li className='entry_people_li'>
                                  
                                  <table className="table">
                                      { (this.state.fee_for_entry.class_prices.length > 0) &&
                                        <thead className="classes-header">                    
                                          <tr className="sgl-primary-header">
                                            <th colSpan="4">Description</th>
                                            <th >Price</th>
                                          </tr>
                                        </thead>
                                      }
                                      <tbody> */}
                                        { (this.state.fee_for_entry.class_prices.length > 0) &&
                                          this.state.fee_for_entry.class_prices.map((data, index) => {
                                            return (
                                              <tr>
                                                <td colSpan="4" className="display_on_desktop">{data.description}</td>
                                                <td colSpan="3" className="display_on_mobile mobile_table_cell">{data.description}</td>
                                                <td className='right-align'>{this.format_currancy(data.price)}</td>
                                              </tr>
                                            )
                                          })
                                        }
                                        { (this.state.fee_for_entry.class_prices.length > 0) &&
                                          <tr>
                                            <td colSpan="3" className="right-align"><span className="display_on_mobile">Subtotal</span></td>
                                            <td className="right-align display_on_desktop">Subtotal</td>
                                            <td  className='right-align'>
                                              {this.format_currancy(this.state.fee_for_entry.class_price_total)}
                                            </td>
                                          </tr>
                                        }
                                        <tr>
                                          <td colSpan="2">Click <img src={delete_image} className="placing-icon add-entry-trash-icon" /> To Remove An Item</td>
                                          <td className='right-align'><span className="display_on_mobile mobile_table_cell" style={{float: "right"}}>Tax</span></td>
                                          <td className='right-align display_on_desktop'>Tax</td>
                                          <td  className='right-align'>
                                            {this.format_currancy(this.state.fee_for_entry.total_tax)}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="3" className='right-align'><span className="display_on_mobile mobile_table_cell" style={{float: "right"}}><strong>Total</strong></span></td>
                                          <td className='right-align display_on_desktop'><strong>Total</strong></td>
                                          <td  className='right-align'>
                                            <strong>
                                              {this.format_currancy(this.state.fee_for_entry.class_price_total + this.state.fee_for_entry.show_fees_total + this.state.fee_for_entry.total_tax)}
                                            </strong>
                                          </td>
                                        </tr>
                                      </tbody>
                                  </table>
                              </li>
                              
                              {(this.state.fee_for_entry.order_delivery_information_required) &&
                              <React.Fragment>
                              <li className='entry_people_li' style={{clear: "both"}}>
                                <p className="add-entry-p">Please enter Order Delivery information for ordered supplies.</p>
                              </li>
                              <li className='entry_people_li' style={{clear: "both", overflow: "visible"}}>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label sgl-add_entry' htmlFor="txtTrainerName">Trainer Name</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="input-box txt-field-container">
                                      <input type="text" name="txtTrainerName" id='txtTrainerName' disabled={true} className="input-height" value={this.state.order_delivery_trainer_name} onChange={evt => this.updateOrderDeliveryTrainerName(evt)} onBlur={evt => this.updateOrderDeliveryTrainerName(evt)}/>
                                    </div>
                                  </div>
                                </div>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label sgl-add_entry' htmlFor="txtArrivalDate">Arrival Date</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="input-box txt-field-container">
                                      {this.renderArrivalDatePicker()}
                                    </div>
                                  </div>
                                  <div className="txt-field-container-div">
                                      <label className='add_entry_label sgl-add_entry' htmlFor="txtArrivalTime">Arrival Time</label>
                                      <div style={{clear: "both"}}></div>
                                      <div className="input-box txt-field-container">
                                        <select id="ArrivalTime" className="input-height class_selection" value={this.state.order_delivery_arrival_time} onChange={(e) => this.updateOrderDeliveryArrivalTime(e)}>
                                            <option value="">Select Arrival Time</option>
                                            <option value="08:00:00">08:00 AM</option>
                                            <option value="09:00:00">09:00 AM</option>
                                            <option value="10:00:00">10:00 AM</option>
                                            <option value="11:00:00">11:00 AM</option>
                                            <option value="12:00:00">12:00 PM</option>
                                            <option value="13:00:00">01:00 PM</option>
                                            <option value="14:00:00">02:00 PM</option>
                                            <option value="15:00:00">03:00 PM</option>
                                            <option value="16:00:00">04:00 PM</option>
                                            <option value="17:00:00">05:00 PM</option>
                                            <option value="18:00:00">06:00 PM</option>
                                            <option value="19:00:00">07:00 PM</option>
                                            <option value="20:00:00">08:00 PM</option>
                                            <option value="21:00:00">09:00 PM</option>
                                            <option value="22:00:00">10:00 PM</option>
                                            <option value="23:00:00">11:00 PM</option>
                                            <option value="00:00:00">12:00 AM</option>
                                            <option value="01:00:00">01:00 AM</option>
                                            <option value="02:00:00">02:00 AM</option>
                                            <option value="03:00:00">03:00 AM</option>
                                            <option value="04:00:00">04:00 AM</option>
                                            <option value="05:00:00">05:00 AM</option>
                                            <option value="06:00:00">06:00 AM</option>
                                            <option value="07:00:00">07:00 AM</option>
                                        </select>
                                      </div>
                                  </div>
                                </div>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div" style={{'width': '100%'}}>
                                    <label className='add_entry_label sgl-add_entry'>Delivery Notification Phone</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className=" txt-field-container">
                                    <div style={{display:'inline-block'}}>

                                        <IntlTelInput
                                            style={{
                                            width: "100%",
                                            }}
                                            // allowDropdown={true}
                                            // dropdownContainer={document.body}
                                            // nationalMode={true}
                                            formatOnDisplay={true}
                                            // placeholder={"MOBILE"}
                                            initialCountry={"us"}
                                            // utilsScript={"https://showgroundslive.com/js/utils.js"}
                                            preferredCountries={["us", "ca"]}
                                            // onPhoneNumberChange={this.handlePhoneNumberChange}
                                            onPhoneNumberChange={this.handlePhoneChange}

                            
                                            // onBlur={handleBlur}
                                            // onKeyUp={reset}
                                            name={"phone_number_plugin_" + this.props.people_id}
                                            id={"phone_number_plugin_" + this.props.people_id} 
                                            // ref={el => this.el = el}
                                            // onChange={evt => this.updatePhone(evt.target.value)}
                                            value={this.state.order_delivery_display_phone}
                                            
                                        />
                                    </div>
                                      <input type="hidden" className="digital_signature_phonenumber" id={"phone_number_order_delivery"} name={"phone_number_order_delivery"}/>
                                      {/* <DigiSignPhone people_id={"order_delivery"} phonenumber={this.state.order_delivery_display_phone} onUpdate={this.updateOrderDeliveryPhone.bind(this)} index={'-1'}/> */}
                                      <span id={"valid_msg_order_delivery"} className="hide">
                                        <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{'paddingLeft':'5px', width:'20px', height:'16px'}} />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div style={{clear: "both"}}>
                                  <div className="txt-field-container-div">
                                    <label className='add_entry_label sgl-add_entry' htmlFor="txtBarnLocation">Barn Location</label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="input-box txt-field-container">
                                      {(this.state.barn_types.length > 0) ?
                                      <select id="txtBarnLocation" className="input-height class_selection" value={this.state.order_delivery_barn_location} onChange={(e) => this.updateOrderDeliveryBarnLocation(e)}>
                                        <option value="">Select Barn Location</option>
                                        {
                                          this.state.barn_types.map((barn_type,index) => {
                                            return (
                                                <option value={`${barn_type}`}>
                                                    {barn_type}
                                                </option>
                                            )
                                          })
                                        }
                                      </select>
                                      :
                                      <input type="text" name="txtBarnLocation" id='txtBarnLocation' className="input-height" value={this.state.order_delivery_barn_location} onChange={evt => this.updateOrderDeliveryBarnLocation(evt)} onBlur={evt => this.updateOrderDeliveryBarnLocation(evt)}/>
                                      }
                                    </div>
                                  </div>
                                  <div className="txt-field-container-div">
                                      <label className='add_entry_label sgl-add_entry' htmlFor="txtStallLocation">Stall Location</label>
                                      <div style={{clear: "both"}}></div>
                                      <div className="input-box txt-field-container">
                                      <input type="text" name="txtStallLocation" id='txtStallLocation' className="input-height" value={this.state.order_delivery_stall_location} onChange={evt => this.updateOrderDeliveryStallLocation(evt)} onBlur={evt => this.updateOrderDeliveryStallLocation(evt)}/>
                                      </div>
                                  </div>
                                </div>
                              </li>
                              </React.Fragment>
                              }

                              <li className='entry_people_li' style={{clear: "both"}}>
                                <div style={{clear: "both"}}></div>
                                {(this.state.fee_for_entry.cutoff_time_message && this.state.fee_for_entry.cutoff_time_message != "") &&
                                  <div id='cutoff_warning' className='required'>{this.state.fee_for_entry.cutoff_time_message}</div>
                                }
                                <div id='step_6_warning' className='required display_none'>{this.state.review_fees_error_msg}</div>
                              </li>
                              
                            </ul>
                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={this.review_fees_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>


                      {/* add entry step 7 - Add to other shows/series */}

                      <div id="step_7_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="7">
                          <p id="step_7_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Add to Series</p>
                          <div id='change_step_7' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                            {(this.state.series_shows.length > 0) &&
                              <a className="sgl-hover" onClick={this.changeSelection('7')}>Change</a>
                            }
                          </div>
                      </div>
                      <div id='step_7' className='add_entry_class add-entry-div display_none'>
                          <ul>    
                            <li className='entry_people_li'>
                              <p className="add-entry-p">
                                Select additional shows in {this.state.fee_for_entry.show_series_name} to add this entry.
                                {(this.state.fee_for_entry.require_all_shows && this.state.fee_for_entry.web_add_entry_text != '') &&
                                  <React.Fragment>{this.state.fee_for_entry.web_add_entry_text}</React.Fragment>
                                }
                              </p>
                              <p className="add-entry-p">{this.state.fee_for_entry.show_series_status}</p>
                            </li>
                            
                            <li className='entry_people_li'>
                              <table className="table">
                                <thead className="classes-header">                    
                                  <tr className="sgl-primary-header">
                                    <th>&nbsp;</th>
                                    <th>Upcoming Show</th>
                                    <th style={{width: "180px"}}>Suggested Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                { 
                                  this.state.series_shows.map((data, index) => {
                                    return (
                                      <tr>
                                        <td className="center-align" style={{verticalAlign: "middle"}}><input type="checkbox" show_id={data.show_id} name={"show_"+ data.show_id} id={"show_"+ data.show_id} value={data.show_id} checked={data.selected} disabled={data.has_error || this.state.fee_for_entry.require_all_shows}  onChange={e => this.checkSeriesShowChange(e)}/></td>
                                        <td style={{verticalAlign: "middle"}}><label htmlFor={"show_"+ data.show_id}>{data.show_name}</label>
                                          { (data.errors.length > 0) &&
                                            <div className="required">
                                              {data.errors
                                                .map(t => <p style={{clear: "both"}}>{t}</p>)
                                                .reduce((prev, curr) => [prev, '', curr])}
                                            </div> 
                                          }
                                        </td>
                                        <td className="center-align" style={{verticalAlign: "middle"}}>$ <input type="text" style={{width: "100px"}} show_id={data.show_id} name={"suggested_amount_show_" + data.show_id} id={"suggested_amount_show_" + data.show_id} value={data.amount} disabled={data.has_error} 
                                          onChange={evt => this.updateSeriesShowDeposit(evt)} 
                                          onBlur={this.updateSeriesShowDeposit.bind(this)}/>
                                        </td>
                                      </tr>
                                    )
                                  })
                                }

                                { (this.state.series_shows.length > 0) ?
                                  <tr>
                                      <td className="right-align" colSpan="2">Total</td>
                                      <td className="center-align">${this.state.series_shows_amount}</td>
                                  </tr>

                                  :
                                  
                                  <tr>
                                      <td colSpan="3">There are no upcoming shows in this show series.</td>
                                  </tr>
                                }
                                </tbody>
                              </table>
                            </li>
                            
                            <li className='entry_people_li'>
                              <div id='step_7_warning' className='required display_none'>{this.state.add_to_series_error_msg}</div>
                            </li>
                          </ul>
                          <div className='continue-button-div'>
                            <div className='required float_right'>
                              * Required Fields
                            </div>
                            <br className="sgl-mb-5"/>
                            <button className='sgl-button float_right' onClick={this.add_to_series_selected()}>
                              Continue
                            </button>
                          </div>
                      </div>

                      {/* add entry step 8 - Payment */}


                        <div id="step_8_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="8">
                            <p id="step_8_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Payment</p>
                            <div id='change_step_8' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('8')}>Change</a>
                            </div>
                        </div>
                        <div id='step_8' className='add_entry_class add-entry-div display_none'> 
                          <div id='step_8_A' className='add_entry_class add-entry-div display_none'>
                            <ul>    
                              <li className='entry_people_li'>
                              {
                                this.state.deposit_payment_agreement?
                                  this.state.deposit_payment_agreement
                                    .replace(/{{COMPANY_NAME}}/g, this.state.company_name)
                                    .split(/\n{2,}/)
                                    .map((paragraph, index) => <p key={index}><b>{paragraph.trim()}</b></p>)
                                :
                                <>
                                  <p>
                                    <b>NOTE: Please select a payment method to be used to secure this entry. You will be charged immediately for any deposit amount required by {this.state.company_name}. Your payment method WILL be available to {this.state.company_name} to be used to pay any balance due at the end of the show. If no alternative payment is made before the end of the show, you authorize the show office to use the payment method to pay any balances due. Automatic payments are usually made 1 day after the show completes.</b>
                                  </p>
                                </>
                              }
                              </li>
                              <li className='entry_people_li'>
                                <div style={{display:"inline-block",width: '50%'}} id="payment_method_card" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                                    <input disabled={(!this.state.can_checkout)} checked={this.state.deposit_payment_method_type === 'card' || !this.state.ach_enabled} style={{float: "left"}} type="radio" name='deposit_payment_method_type' id='deposit_payment_method_type_card' value='card' onChange={(e) => {this.onDepositPaymentMethodType(e)}}/>
                                    <label for="deposit_payment_method_type_card" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Credit Card</label>
                                </div>
                              </li>
                              {
                              (this.state.deposit_payment_method_type == 'card' || !this.state.ach_enabled)?
                              <>
                              <li className='entry_people_li'>
                                <p>
                                  You may enter a deposit amount greater than the suggested amount below:
                                </p>
                              </li>
                              <li className='entry_people_li'>
                                {/* <div id='' className=''> */}
                                <div>
                                  <label className='add_entry_label'> Suggested Amount 
                                    {(this.state.series_shows_amount > 0) && 
                                      <React.Fragment>
                                      {" for " + this.state.selected_show_details.show_name + " "}
                                      </React.Fragment>
                                    } 
                                    $ &nbsp;<em  className="required">*</em>
                                  </label>
                                </div>
                                <div style={{clear: "both"}}></div>
                                <div className="txt-field-container-div">
                                  <div className="people_selection_div txt-field-container">

                                    <input className="input-height input-text mr-15" type="text" name="deposit_amount" id='deposit_amount'  
                                      value={this.state.deposit_amount}
                                      onChange={(e) => this.updateDepositAmount(e)}   
                                      onBlur={this.setDepositAmount.bind(this)}
                                    />
                                  </div>
                                </div>
                              </li>
                                <li className="entry_people_li">
                                <div style={{clear: "both"}}></div>

                                <table className="series_payment_container" style={{minWidth: "380px"}}>
                                  
                                    {(this.state.series_shows_amount > 0) &&
                                    <tr>
                                        <td><label className="add_entry_label">Deposit for show series {this.state.fee_for_entry.show_series_name}</label></td>
                                        <td><div className="input-box"><label className="add_entry_label">{this.format_currancy(this.state.series_shows_amount)}</label></div></td>
                                    </tr>
                                    }

                                    <tr>
                                        <td><label className="add_entry_label">Credit Card Service Fee &nbsp; &nbsp;</label></td>
                                        <td><div className="input-box"><label className="add_entry_label">{this.format_currancy(this.getCreditCardServiceFee())}</label></div></td>
                                    </tr>
                                    <tr>
                                        <td><label className="add_entry_label">Total Deposit &nbsp; &nbsp;</label></td>
                                        <td><div className="input-box"><label className="add_entry_label total_deposit_amount">{this.format_currancy(this.getTotalAmountToDisplay())}</label></div></td>
                                    </tr>
                                </table>
                              </li>
                              <li className='entry_people_li'>
                                <div id='' className=''>
                                  <label className='add_entry_label'> We Accept </label>
                                  <div style={{clear: "both"}}></div>
                                  <div>
                                    {this.state.payment_options.visa &&
                                        <img className="payment_cards_icon" src={visa_image} />
                                    }
                                    {this.state.payment_options.mastercard &&
                                        <img className="payment_cards_icon" src={mastercard_image} />
                                    }
                                    {this.state.payment_options.discover &&
                                        <img className="payment_cards_icon" src={discover_image} />
                                    }
                                    {this.state.payment_options.american_express &&
                                        <img className="payment_cards_icon" src={americanexpress_image} />
                                    }
                                    {/* <img className="payment_cards_icon" src={visa_image} />
                                    <img className="payment_cards_icon" src={mastercard_image} />
                                    <img className="payment_cards_icon" src={discover_image} />
                                    <img className="payment_cards_icon" src={americanexpress_image} /> */}
                                  </div>
                                </div>
                              </li>
                              <li id="CreditCardRow" className="entry_people_li">
                                <div style={{clear: "both"}}></div>
                                <div className="txt-field-container-div">
                                    <label className='add_entry_label'> Credit Cards &nbsp;<em  className="required">*</em> </label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="people_selection_div txt-field-container">

                                        <select id="credit_card" className="input-height class_selection" value={this.state.selected_deposit_method} onChange={(e) => this.onDepositMethodSelect(e)}>
                                            <option value="-1" data-type='card'>Select credit card...</option>
                                            {
                                              this.state.payment_methods.map((payment_method,index) => {
                                                return (
                                                    <option value={`${payment_method.sgl_id}`} data-type='card'>
                                                        {payment_method.label}
                                                    </option>
                                                )
                                              })
                                            }
                                            <option value='ManageCards'>Manage Credit Cards</option>
                                        </select>
                                    </div>
                                </div>
                              </li>
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>

                                {/* <div id='' className=''> */}
                                <div className="txt-field-container-div">

                                  <label className='add_entry_label'> CVV </label>
                                  <div style={{clear: "both"}}></div>
                                  <div className="people_selection_div txt-field-container">
                                    <input className="input-height input-text mr-15" type="text"
                                    name="deposit_CVV" id='deposit_CVV' maxLength="4"
                                    value={this.state.deposit_cvv}
                                    onChange={evt => this.updateDepositCvv(evt)} onBlur={evt => this.updateDepositCvv(evt)}/>
                                  </div>
                                </div>
                              </li>
                              <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>

                                  <p>
                                      <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy.
                                  </p>
                              </li>
                              </>
                              :
                              <></>
                              }
                              <li className='entry_people_li'>
                                <div style={{display:"inline-block",width: '50%'}} id="payment_method_bank" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                                    <input disabled={!this.state.ach_enabled || !this.state.can_checkout} checked={this.state.deposit_payment_method_type === 'bank' && this.state.ach_enabled} style={{float: "left"}} type="radio" name='deposit_payment_method_type' id='deposit_payment_method_type_bank' value='bank' onChange={(e) => {this.onDepositPaymentMethodType(e)}}/>
                                    <label for="deposit_payment_method_type_bank" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Bank Account</label>
                                </div>
                              </li>
                              {
                              (this.state.deposit_payment_method_type == 'bank')?
                              <>
                              <li className='entry_people_li'>
                                <p>
                                  You may enter a deposit amount greater than the suggested amount below:
                                </p>
                              </li>
                              <li className='entry_people_li'>
                                {/* <div id='' className=''> */}
                                <div>
                                  <label className='add_entry_label'> Suggested Amount 
                                    {(this.state.series_shows_amount > 0) && 
                                      <React.Fragment>
                                      {" for " + this.state.selected_show_details.show_name + " "}
                                      </React.Fragment>
                                    } 
                                    $ &nbsp;<em  className="required">*</em>
                                  </label>
                                </div>
                                <div style={{clear: "both"}}></div>
                                <div className="txt-field-container-div">
                                  <div className="people_selection_div txt-field-container">

                                    <input className="input-height input-text mr-15" type="text" name="deposit_amount" id='deposit_amount'  
                                      value={this.state.deposit_amount}
                                      onChange={(e) => this.updateDepositAmount(e)}   
                                      onBlur={this.setDepositAmount.bind(this)}
                                    />
                                  </div>
                                </div>
                              </li>
                              <li className="entry_people_li">
                                <div style={{clear: "both"}}></div>

                                <table className="series_payment_container" style={{minWidth: "380px"}}>
                                  
                                    {(this.state.series_shows_amount > 0) &&
                                    <tr>
                                        <td><label className="add_entry_label">Deposit for show series {this.state.fee_for_entry.show_series_name}</label></td>
                                        <td><div className="input-box"><label className="add_entry_label">{this.format_currancy(this.state.series_shows_amount)}</label></div></td>
                                    </tr>
                                    }

                                    <tr>
                                        <td><label className="add_entry_label">ACH Service Fee &nbsp; &nbsp;</label></td>
                                        <td><div className="input-box"><label className="add_entry_label">{this.format_currancy(this.getACHServiceFee())}</label></div></td>
                                    </tr>
                                    <tr>
                                        <td><label className="add_entry_label">Total Deposit &nbsp; &nbsp;</label></td>
                                        <td><div className="input-box"><label className="add_entry_label total_deposit_amount">{this.format_currancy(this.getTotalAmountToDisplay())}</label></div></td>
                                    </tr>
                                </table>
                              </li>
                              <li id="CreditCardRow" className="entry_people_li">
                                <div style={{clear: "both"}}></div>
                                <div className="txt-field-container-div">
                                    <label className='add_entry_label'> Bank Accounts &nbsp;<em  className="required">*</em> </label>
                                    <div style={{clear: "both"}}></div>
                                    <div className="people_selection_div txt-field-container">

                                        <select id="credit_card" className="input-height class_selection" value={this.state.selected_deposit_method} onChange={(e) => this.onDepositMethodSelect(e)}>
                                            <option value="-1" data-type="bank">Select bank account...</option>
                                            {
                                              this.state.bank_accounts.map((bank_account,index) => {
                                                return (
                                                    <option value={`${bank_account.sgl_id}`} data-type="bank">
                                                        {bank_account.account_holder_name?`${bank_account.account_holder_name} - `:""}*{bank_account.last4} - {bank_account.bank_name}
                                                    </option>
                                                )
                                              })
                                            }
                                            <option value='AddBankAccount'>Add Bank Account</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                  {(this.state.is_open_add_bank_modal) &&
                                      <AddBankModal 
                                          is_open_add_bank_modal = {this.state.is_open_add_bank_modal}
                                          closeAddBankModal = {this.closeAddBankModal}
                                          ref = {this.AddBankElement}
                                      />
                                  }
                                </div>

                              </li>
                              <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>

                                  <p>
                                      <a className="sgl-hover" onClick={this.openViewRefundPolicyModal}>Click here</a> to view our refund policy.
                                  </p>
                              </li>
                              </>
                              :
                              <></>
                              }
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_8_A_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.payment_A_error_msg }}></div>
                                {/* <div id='step_8_A_warning' className='required display_none'>{this.state.payment_A_error_msg}</div> */}

                              </li>
                              {
                              (!this.state.can_checkout)?
                                <li className='entry_people_li'>
                                  <div style={{clear: "both"}}></div>
                                  <div className='required'>You are not authorized to make payments for this team.</div>
                                </li>
                              :
                                <></>
                              }
                            </ul>
                            <div>
                                  <AddModal
                                    isOpen={this.state.is_open_view_policy_modal}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={this.closeViewRefundPolicyModal}
                                    className="mymodal modal-width-responsive add-entry-page"
                                    overlayClassName="myoverlay"
                                    ariaHideApp={false}
                                    // style={customStyles}
                                    // contentLabel="Example Modal"
                                  >

                                    {/* <h2 ref={subtitle => this.subtitle = subtitle}>Manage Credit Cards</h2> */}
                                    {/* <div ref={subtitle => this.subtitle = subtitle} className='sgl-primary-header modal_heading'> */}
                                      <h2>Refund Policy for {this.state.company_name}</h2>
                                    {/* </div> */}
                                    <div>
                                      {(this.state.refund_policy && this.state.refund_policy!='')?
                                        <p>{this.state.refund_policy}</p>
                                      :
                                        <p>
                                          {this.state.company_name} has not provided a refund policy at this time.  Please refer to the Prize List or other event documentation for the refund policy in effect for this transaction.
                                        </p>
                                      }
                                    </div>
                                    <div className='continue-button-div'>
                                      <br/>
                                      <button className='sgl-button float_right horse_search-button' onClick={this.closeViewRefundPolicyModal}>
                                        Close
                                      </button>
                                      
                                    </div>
                                  </AddModal>
                            </div>
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button className='sgl-button float_right' onClick={this.payment_A_selected()}>
                                Continue
                              </button>
                            </div>
                          </div>
                          <div id='step_8_B' className='add_entry_class add-entry-div display_none'>  
                            <ul>    
                              <li className='entry_people_li'>
                              {
                                this.state.securing_entry_agreement?
                                  this.state.securing_entry_agreement
                                    .replace(/{{COMPANY_NAME}}/g, this.state.company_name)
                                    .split(/\n{2,}/)
                                    .map((paragraph, index) => <p key={index}>{paragraph.trim()}</p>)
                                :
                                <>
                                  <p>
                                    I understand that this entry will be immediately entered into the show and agree to pay for all fees associated with this entry.  I further understand that activities during the course of the show can change the final cost of this entry.  I agree to pay for these fees by the end of business on the final day of the show. Please refer to the show management companies policy regarding refunds.
                                  </p>
                                </>
                              }
                              </li>
                              <li className={["entry_people_li", (this.state.selected_show_details.web_require_credit_card_on_file) ? '' : 'display_none'].join(' ')}>
                                {
                                  this.state.require_payment_method_agreement?
                                    this.state.require_payment_method_agreement
                                      .replace(/{{COMPANY_NAME}}/g, this.state.company_name)
                                      .split(/\n{2,}/)
                                      .map((paragraph, index) => <p key={index}>{paragraph.trim()}</p>)
                                  :
                                  <>
                                    <p>
                                      I authorize {this.state.company_name} to use this payment method to settle the bills for these entries, should the account not be settled by the end of the last day of each show.
                                    </p>
                                  </>
                                }
                              </li>
                              {
                              (this.state.selected_show_details.web_require_credit_card_on_file)?
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div style={{display:"inline-block",width: '50%'}} id="selected_payment_method_card" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                                    <input checked={this.state.selected_payment_method_type === 'card' || !this.state.ach_enabled} style={{float: "left"}} type="radio" name='selected_payment_method_type' id='selected_payment_method_type_card' value='card' onChange={(e) => {this.onSelectedPaymentMethodType(e)}}/>
                                    <label for="selected_payment_method_type_card" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Credit Card</label>
                                </div>
                              </li>
                              :<></>
                              }
                              {
                              (this.state.selected_payment_method_type == 'card' || !this.state.ach_enabled)?
                              <>
                              <li id="CreditCardRow" className={["entry_people_li", (this.state.selected_show_details.web_require_credit_card_on_file) ? '' : 'display_none'].join(' ')}>
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                  <label className='add_entry_label'> Credit Cards &nbsp;<em  className="required">*</em> </label>
                                  <div style={{clear: "both"}}></div>
                                    {/* <div className="input-box"> */}
                                        <select id="credit_card" className="input-height class_selection" value={this.state.selected_payment_method} onChange={(e) => this.onPaymentMethodSelect(e)}>
                                            <option value="-1">Select credit card...</option>
                                            {
                                              this.state.payment_methods.map((payment_method,index) => {
                                              return (
                                                  <option value={`${payment_method.sgl_id}`} data-type='card'>
                                                      {payment_method.label}
                                                  </option>
                                              )
                                              })
                                            }
                                            <option value='ManageCards'>Manage Credit Cards</option>
                                        </select>
                                    {/* </div> */}
                                </div>
                                <div>
                                  {(this.state.is_open_select_card_modal) &&
                                      <ManageCards 
                                          payment_methods = {this.state.payment_methods} 
                                          check_card_email_phone_info = {this.state.check_card_email_phone_info} 
                                          check_address_info = {this.state.check_address_info}
                                          is_open_manage_card_modal = {this.state.is_open_select_card_modal}
                                          closeManageCardModal = {this.closeSelectCardModal}
                                          getPaymentMethods = {this.getPaymentMethods}
                                          ref = {this.ManageCardsElement}
                                          can_checkout = {this.state.can_checkout}
                                          team_id = {this.context.currentTeamId != 'personal'?this.context.currentTeamId:0}
                                      />
                                  }
                                </div>
                                <div style={{clear: "both"}}></div>
                              </li>
                              </>
                              :
                              <></>
                              }
                              {
                              (this.state.selected_show_details.web_require_credit_card_on_file)?
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div style={{display:"inline-block",width: '50%'}} id="payment_method_bank" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options'>
                                    <input disabled={!this.state.ach_enabled} checked={this.state.selected_payment_method_type === 'bank' && this.state.ach_enabled } style={{float: "left"}} type="radio" name='selected_payment_method_type' id='selected_payment_method_type_bank' value='bank' onChange={(e) => {this.onSelectedPaymentMethodType(e)}}/>
                                    <label for="selected_payment_method_type_bank" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Bank Account</label>
                                </div>
                              </li>
                              :
                              <></>
                              }
                              {
                              (this.state.selected_payment_method_type == 'bank')?
                              <>
                              <li id="CreditCardRow" className={["entry_people_li", (this.state.selected_show_details.web_require_credit_card_on_file) ? '' : 'display_none'].join(' ')}>
                                <div style={{clear: "both"}}></div>
                                <div className="people_selection_div">
                                  <label className='add_entry_label'> Bank Accounts &nbsp;<em  className="required">*</em> </label>
                                  <div style={{clear: "both"}}></div>
                                    {/* <div className="input-box"> */}
                                        <select id="credit_card" className="input-height class_selection" value={this.state.selected_payment_method} onChange={(e) => this.onPaymentMethodSelect(e)}>
                                            <option value="-1">Select bank account...</option>
                                            {
                                              this.state.bank_accounts.map((bank_account,index) => {
                                                return (
                                                    <option value={`${bank_account.sgl_id}`} data-type="bank">
                                                        {bank_account.account_holder_name?`${bank_account.account_holder_name} - `:""}*{bank_account.last4} - {bank_account.bank_name}
                                                    </option>
                                                )
                                              })
                                            }
                                            <option value='AddBankAccount'>Add Bank Account</option>
                                        </select>
                                    {/* </div> */}
                                </div>
                                <div>
                                  {(this.state.is_open_add_bank_modal) &&
                                      <AddBankModal 
                                          is_open_add_bank_modal = {this.state.is_open_add_bank_modal}
                                          closeAddBankModal = {this.closeAddBankModal}
                                          ref = {this.AddBankElement}
                                      />
                                  }
                                </div>
                                <div style={{clear: "both"}}></div>
                              </li>
                              </>
                              :<></>
                              }

                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_8_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.payment_error_msg }}></div>
                              </li>

                              {/* Platform Fee */}
                              {
                                !this.state.exhibitor_billing_enabled_for_show ? null :
                                !this.state.selected_responsible.useCurrentUserForPlaformFee ?
                                <li className='entry_people_li'>
                                  <label className='add_entry_label' style={{fontSize: '15px'}}> SGL Platform Fee </label>
                                  <p>
                                    {`I understand that a platform fee will be charged by ShowGrounds Live. I agree that the Responsible Party’s payment method on file will be used for this fee.`}
                                  </p>
                                  <div className="people_selection_div">
                                  <div style={{clear: "both"}}></div>
                                  <select id="credit_card" disabled={true} className="input-height class_selection">
                                      {
                                        <option data-type='card'>
                                            {this.state.selected_responsible.rpDefaultPaymentMethodDesc}
                                        </option>
                                      }
                                  </select>
                                  <div style={{marginBottom: '10px'}}></div>
                                  </div>
                                </li>
                                : 
                                <li className='entry_people_li'>
                                  <label className='add_entry_label' style={{fontSize: '15px'}}> SGL Platform Fee </label>
                                  <p>
                                    {this.state.selected_responsible.hasUnsignedTOS && this.state.selected_responsible.hasDefaultPayMethod
                                    ? "I understand that the Responsible Party has not signed the required agreement. I further understand that a payment method must be selected in order to complete this entry, and that the selected payment method will be charged the platform fee by ShowGrounds Live."
                                    : !this.state.selected_responsible.hasUnsignedTOS && !this.state.selected_responsible.hasDefaultPayMethod
                                    ? "I understand that the Responsible Party does not have a payment method on file. I further understand that a payment method must be selected in order to complete this entry, and that the selected payment method will be charged the platform fee by ShowGrounds Live."
                                    : this.state.selected_responsible.hasUnsignedTOS && !this.state.selected_responsible.hasDefaultPayMethod
                                    ? "I understand that the Responsible Party has not signed the required agreement and does not have a payment method on file. I further understand that a payment method must be selected in order to complete this entry, and that the selected payment method will be charged the platform fee by ShowGrounds Live."
                                    : this.state.selected_responsible.hasDefaultPayMethod && !this.state.selected_responsible.hasValidDefaultPayMethod
                                    ? "I understand that the Responsible Party’s default payment method is not valid. A valid payment method must be provided in order to complete this entry, and the selected payment method will be charged the platform fee by ShowGrounds Live."
                                    : "I understand that a platform fee will be charged by ShowGrounds Live. I agree that the Responsible Party’s payment method on file will be used for this fee."}
                                  </p>
                                  <div className="people_selection_div">
                                  <label className='add_entry_label'> Credit Cards For Platform Fee &nbsp;<em  className="required">*</em> </label>
                                  <div style={{clear: "both"}}></div>
                                  <select id="credit_card" className="input-height class_selection" value={this.state.platform_fee_payment_method} onChange={(e) => this.onPlatformFeePaymentMethodSelect(e)}>
                                      <option value="-1">Select credit card...</option>
                                      {
                                        this.state.payment_methods.map((payment_method,index) => {
                                        return (
                                            <option value={`${payment_method.sgl_id}`} data-type='card'>
                                                {payment_method.label}
                                            </option>
                                        )
                                        })
                                      }
                                      <option value='ManageCards'>Manage Credit Cards</option>
                                  </select>
                                  <div style={{marginBottom: '10px'}}></div>
                                  </div>
                                </li>
                              }
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <input type="checkbox" name="checkAgree" id="checkAgree" checked={this.state.payment_agree} onChange={e => this.paymentAgreeChange(e)}/>
                                <label htmlFor='checkAgree'>  I agree</label>
                              </li>
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_platform_fee_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.payment_error_msg }}></div>
                              </li>
                            
                            </ul>

                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <button id="secure-payment-button" className='sgl-button float_right' onClick={this.payment_selected()}>
                                Continue
                              </button>
                              <span id="validate-platform-fee" className='display_none float_right'><img src={indicator_icon} /></span>
                            </div>
                          
                          </div>
                        </div>

                        <div>
                          {(this.state.is_open_select_card_modal) &&
                              <ManageCards 
                                  payment_methods = {this.state.payment_methods} 
                                  check_card_email_phone_info = {this.state.check_card_email_phone_info} 
                                  check_address_info = {this.state.check_address_info}
                                  is_open_manage_card_modal = {this.state.is_open_select_card_modal}
                                  closeManageCardModal = {this.closeSelectCardModal}
                                  getPaymentMethods = {this.getPaymentMethods}
                                  ref = {this.ManageCardsElement}
                                  can_checkout = {this.state.can_checkout}
                                  team_id = {this.context.currentTeamId != 'personal'?this.context.currentTeamId:0}
                              />
                          }
                        </div>


                      {/* add entry step 9 - Digital signature verification */}



                        <div id="step_9_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="9">
                            <p id="step_9_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Digital signature verification</p>
                            <div id='change_step_9' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('9')}>Change</a>
                            </div>
                        </div>
                        <div id='step_9' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p className="add-entry-p">
                                  Please enter mobile numbers of People connected to entry to sign the waiver online.
                                </p>
                              </li>

                              <li id="SignatureRow" className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <table className="table table-striped table-hover">
                                    <thead className="classes-header">                    
                                        <tr className="sgl-primary-header">
                                          <th>Name</th>
                                          <th >Mobile Number</th>
                                          <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    { (this.state.digital_sign_people_list.length > 0) &&
                                          this.state.digital_sign_people_list.map((data, index) => {
                                            let phoneNumber = this.getFormattedPhoneNumber(data.phone, index)
                                            return (
                                              <tr className="sgl-anchor">
                                                <td colSpan="">{data.fl_name} ({this.getDataRoles(data.roles, data.people_id)})</td>
                                                {data.phone_number_verified && 
                                                <td className=''>
                                                  {data.phone}
                                                </td>
                                                }
                                                {!data.phone_number_verified && 
                                                <td className=''>
                                                  <input 
                                                    type="hidden" 
                                                    className="digital_signature_phonenumber" 
                                                    id={"phone_number_" + data.people_id} 
                                                    name={"phone_number_" + data.people_id} 
                                                    // value={data.phone}
                                                    // onChange={evt => this.updateDigitalSignaturePhone(evt, index)}
                                                  />
                                                  <DigiSignPhone people_id={data.people_id} phonenumber={phoneNumber} onUpdate={this.updateDigitalSignaturePhone.bind(this)} index={index}/>
                                                  <span id={"valid_msg_" + data.people_id} className="hide">
                                                    <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{'paddingLeft':'5px', width:'20px', height:'16px'}} />
                                                  </span>

                                                </td>
                                                }

                                                <td>
                                                  {(!data.roles.includes('Trainer')) && !this.state.disallow_agent_signature && 
                                                    <div className='agent_will_sign'>
                                                    <input type="checkbox" name={"agent_will_sign_" + data.people_id} id={"agent_will_sign_" + data.people_id}/>
                                                    <label htmlFor={'agent_will_sign_' + data.people_id}>&nbsp;{this.state.governing_organization === 'EC'?'Coach ':'Trainer '}will Sign</label>
                                                  </div>
                                                  }
                                                </td>
                                              </tr>
                                            )
                                          })
                                        }
                                    </tbody>
                                </table>
                                <div style={{clear: "both"}}></div>
                              </li>
                              <li id="GuardianRow" className='entry_people_li'>

                                {/* <div className=''>
                                  <label className="sgl-label-border">Select parent/guardian</label>
                                  <div className='people_selection_div'>
                                    <select id="guardian" className="input-height people_selection" 
                                      value={this.state.selected_guardian.people_id}
                                      onChange={(e) => this.onGuardianSelect(e)}>
                                            <option value="-4">Select...</option>
                                            {
                                                this.state.selected_distinct_people_list.map((person,index) => {
                                                return (
                                                    <option value={`${person.people_id}`}>
                                                        {person.lf_name}  {person.people_id === this.state.logged_in_people_id? '(ME)' : ''}
                                                    </option>
                                                )
                                                })
                                            }
                                    </select>
                                  </div>
                                </div> */}
                                <div style={{clear: "both"}}></div>
                                <div id='step_9_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.digisign_error_msg }}></div>

                              </li>
                              <li className='entry_people_li'>
                                <div style={{clear: "both"}}></div>
                                <div id='step_10_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.create_entry_error_msg }}></div>
                              </li>

                            
                            </ul>

                            {/* <hr/> */}
                            <div className='continue-button-div'>
                              <div className='required float_right'>
                                * Required Fields
                              </div>
                              <br className="sgl-mb-5"/>
                              <span id="create-entry-please-wait" className='display_none float_right'><img src={indicator_icon} /></span>
                              <button id='continue-signature' className='sgl-button float_right' onClick={this.signature_selected()}>
                                Continue
                              </button>
                            </div>
                        </div>

                      {/*Step 12 Ditital Envelopes/Tax Information*/}
                      {this.state.acquire_add_entry_tax_info ?
                      <div id="step_12_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="12">
                        <p id="step_12_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Electronic Documents</p>
                        <div id='change_step_12' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                          <a className="sgl-hover" onClick={this.changeSelection('12')}>Change</a>
                        </div>
                      </div>
                      :
                      <></>
                      }

                      <div id='step_12' className='add_entry_class add-entry-div display_none'>

                        <ul>
                          <li className='entry_people_li'>
                            <p className="add-entry-p">
                              Please follow the link to complete required documentation:
                            </p>
                          </li>

                          <li id="SignatureRow" className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                            <table className="table table-striped table-hover">
                              <thead className="classes-header">
                              <tr className="sgl-primary-header">
                                <th>Name</th>
                                <th >Form Link</th>
                              </tr>
                              </thead>
                              <tbody>
                              {!this.state.formtype_change_loader && this.state.nextform_urls && this.state.nextform_urls.map((item, index)=>{return (
                                  <>
                                    <tr>
                                      <td>{item.entity_name} ({item.entity_roles.join(', ')})</td>
                                      <td>
                                      {item.documents[0]?.obtained ?
                                        <>
                                        <span>
                                          {item.documents[0]?.alreadySubmittedFormType} Obtained
                                          <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{'paddingLeft':'5px', width:'20px', height:'16px', 'vertical-align': 'baseline'}} />
                                        </span>
                                        </>
                                      :
                                      <>
                                        {/* Change tax form type */}
                                        <div id={"nextform-link-" + index}>
                                          <a href={item.documents[0]?.url} target="_blank">{item.documents[0]?.documentType}</a>
                                          <a className="sgl-hover ml-1" title="Change Form Type" onClick={() => this.showAvailableForms(index)}>
                                            Change
                                          </a> 
                                        </div>
                                        <div id={"change-form-type-" + index} className="display_none">
                                          <select id="rider" className="input-height people_selection mb-1" onChange={(e) => this.handleElectronicFormChange(e, index, item)}>
                                              <option value="-1">Select...</option>
                                              {
                                                  item.availableTaxForms[0].map((form, index) => {
                                                    return (
                                                      <option key={form.sgl_id} value={`${form.sgl_id}`}>
                                                          {form.form_type}
                                                      </option>
                                                  )
                                                  })
                                              }
                                          </select>
                                          <a className="sgl-hover" title="Select form type" onClick={() => this.updateElectronicFormUrl(index)}>
                                            Select
                                          </a>
                                          <a className="sgl-hover ml-1" title="Cancel change" onClick={() => this.cancelFormChange(index)}>
                                            Cancel
                                          </a> 
                                        </div>
                                      </>
                                      }
                                      </td>
                                    </tr>
                                  </>
                              )})}
                              </tbody>
                            </table>
                            <div style={{clear: "both"}}></div>
                          </li>
                          <li className='entry_people_li'>
                            <div style={{clear: "both"}}></div>
                              <div id='electronic_documents_warning' className='required display_none' dangerouslySetInnerHTML={{ __html: this.state.nextform_error_msg }}></div>
                          </li>
                        </ul>

                        {/* <hr/> */}
                        <div className='continue-button-div'>
                          <br className="sgl-mb-5"/>
                          <span id="save-electronic-documents-please-wait" className='display_none float_right'><img src={indicator_icon} /></span>
                          <button id='continue-electronic-documents' className='sgl-button float_right' onClick={this.saveDigitalEnvelope()}>
                            Continue
                          </button>
                        </div>
                      </div>

                      {/* add entry step 10 - Thank you */}
                        <div id="step_10_container" className='sgl-primary-header className-details, primary-header className-details-header add_entry_options' rownum="10">
                            <p id="step_10_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Thank you</p>
                            <div id='change_step_10' className='sgl-no-text-shadow sgl-arrow ring-arrow display_none change_selection'>
                                <a className="sgl-hover" onClick={this.changeSelection('10')}>Change</a>
                            </div>
                        </div>
                        <div id='step_10' className='add_entry_class add-entry-div display_none'> 
                            
                            <ul>    
                              <li className='entry_people_li'>
                                <p>
                                  Thank you! Your request for entry has been submitted. Your entry number will be provided by the show office.
                                </p>
                              </li>
                            </ul>
                        </div>
                    </div>


                </div>
              </div>
              }
              <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
            </div>
        )
    }
  }
  AddEntry.contextType = SglContext;
  export default AddEntry;